webpackJsonp([1],[
/* 0 */,
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var _class = function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, _class);

        this.apiToken = '$2y$10$Q8DXfG009VhLIFQ.jVOUc.PQP9veEMmsqkthzMdi8xIFTCRkf2AEm';
        this.siteImage = "https://cityneeds.ng/cnpro.jpg";
        this.mainSiteUrl = 'https://cityneeds.ng';
        this.siteUrl = "https://forum.survey.cityneeds.ng/";

        this.siteUrl = "https://cityneeds.ng/";

        this.baseURL = 'https://prep.dev.cityneeds.ng/koko/v1/api/';
        this.imageURL = 'https://prep.dev.cityneeds.ng/koko/v1/api/server/x52rs6c/pr.im.ti.ny.8/';

        this.pageIntv = 5;this.pageCnproIntv = 12;

        this.koUrl = this.baseURL + 'prx/';

        this.paga_apiBaseUrl = this.koUrl + 'https://www.mypaga.com/paga-webservices/business-rest/secured/';


        this.paga_principal = 'FFEEF6C1-18C6-40C4-AD90-B9FED2CE9C9F';
        this.paga_password = 'tP8@uv%dQHguBXR';
        this.paga_apiKey = 'bb9363108ed947c4932b42cbd0068ff291133e0a5ee04ac3afb3f4e365fa0de7aec14f90a5cb463f95f41587390efc3a50f40ce0d2a74acb9784007a21a202c9';

        this.paystack_public_test = '';
        this.paystack_secret_test = '';
        this.paystack_public_live = '';
        this.paystack_secret_live = '';
        this.ravepay_public_test = 'FLWPUBK-8b636e40e721ae65285c678950808ef5-X';
        this.ravepay_secret_test = '';
        this.ravepay_public_live_remita = 'FLWPUBK-7bfea41df783f28ad7c71d9925a1bc57-X';
        this.ravepay_secret_live_remita = 'FLWSECK-a235ea72184ac4d7c07ea2e356682cd7-X';
        this.ravepay_public_live_paga = 'FLWPUBK-9a2d236c853b6f2e2c7a5c0888456977-X';
        this.ravepay_secret_live_paga = 'FLWSECK-e548cb5dc39ca101d6eb143a7378cd17-X';

        this.service_amt_out_of_range_msg = "Amount to purchase is out of range";
        this.service_purchase_failed = "Payment Failed";
        this.service_purchase_success = "Payment was Successful";
        this.service_payment_successful = "Payment unsuccessfull. please try again or contact us";
        this.service_payment_failed = "Payment was not processed";
        this.service_payment_circle_fully_successful = "Payment was Successful";
        this.service_payment_circle_not_fully_successful = "Payment Update Failed";
        this.thisYear = new Date().getFullYear();
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(_class, [{
        key: 'getStates',
        value: function getStates(context) {
            return context.$http.get(this.baseURL + 'states');
        }
    }, {
        key: 'getStateName',
        value: function getStateName(context, id) {
            return context.$http.get(this.baseURL + 'states/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getCityName',
        value: function getCityName(context, id) {
            return context.$http.get(this.baseURL + 'cities/name/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getCities',
        value: function getCities(context, id) {
            return context.$http.get(this.baseURL + 'cities/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getUserID',
        value: function getUserID(context, id) {
            return context.$http.post(this.baseURL + 'auth/sessions/id', id);
        }
    }, {
        key: 'getDataItem',
        value: function getDataItem(context, data, id) {
            return context.$http.post(this.baseURL + 'auth/data/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getNotifications',
        value: function getNotifications(context, id) {
            return context.$http.get(this.baseURL + 'notifications/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'uploadDataPhoto',
        value: function uploadDataPhoto(context, data) {
            return context.$http.post(this.baseURL + '/uploads', data, {
                headers: {
                    'Api-Token': this.apiToken,
                    'Content-Type': 'multipart/form-data'
                }
            });
        }
    }, {
        key: 'sendServicesEmails',
        value: function sendServicesEmails(context, data) {
            return context.$http.post(this.baseURL + 'settings/emails', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'regUser',
        value: function regUser(context, data) {
            return context.$http.post(this.baseURL + 'users', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'loginUser',
        value: function loginUser(context, data) {
            return context.$http.post(this.baseURL + 'users/login', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'sessionGuard',
        value: function sessionGuard(context, data) {
            return context.$http.post(this.baseURL + 'auth/sessions', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'prepareCNuserGuestID',
        value: function prepareCNuserGuestID(context) {
            return context.$http.get(this.baseURL + 'users/guests', {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'verifyEmail',
        value: function verifyEmail(context, data) {
            return context.$http.post(this.baseURL + 'auth/verify/email', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'verifyResetToken',
        value: function verifyResetToken(context, token) {
            return context.$http.post(this.baseURL + 'auth/verify/reset/token/' + token, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'forgotPassword',
        value: function forgotPassword(context, data) {
            return context.$http.post(this.baseURL + 'auth/password/forgot', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'resetForgotPassword',
        value: function resetForgotPassword(context, data) {
            return context.$http.post(this.baseURL + 'auth/password/forgot/reset', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'resetPassword',
        value: function resetPassword(context, data) {
            return context.$http.post(this.baseURL + 'auth/password/reset', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'resetEmail',
        value: function resetEmail(context, data) {
            return context.$http.post(this.baseURL + 'auth/email/reset', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'activateEmail',
        value: function activateEmail(context, data) {
            return context.$http.post(this.baseURL + 'auth/verify/email', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getUser',
        value: function getUser(context, id) {
            return context.$http.get(this.baseURL + 'users/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'editProfile',
        value: function editProfile(context, data, id) {
            return context.$http.put(this.baseURL + 'users/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'setUserPaymentDetails',
        value: function setUserPaymentDetails(context, data) {
            return context.$http.post(this.baseURL + 'users/payments', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getBusinessCategories',
        value: function getBusinessCategories(context) {
            return context.$http.get(this.baseURL + 'businesscategories', {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getAllBusinesses',
        value: function getAllBusinesses(context, id) {
            return context.$http.get(this.baseURL + 'businesses', {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getSearchBusinesses',
        value: function getSearchBusinesses(context, offset, items) {
            return context.$http.get(this.baseURL + 'businesses/pages/' + offset + '/' + items, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getBusinesses',
        value: function getBusinesses(context, id) {
            return context.$http.get(this.baseURL + 'businesses/user/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getBusiness',
        value: function getBusiness(context, id) {
            return context.$http.get(this.baseURL + 'businesses/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getBusinessWorkingHours',
        value: function getBusinessWorkingHours(context, id) {
            return context.$http.get(this.baseURL + 'businesses/workinghours/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'addBusiness',
        value: function addBusiness(context, data) {
            return context.$http.post(this.baseURL + 'businesses', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'editBusiness',
        value: function editBusiness(context, id, data) {
            return context.$http.put(this.baseURL + 'businesses/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'setWorkingHours',
        value: function setWorkingHours(context, id, data) {
            var datab = [];
            datab = ['t', 'u', 'y'];
            return context.$http.put(this.baseURL + 'businesses/workinghours/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'deleteBusiness',
        value: function deleteBusiness(context, id) {
            return context.$http.delete(this.baseURL + 'businesses/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'searchBusinesses',
        value: function searchBusinesses(context, data, offset, items) {
            return context.$http.post(this.baseURL + 'businesses/search/' + offset + '/' + items, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'searchBusiness',
        value: function searchBusiness(context, id) {
            return context.$http.get(this.baseURL + 'businesses/business/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'citisaveBusinesses',
        value: function citisaveBusinesses(context, data) {
            return context.$http.post(this.baseURL + 'businesses/citisave', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getCnproParentCategories',
        value: function getCnproParentCategories(context) {
            return context.$http.get(this.baseURL + 'cnprocategories/parent', {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getCnproCategories',
        value: function getCnproCategories(context, id) {
            return context.$http.get(this.baseURL + 'cnprocategories/sub/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getAllCnpros',
        value: function getAllCnpros(context) {
            return context.$http.get(this.baseURL + 'cnpros', {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getSearchCnpros',
        value: function getSearchCnpros(context, offset, items) {
            return context.$http.get(this.baseURL + 'cnpros/pages/' + offset + '/' + items, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getCnpros',
        value: function getCnpros(context, id) {
            return context.$http.get(this.baseURL + 'cnpros/user/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getCnpro',
        value: function getCnpro(context, id) {
            return context.$http.get(this.baseURL + 'cnpros/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'searchCnpro',
        value: function searchCnpro(context, search) {
            return context.$http.get(this.baseURL + 'cnpros/cnpro/search/' + search, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'addCnpro',
        value: function addCnpro(context, data) {
            return context.$http.post(this.baseURL + 'cnpros', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'addCnproPhoto',
        value: function addCnproPhoto(context, data) {
            return context.$http.post(this.baseURL + 'cnpros/uploads', data, {
                headers: {
                    'Api-Token': this.apiToken,
                    'Content-Type': 'multipart/form-data'

                }
            });
        }
    }, {
        key: 'editCnpro',
        value: function editCnpro(context, data, id) {
            return context.$http.put(this.baseURL + 'cnpros/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'deleteCnpro',
        value: function deleteCnpro(context, id) {
            return context.$http.delete(this.baseURL + 'cnpros/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'searchCnpros',
        value: function searchCnpros(context, data, offset, items) {
            return context.$http.post(this.baseURL + 'cnpros/search/' + offset + '/' + items, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'findCnpro',
        value: function findCnpro(context, data) {
            return context.$http.post(this.baseURL + 'cnpros/findrequests', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getSavedListings',
        value: function getSavedListings(context, id) {
            return context.$http.get(this.baseURL + 'citisaves/users/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getSavedListing',
        value: function getSavedListing(context, id) {
            return context.$http.get(this.baseURL + 'citisaves/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'saveListing',
        value: function saveListing(context, data) {
            return context.$http.post(this.baseURL + 'citisaves', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getServiceCharge',
        value: function getServiceCharge(context) {
            return context.$http.get(this.baseURL + 'contracts/services/charges', {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getUserContracts',
        value: function getUserContracts(context, id) {
            return context.$http.get(this.baseURL + 'contracts/user/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getCnproContracts',
        value: function getCnproContracts(context, id) {
            return context.$http.get(this.baseURL + 'contracts/cnpro/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getContract',
        value: function getContract(context, id) {
            return context.$http.get(this.baseURL + 'contracts/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'checkCnproContractRequest',
        value: function checkCnproContractRequest(context, data) {
            return context.$http.post(this.baseURL + 'contracts/checks', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'requestQuote',
        value: function requestQuote(context, data) {
            return context.$http.post(this.baseURL + 'contracts', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'replyQuote',
        value: function replyQuote(context, id, data) {
            return context.$http.post(this.baseURL + 'contracts/reply', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'setQuote',
        value: function setQuote(context, id, data) {
            return context.$http.put(this.baseURL + 'contracts/set/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'updateQuote',
        value: function updateQuote(context, id, data) {
            return context.$http.put(this.baseURL + 'contracts/update/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'acceptQuote',
        value: function acceptQuote(context, id, data) {
            return context.$http.put(this.baseURL + 'contracts/accept/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'rejectQuote',
        value: function rejectQuote(context, id, data) {
            return context.$http.put(this.baseURL + 'contracts/reject/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'confirmContractCnpro',
        value: function confirmContractCnpro(context, id, data) {
            return context.$http.put(this.baseURL + 'contracts/confirm/cnpro/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'confirmContract',
        value: function confirmContract(context, id, data) {
            return context.$http.put(this.baseURL + 'contracts/confirm/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'closeContract',
        value: function closeContract(context, id, data) {
            return context.$http.put(this.baseURL + 'contracts/close/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'updatePayment',
        value: function updatePayment(context, id, data) {
            return context.$http.put(this.baseURL + 'contracts/payments/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getContractComplaints',
        value: function getContractComplaints(context, id) {
            return context.$http.get(this.baseURL + 'contracts/complaints/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'makeComplaint',
        value: function makeComplaint(context, id, data) {
            return context.$http.post(this.baseURL + 'contracts/complaints', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'resolveComplaint',
        value: function resolveComplaint(context, id, data) {
            return context.$http.put(this.baseURL + 'contracts/complaints/resolve/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getAllReviews',
        value: function getAllReviews(context) {
            return context.$http.get(this.baseURL + 'reviews', {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'submitReview',
        value: function submitReview(context, data) {
            return context.$http.post(this.baseURL + 'reviews', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'submitRating',
        value: function submitRating(context, data) {
            return context.$http.post(this.baseURL + 'ratings', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getAllForums',
        value: function getAllForums(context) {
            return context.$http.get(this.baseURL + 'forums', {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getForums',
        value: function getForums(context, category, offset, items) {
            return context.$http.get(this.baseURL + 'forums/' + category + '/' + offset + '/' + items, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'searchForums',
        value: function searchForums(context, id) {
            return context.$http.get(this.baseURL + 'forums/search/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'postThread',
        value: function postThread(context, data) {
            return context.$http.post(this.baseURL + 'forums', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'editThread',
        value: function editThread(context, id, data) {
            return context.$http.put(this.baseURL + 'forums/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getUserThreads',
        value: function getUserThreads(context, id) {
            return context.$http.get(this.baseURL + 'forums/users/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getThread',
        value: function getThread(context, data) {
            return context.$http.post(this.baseURL + 'forums/url', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'forumComments',
        value: function forumComments(context, id) {
            return context.$http.get(this.baseURL + 'forums/comments/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'addThreadComment',
        value: function addThreadComment(context, data) {
            return context.$http.post(this.baseURL + 'forums/comments', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'editThreadComment',
        value: function editThreadComment(context, id, data) {
            return context.$http.put(this.baseURL + 'forums/comments/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'canEditData',
        value: function canEditData(context, data) {
            return context.$http.post(this.baseURL + 'settings/ownership', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'survey',
        value: function survey(context, data) {
            return context.$http.post(this.baseURL + 'cnsurveys', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'addSurveyQuestion',
        value: function addSurveyQuestion(context, data) {
            return context.$http.post(this.baseURL + 'cnsurveys/questions', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'editSurvey',
        value: function editSurvey(context, data, id) {
            return context.$http.put(this.baseURL + 'cnsurveys/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'editSurveyQuestion',
        value: function editSurveyQuestion(context, data, id) {
            return context.$http.put(this.baseURL + 'cnsurveys/questions/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'userSurveys',
        value: function userSurveys(context, id) {
            return context.$http.get(this.baseURL + 'cnsurveys/users/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getUserSurveys',
        value: function getUserSurveys(context, id) {
            return context.$http.get(this.baseURL + 'cnsurveys/users/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'allSurveys',
        value: function allSurveys(context) {
            return context.$http.get(this.baseURL + 'cnsurveys', {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getAllSurveys',
        value: function getAllSurveys(context, offset, items) {
            return context.$http.get(this.baseURL + 'cnsurveys/pages/' + offset + '/' + items, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getSurvey',
        value: function getSurvey(context, data) {
            return context.$http.post(this.baseURL + 'cnsurveys/url', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'surveyAns',
        value: function surveyAns(context, data) {
            return context.$http.post(this.baseURL + 'cnsurveys/answers', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'deleteSurvey',
        value: function deleteSurvey(context, id) {
            return context.$http.delete(this.baseURL + 'cnsurveys/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'deleteSurveyQuestion',
        value: function deleteSurveyQuestion(context, id) {
            return context.$http.delete(this.baseURL + 'cnsurveys/questions/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'updateCnsurveysPayments',
        value: function updateCnsurveysPayments(context, id, data) {
            return context.$http.put(this.baseURL + 'cnsurveys/payments/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getPaymentPlans',
        value: function getPaymentPlans(context) {
            return context.$http.get(this.baseURL + 'plans', {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'setPaymentPlan',
        value: function setPaymentPlan(context, data) {
            return context.$http.post(this.baseURL + 'plans/users', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'updatePaymentPlan',
        value: function updatePaymentPlan(context, id, data) {
            return context.$http.put(this.baseURL + 'plans/payments/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getMonies',
        value: function getMonies(context, id) {
            return context.$http.get(this.baseURL + 'monies/users/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getMoney',
        value: function getMoney(context, id) {
            return context.$http.get(this.baseURL + 'monies/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'updateMoniesPaid',
        value: function updateMoniesPaid(context, id, data) {
            return context.$http.put(this.baseURL + 'monies/payments/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getBanking',
        value: function getBanking(context, id) {
            return context.$http.get(this.baseURL + 'monies/banks/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'setBanking',
        value: function setBanking(context, data) {
            return context.$http.post(this.baseURL + 'monies/banks', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'updateBankSetting',
        value: function updateBankSetting(context, id, data) {
            return context.$http.put(this.baseURL + 'monies/banks/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getWalletProcessingCharges',
        value: function getWalletProcessingCharges(context, id) {
            return context.$http.get(this.baseURL + 'cnwallet/charges', {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getWalletProcessingChargesRF',
        value: function getWalletProcessingChargesRF(context) {
            return context.$http.get(this.baseURL + 'cnwallet/charges/rf', {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getWalletBalance',
        value: function getWalletBalance(context, id) {
            return context.$http.get(this.baseURL + 'cnwallet/balance/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getWalletTransactions',
        value: function getWalletTransactions(context, id) {
            return context.$http.get(this.baseURL + 'cnwallet/transactions/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'postWalletTopup',
        value: function postWalletTopup(context, data) {
            return context.$http.post(this.baseURL + 'cnwallet/transactions/topup', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'postWalletPayout',
        value: function postWalletPayout(context, data) {
            return context.$http.post(this.baseURL + 'cnwallet/transactions/payout', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'remitaRRRLookup',
        value: function remitaRRRLookup(context, req, data) {
            return context.$http.post('https://login.remita.net/remita/exapp/api/v1/send/api/echannelsvc/echannel/agents/collection/K0hJWTFORFVmcEZ1T2ZIY2hTWXdtVGpaVTNBaVVTZFh6bDFlSzNxS0d6UFBQRXoxdVBaREhkUHRnOWozZGhZYQ==/' + req.rrr_code + '/' + req.rrr_request_id + '/lookup?callback=?', data, {
                headers: {
                    Accept: "application/json"
                }
            });
        }
    }, {
        key: 'remitaPaymentNotification',
        value: function remitaPaymentNotification(context, req, data) {
            return context.$http.post('https://login.remita.net/remita/exapp/api/v1/send/api/echannelsvc/echannel/agents/collection/K0hJWTFORFVmcEZ1T2ZIY2hTWXdtVGpaVTNBaVVTZFh6bDFlSzNxS0d6UFBQRXoxdVBaREhkUHRnOWozZGhZYQ==/' + req.rrr_code + '/00/SUCCESS/' + req.rrr_request_id + '/notification', data, {
                headers: {
                    Accept: "application/json"
                }
            });
        }
    }, {
        key: 'verifyRavePayment',
        value: function verifyRavePayment(context, data) {
            return context.$http.post('https://api.ravepay.co/flwv3-pug/getpaidx/api/v2/verify', data, {
                headers: {
                    Accept: "application/json"
                }
            });
        }
    }, {
        key: 'postCNpayPaymentDetails',
        value: function postCNpayPaymentDetails(context, data) {
            return context.$http.post(this.baseURL + 'cnpayments', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'updateCNpayPaymentNotification',
        value: function updateCNpayPaymentNotification(context, id, data) {
            return context.$http.put(this.baseURL + 'cnpayments/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getCNpayCharges',
        value: function getCNpayCharges(context) {
            return context.$http.get(this.baseURL + 'cnpayments/charges', {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'pagaGetMerchants',
        value: function pagaGetMerchants(context) {
            return context.$http.post(this.paga_apiBaseUrl + 'unsecured/getMerchants', {
                headers: {
                    'Content-Type': 'application/json',
                    principal: this.paga_principal,
                    Credentials: this.paga_password
                }
            });
        }
    }, {
        key: 'pagaGetMobileOperators',
        value: function pagaGetMobileOperators(context) {
            return context.$http.post(this.paga_apiBaseUrl + 'unsecured/getMobileOperators', {
                headers: {
                    'Content-Type': 'application/json',
                    principal: this.paga_principal,
                    Credentials: this.paga_password,

                    Accept: 'application/json'
                }
            });
        }
    }, {
        key: 'getPagaServiceGroups',
        value: function getPagaServiceGroups(context) {
            return context.$http.get(this.baseURL + 'cnpay/paga/servicegroups', {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getPagaRequest',
        value: function getPagaRequest(context, data, url, hash) {
            return context.$http.post(url, data, {
                headers: {
                    'Content-Type': 'application/json',
                    principal: this.paga_principal,
                    credentials: this.paga_password,
                    hash: hash,
                    accept: 'application/json'
                }
            });
        }
    }, {
        key: 'simulGetPagaRequest',
        value: function simulGetPagaRequest(context, data, url, hash) {
            return context.$http.get(this.baseURL + 'simul/paga/paymerchants', {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getPagaRequestAAA',
        value: function getPagaRequestAAA(context, data, url, hash) {
            $.jsonp({
                url: url,
                type: 'post',
                data: data,
                headers: {
                    principal: this.paga_principal,
                    Credentials: this.paga_password,
                    hash: hash,
                    Accept: 'application/json'
                },
                corsSupport: true,
                jsonpSupport: true,
                success: function success(data) {
                    console.log("hereJSOPCORS");
                    console.log(data);
                }
            });
        }
    }, {
        key: 'postCNpayPagaPaymentDetails',
        value: function postCNpayPagaPaymentDetails(context, data) {
            return context.$http.post(this.baseURL + 'cnpayments/paga', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'updateCNpayPagaPaymentNotification',
        value: function updateCNpayPagaPaymentNotification(context, id, data) {
            return context.$http.put(this.baseURL + 'cnpayments/paga/' + id, data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'saveServiceData',
        value: function saveServiceData(context, data) {
            return context.$http.post(this.baseURL + 'cnpayments/save/data', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getSavedServiceData',
        value: function getSavedServiceData(context, id) {
            return context.$http.get(this.baseURL + 'cnpayments/save/data/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getWalletProcessingCharges',
        value: function getWalletProcessingCharges(context, id) {
            return context.$http.get(this.baseURL + 'cnwallet/charges', {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getWalletProcessingChargesRF',
        value: function getWalletProcessingChargesRF(context) {
            return context.$http.get(this.baseURL + 'cnwallet/charges/rf', {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getWalletBalance',
        value: function getWalletBalance(context, id) {
            return context.$http.get(this.baseURL + 'cnwallet/balance/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'getWalletTransactions',
        value: function getWalletTransactions(context, id) {
            return context.$http.get(this.baseURL + 'cnwallet/transactions/' + id, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'postWalletTopup',
        value: function postWalletTopup(context, data) {
            return context.$http.post(this.baseURL + 'cnwallet/transactions/topup', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'postMessages',
        value: function postMessages(context, data) {
            return context.$http.post(this.baseURL + 'system/messages', data, {
                headers: {
                    'Api-Token': this.apiToken
                }
            });
        }
    }, {
        key: 'SHA512',
        value: function SHA512(str) {
            function int64(msint_32, lsint_32) {
                this.highOrder = msint_32;
                this.lowOrder = lsint_32;
            }

            var H = [new int64(0x6a09e667, 0xf3bcc908), new int64(0xbb67ae85, 0x84caa73b), new int64(0x3c6ef372, 0xfe94f82b), new int64(0xa54ff53a, 0x5f1d36f1), new int64(0x510e527f, 0xade682d1), new int64(0x9b05688c, 0x2b3e6c1f), new int64(0x1f83d9ab, 0xfb41bd6b), new int64(0x5be0cd19, 0x137e2179)];

            var K = [new int64(0x428a2f98, 0xd728ae22), new int64(0x71374491, 0x23ef65cd), new int64(0xb5c0fbcf, 0xec4d3b2f), new int64(0xe9b5dba5, 0x8189dbbc), new int64(0x3956c25b, 0xf348b538), new int64(0x59f111f1, 0xb605d019), new int64(0x923f82a4, 0xaf194f9b), new int64(0xab1c5ed5, 0xda6d8118), new int64(0xd807aa98, 0xa3030242), new int64(0x12835b01, 0x45706fbe), new int64(0x243185be, 0x4ee4b28c), new int64(0x550c7dc3, 0xd5ffb4e2), new int64(0x72be5d74, 0xf27b896f), new int64(0x80deb1fe, 0x3b1696b1), new int64(0x9bdc06a7, 0x25c71235), new int64(0xc19bf174, 0xcf692694), new int64(0xe49b69c1, 0x9ef14ad2), new int64(0xefbe4786, 0x384f25e3), new int64(0x0fc19dc6, 0x8b8cd5b5), new int64(0x240ca1cc, 0x77ac9c65), new int64(0x2de92c6f, 0x592b0275), new int64(0x4a7484aa, 0x6ea6e483), new int64(0x5cb0a9dc, 0xbd41fbd4), new int64(0x76f988da, 0x831153b5), new int64(0x983e5152, 0xee66dfab), new int64(0xa831c66d, 0x2db43210), new int64(0xb00327c8, 0x98fb213f), new int64(0xbf597fc7, 0xbeef0ee4), new int64(0xc6e00bf3, 0x3da88fc2), new int64(0xd5a79147, 0x930aa725), new int64(0x06ca6351, 0xe003826f), new int64(0x14292967, 0x0a0e6e70), new int64(0x27b70a85, 0x46d22ffc), new int64(0x2e1b2138, 0x5c26c926), new int64(0x4d2c6dfc, 0x5ac42aed), new int64(0x53380d13, 0x9d95b3df), new int64(0x650a7354, 0x8baf63de), new int64(0x766a0abb, 0x3c77b2a8), new int64(0x81c2c92e, 0x47edaee6), new int64(0x92722c85, 0x1482353b), new int64(0xa2bfe8a1, 0x4cf10364), new int64(0xa81a664b, 0xbc423001), new int64(0xc24b8b70, 0xd0f89791), new int64(0xc76c51a3, 0x0654be30), new int64(0xd192e819, 0xd6ef5218), new int64(0xd6990624, 0x5565a910), new int64(0xf40e3585, 0x5771202a), new int64(0x106aa070, 0x32bbd1b8), new int64(0x19a4c116, 0xb8d2d0c8), new int64(0x1e376c08, 0x5141ab53), new int64(0x2748774c, 0xdf8eeb99), new int64(0x34b0bcb5, 0xe19b48a8), new int64(0x391c0cb3, 0xc5c95a63), new int64(0x4ed8aa4a, 0xe3418acb), new int64(0x5b9cca4f, 0x7763e373), new int64(0x682e6ff3, 0xd6b2b8a3), new int64(0x748f82ee, 0x5defb2fc), new int64(0x78a5636f, 0x43172f60), new int64(0x84c87814, 0xa1f0ab72), new int64(0x8cc70208, 0x1a6439ec), new int64(0x90befffa, 0x23631e28), new int64(0xa4506ceb, 0xde82bde9), new int64(0xbef9a3f7, 0xb2c67915), new int64(0xc67178f2, 0xe372532b), new int64(0xca273ece, 0xea26619c), new int64(0xd186b8c7, 0x21c0c207), new int64(0xeada7dd6, 0xcde0eb1e), new int64(0xf57d4f7f, 0xee6ed178), new int64(0x06f067aa, 0x72176fba), new int64(0x0a637dc5, 0xa2c898a6), new int64(0x113f9804, 0xbef90dae), new int64(0x1b710b35, 0x131c471b), new int64(0x28db77f5, 0x23047d84), new int64(0x32caab7b, 0x40c72493), new int64(0x3c9ebe0a, 0x15c9bebc), new int64(0x431d67c4, 0x9c100d4c), new int64(0x4cc5d4be, 0xcb3e42b6), new int64(0x597f299c, 0xfc657e2a), new int64(0x5fcb6fab, 0x3ad6faec), new int64(0x6c44198c, 0x4a475817)];

            var W = new Array(64);
            var a, b, c, d, e, f, g, h, i, j;
            var T1, T2;
            var charsize = 8;

            function utf8_encode(str) {
                return unescape(encodeURIComponent(str));
            }

            function str2binb(str) {
                var bin = [];
                var mask = (1 << charsize) - 1;
                var len = str.length * charsize;

                for (var i = 0; i < len; i += charsize) {
                    bin[i >> 5] |= (str.charCodeAt(i / charsize) & mask) << 32 - charsize - i % 32;
                }

                return bin;
            }

            function binb2hex(binarray) {
                var hex_tab = '0123456789abcdef';
                var str = '';
                var length = binarray.length * 4;
                var srcByte;

                for (var i = 0; i < length; i += 1) {
                    srcByte = binarray[i >> 2] >> (3 - i % 4) * 8;
                    str += hex_tab.charAt(srcByte >> 4 & 0xF) + hex_tab.charAt(srcByte & 0xF);
                }

                return str;
            }

            function safe_add_2(x, y) {
                var lsw, msw, lowOrder, highOrder;

                lsw = (x.lowOrder & 0xFFFF) + (y.lowOrder & 0xFFFF);
                msw = (x.lowOrder >>> 16) + (y.lowOrder >>> 16) + (lsw >>> 16);
                lowOrder = (msw & 0xFFFF) << 16 | lsw & 0xFFFF;

                lsw = (x.highOrder & 0xFFFF) + (y.highOrder & 0xFFFF) + (msw >>> 16);
                msw = (x.highOrder >>> 16) + (y.highOrder >>> 16) + (lsw >>> 16);
                highOrder = (msw & 0xFFFF) << 16 | lsw & 0xFFFF;

                return new int64(highOrder, lowOrder);
            }

            function safe_add_4(a, b, c, d) {
                var lsw, msw, lowOrder, highOrder;

                lsw = (a.lowOrder & 0xFFFF) + (b.lowOrder & 0xFFFF) + (c.lowOrder & 0xFFFF) + (d.lowOrder & 0xFFFF);
                msw = (a.lowOrder >>> 16) + (b.lowOrder >>> 16) + (c.lowOrder >>> 16) + (d.lowOrder >>> 16) + (lsw >>> 16);
                lowOrder = (msw & 0xFFFF) << 16 | lsw & 0xFFFF;

                lsw = (a.highOrder & 0xFFFF) + (b.highOrder & 0xFFFF) + (c.highOrder & 0xFFFF) + (d.highOrder & 0xFFFF) + (msw >>> 16);
                msw = (a.highOrder >>> 16) + (b.highOrder >>> 16) + (c.highOrder >>> 16) + (d.highOrder >>> 16) + (lsw >>> 16);
                highOrder = (msw & 0xFFFF) << 16 | lsw & 0xFFFF;

                return new int64(highOrder, lowOrder);
            }

            function safe_add_5(a, b, c, d, e) {
                var lsw, msw, lowOrder, highOrder;

                lsw = (a.lowOrder & 0xFFFF) + (b.lowOrder & 0xFFFF) + (c.lowOrder & 0xFFFF) + (d.lowOrder & 0xFFFF) + (e.lowOrder & 0xFFFF);
                msw = (a.lowOrder >>> 16) + (b.lowOrder >>> 16) + (c.lowOrder >>> 16) + (d.lowOrder >>> 16) + (e.lowOrder >>> 16) + (lsw >>> 16);
                lowOrder = (msw & 0xFFFF) << 16 | lsw & 0xFFFF;

                lsw = (a.highOrder & 0xFFFF) + (b.highOrder & 0xFFFF) + (c.highOrder & 0xFFFF) + (d.highOrder & 0xFFFF) + (e.highOrder & 0xFFFF) + (msw >>> 16);
                msw = (a.highOrder >>> 16) + (b.highOrder >>> 16) + (c.highOrder >>> 16) + (d.highOrder >>> 16) + (e.highOrder >>> 16) + (lsw >>> 16);
                highOrder = (msw & 0xFFFF) << 16 | lsw & 0xFFFF;

                return new int64(highOrder, lowOrder);
            }

            function maj(x, y, z) {
                return new int64(x.highOrder & y.highOrder ^ x.highOrder & z.highOrder ^ y.highOrder & z.highOrder, x.lowOrder & y.lowOrder ^ x.lowOrder & z.lowOrder ^ y.lowOrder & z.lowOrder);
            }

            function ch(x, y, z) {
                return new int64(x.highOrder & y.highOrder ^ ~x.highOrder & z.highOrder, x.lowOrder & y.lowOrder ^ ~x.lowOrder & z.lowOrder);
            }

            function rotr(x, n) {
                if (n <= 32) {
                    return new int64(x.highOrder >>> n | x.lowOrder << 32 - n, x.lowOrder >>> n | x.highOrder << 32 - n);
                } else {
                    return new int64(x.lowOrder >>> n | x.highOrder << 32 - n, x.highOrder >>> n | x.lowOrder << 32 - n);
                }
            }

            function sigma0(x) {
                var rotr28 = rotr(x, 28);
                var rotr34 = rotr(x, 34);
                var rotr39 = rotr(x, 39);

                return new int64(rotr28.highOrder ^ rotr34.highOrder ^ rotr39.highOrder, rotr28.lowOrder ^ rotr34.lowOrder ^ rotr39.lowOrder);
            }

            function sigma1(x) {
                var rotr14 = rotr(x, 14);
                var rotr18 = rotr(x, 18);
                var rotr41 = rotr(x, 41);

                return new int64(rotr14.highOrder ^ rotr18.highOrder ^ rotr41.highOrder, rotr14.lowOrder ^ rotr18.lowOrder ^ rotr41.lowOrder);
            }

            function gamma0(x) {
                var rotr1 = rotr(x, 1),
                    rotr8 = rotr(x, 8),
                    shr7 = shr(x, 7);

                return new int64(rotr1.highOrder ^ rotr8.highOrder ^ shr7.highOrder, rotr1.lowOrder ^ rotr8.lowOrder ^ shr7.lowOrder);
            }

            function gamma1(x) {
                var rotr19 = rotr(x, 19);
                var rotr61 = rotr(x, 61);
                var shr6 = shr(x, 6);

                return new int64(rotr19.highOrder ^ rotr61.highOrder ^ shr6.highOrder, rotr19.lowOrder ^ rotr61.lowOrder ^ shr6.lowOrder);
            }

            function shr(x, n) {
                if (n <= 32) {
                    return new int64(x.highOrder >>> n, x.lowOrder >>> n | x.highOrder << 32 - n);
                } else {
                    return new int64(0, x.highOrder << 32 - n);
                }
            }

            var str = utf8_encode(str);
            var strlen = str.length * charsize;
            var str = str2binb(str);

            str[strlen >> 5] |= 0x80 << 24 - strlen % 32;
            str[(strlen + 128 >> 10 << 5) + 31] = strlen;

            for (var i = 0; i < str.length; i += 32) {
                a = H[0];
                b = H[1];
                c = H[2];
                d = H[3];
                e = H[4];
                f = H[5];
                g = H[6];
                h = H[7];

                for (var j = 0; j < 80; j++) {
                    if (j < 16) {
                        W[j] = new int64(str[j * 2 + i], str[j * 2 + i + 1]);
                    } else {
                        W[j] = safe_add_4(gamma1(W[j - 2]), W[j - 7], gamma0(W[j - 15]), W[j - 16]);
                    }

                    T1 = safe_add_5(h, sigma1(e), ch(e, f, g), K[j], W[j]);
                    T2 = safe_add_2(sigma0(a), maj(a, b, c));
                    h = g;
                    g = f;
                    f = e;
                    e = safe_add_2(d, T1);
                    d = c;
                    c = b;
                    b = a;
                    a = safe_add_2(T1, T2);
                }

                H[0] = safe_add_2(a, H[0]);
                H[1] = safe_add_2(b, H[1]);
                H[2] = safe_add_2(c, H[2]);
                H[3] = safe_add_2(d, H[3]);
                H[4] = safe_add_2(e, H[4]);
                H[5] = safe_add_2(f, H[5]);
                H[6] = safe_add_2(g, H[6]);
                H[7] = safe_add_2(h, H[7]);
            }

            var binarray = [];
            for (var i = 0; i < H.length; i++) {
                binarray.push(H[i].highOrder);
                binarray.push(H[i].lowOrder);
            }
            return binb2hex(binarray);
        }
    }]);

    return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(94)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(48),
  /* template */
  __webpack_require__(106),
  /* scopeId */
  "data-v-b54bb7f8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(88)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(49),
  /* template */
  __webpack_require__(99),
  /* scopeId */
  "data-v-1bd8eaca",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(89)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(46),
  /* template */
  __webpack_require__(101),
  /* scopeId */
  "data-v-2ab6b632",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(90)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(47),
  /* template */
  __webpack_require__(102),
  /* scopeId */
  "data-v-33ba9bc4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(91)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(51),
  /* template */
  __webpack_require__(103),
  /* scopeId */
  "data-v-362d683a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var inBrowser = typeof window !== 'undefined';
/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'VueProgress',
    serverCacheKey: function serverCacheKey() {
        return 'Progress';
    },
    computed: {
        style: function style() {
            var location = this.progress.options.location;
            var style = {
                'background-color': this.progress.options.canSuccess ? this.progress.options.color : this.progress.options.failedColor,
                'opacity': this.progress.options.show ? 1 : 0
            };
            if (location == 'top' || location == 'bottom') {
                location === 'top' ? style.top = '0px' : style.bottom = '0px';
                if (!this.progress.options.inverse) {
                    style.left = '0px';
                } else {
                    style.right = '0px';
                }
                style.width = this.progress.percent + '%';
                style.height = this.progress.options.thickness;
                style.transition = "width " + this.progress.options.transition.speed + ", opacity " + this.progress.options.transition.opacity;
            } else if (location == 'left' || location == 'right') {
                location === 'left' ? style.left = '0px' : style.right = '0px';
                if (!this.progress.options.inverse) {
                    style.bottom = '0px';
                } else {
                    style.top = '0px';
                }
                style.height = this.progress.percent + '%';
                style.width = this.progress.options.thickness;
                style.transition = "height " + this.progress.options.transition.speed + ", opacity " + this.progress.options.transition.opacity;
            }
            return style;
        },
        progress: function progress() {
            if (inBrowser) {
                return window.VueProgressBarEventBus.RADON_LOADING_BAR;
            } else {
                return {
                    percent: 0,
                    options: {
                        canSuccess: true,
                        show: false,
                        color: 'rgb(19, 91, 55)',
                        failedColor: 'red',
                        thickness: '2px',
                        transition: {
                            speed: '0.2s',
                            opacity: '0.6s',
                            termination: 300
                        },
                        location: 'top',
                        autoRevert: true,
                        inverse: false
                    }
                };
            }
        }
    }
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);



var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: "Sidebar",
    data: function data() {
        return {
            forums: {},
            forum: {},
            search: {},
            survey: {},
            surveys: [],
            pageNotSurvey: true,
            cnproParentCategories: {},
            sub_categories: {}
        };
    },


    methods: {
        setForum: function setForum(forum) {
            localStorage.setItem("cn_f", forum);
            this.$router.push("/forum");
        },
        getSurveys: function getSurveys() {
            var _this = this;

            service.allSurveys(this).then(function (res) {
                _this.surveys = res.body.data;
            });
        },
        getAllForums: function getAllForums() {
            var _this2 = this;

            service.getAllForums(this).then(function (data) {
                if (data.body.status == 200) {
                    _this2.forums = data.body.data;
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        checkCurrentPage: function checkCurrentPage() {
            if (this.$route.path != '/cnsurveys') {
                this.pageNotSurvey = true;
            } else {
                this.pageNotSurvey = false;
            }
        },
        getCnproParentCategories: function getCnproParentCategories() {
            var _this3 = this;

            service.getCnproParentCategories(this).then(function (data) {
                if (data.body.status == 200) {
                    _this3.cnproParentCategories = data.body.data;
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        getCnproSubCategories: function getCnproSubCategories(parent) {
            var _this4 = this;

            service.getCnproCategories(this, parent).then(function (data) {
                if (data.body.status == 200) {
                    _this4.sub_categories = data.body.data;
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        getBusinessCategories: function getBusinessCategories() {
            var _this5 = this;

            service.getBusinessCategories(this).then(function (data) {
                if (data.body.status == 200) {
                    _this5.sub_categories = data.body.data;
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        prep_sub_categories: function prep_sub_categories(parent) {
            if (parent == "business-search") {
                this.search.type = 'business-search';
                this.getBusinessCategories();
            } else {
                this.search.type = 'cnpro-search';
                this.getCnproSubCategories(parent);
            }
        },
        prep_search: function prep_search(keywords) {
            this.search.keywords = keywords;
            this.search.city = 'Abuja';
        },
        doSearch: function doSearch() {
            var credentials = {
                search_type: this.search.type,
                search_keywords: this.search.keywords,
                search_city: this.search.city
            };

            var navi = this.$router;

            if (credentials.search_type != null || credentials.search_keywords != null) {
                navi.push(this.search.type + '?context=' + this.search.keywords + '&city=' + this.search.city);
            } else {
                toastr.error('Kindly fill all fields', 'Warning!');
            }
        }
    },
    created: function created() {
        this.getAllForums();
        this.getSurveys();
        this.checkCurrentPage();
        this.getCnproParentCategories();
    }
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);



var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: "SearchBar",
    data: function data() {
        return {
            search: {},
            cnproParentCategories: {},
            sub_categories: {}
        };
    },

    methods: {
        getCnproParentCategories: function getCnproParentCategories() {
            var _this = this;

            service.getCnproParentCategories(this).then(function (data) {
                if (data.body.status == 200) {
                    _this.cnproParentCategories = data.body.data;
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        getCnproSubCategories: function getCnproSubCategories(parent) {
            var _this2 = this;

            service.getCnproCategories(this, parent).then(function (data) {
                if (data.body.status == 200) {
                    _this2.sub_categories = data.body.data;
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        getBusinessCategories: function getBusinessCategories() {
            var _this3 = this;

            service.getBusinessCategories(this).then(function (data) {
                if (data.body.status == 200) {
                    _this3.sub_categories = data.body.data;
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        prep_sub_categories: function prep_sub_categories(parent) {
            if (parent == "business-search") {
                this.search.type = 'business-search';
                this.getBusinessCategories();
            } else {
                this.search.type = 'cnpro-search';
                this.getCnproSubCategories(parent);
            }
        },
        prep_search: function prep_search(keywords) {
            this.search.keywords = keywords;
            this.search.city = 'Abuja';
        },
        doSearch: function doSearch() {
            var credentials = {
                search_type: this.search.type,
                search_keywords: this.search.keywords,
                search_city: this.search.city
            };

            var navi = this.$router;

            if (credentials.search_type != null || credentials.search_keywords != null) {
                location.replace(this.search.type + '?context=' + this.search.keywords + '&city=' + this.search.city);
            } else {
                toastr.error('Kindly fill all fields', 'Warning!');
            }
        }
    },
    created: function created() {
        this.getCnproParentCategories();
    }
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_validator__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Second_Header_index_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Second_Header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Second_Header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Sidebar_index_vue__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Sidebar_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Sidebar_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__HorizontalWidget_vue__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__HorizontalWidget_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__HorizontalWidget_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Main_Footer_index_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Main_Footer_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__Main_Footer_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SearchBar_vue__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SearchBar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__SearchBar_vue__);











var service = new __WEBPACK_IMPORTED_MODULE_3__services_service__["a" /* default */]();
var valid = new __WEBPACK_IMPORTED_MODULE_4__services_validator__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'CNpay',
    data: function data() {
        var _ref;

        return _ref = {
            user: {},
            user_details: {},
            rrr: {},
            rrr_details: {},
            rrr_txn_details: {},
            panelFlag: false,
            addFlag: false,
            backgroundSize: 'contain',
            disable_btn: false,
            error_count: 0,
            request_sent: false,
            show_code_details: false,
            rrr_err_message: "",
            onboarding: false,
            loading: false,
            rloading: false,
            processing: false,
            cnpay_proc_fee: 0 }, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'cnpay_proc_fee', 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'cnpay_post_txn_id', 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'cnpay_post_txn_ref', ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'range_1_max', 5000), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'range_2_max', 10000), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'range_1_pay', 25), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'range_2_pay', 50), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'range_3_pay', 100), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'ravecomm', 0.0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'total_fee', 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'payment_message', ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'payment_service_message', ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'login_script', false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'loggedIn', false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'disable_btn_login', false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'disable_btn_wallet', false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'paga_service_groups', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'paga_merchant', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'paga_airtime_request', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'paga_bundle_request', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'show_paga_service_details', false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'show_airtime_form_details', false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'show_data_bundle', false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'show_data_bundle_phone_number_field', false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'is_paga_merchant_purchase', false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'is_paga_mobileops_purchase', false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'serviceToPayFor', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'customer', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'customer_received_details', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'data_error_message', ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'data_phone_error_message', ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'data_email_error_message', ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'setPayWithOption', false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'today', new Date()), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'img_url', service.imageURL), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'serviceToPayComponentKey', 1), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'payment_details', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'wallet_charges', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'wallet_transaction', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'wallet_transactions', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'current_wallet_balance', 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'to_pay_out', 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'wallet_payment_message', ''), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'wallet_payment_error_message', ''), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'min_wallet_topup_amount', 100), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'max_wallet_topup_amount', 10000), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'wallet_payment_calculated', false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'disable_topup_wallet_btn', false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'headerKey', 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'dataBundleComponentKey', 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'mainSiteUrl', service.mainSiteUrl), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'transaction_processed_reload', false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'save_service_data_prompt', false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'show_set_service_saved_data', false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'saved_services_data', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'set_service_saved_data', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'show_payment_receipt', false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'payment_receipt_details', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'downloading', false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'service_charge', 0), _ref;
    },

    components: {
        'second-header': __WEBPACK_IMPORTED_MODULE_5__Second_Header_index_vue___default.a,
        'sidebar': __WEBPACK_IMPORTED_MODULE_6__Sidebar_index_vue___default.a,
        'main-footer': __WEBPACK_IMPORTED_MODULE_8__Main_Footer_index_vue___default.a,
        'horizontal-widget': __WEBPACK_IMPORTED_MODULE_7__HorizontalWidget_vue___default.a,
        'search-bar': __WEBPACK_IMPORTED_MODULE_9__SearchBar_vue___default.a
    },
    computed: {
        rateValue: {
            get: function get() {
                return this.rate;
            },
            set: function set(newVal) {
                this.rate = newVal;
                this.rateCnpro();
            }
        }
    },
    methods: {
        isActive: function isActive(page) {
            if (page == this.current_page) {
                return true;
            }
        },
        showLoading: function showLoading(id) {
            var x = document.getElementById(id);
            if (id.includes("xs")) {
                document.getElementById(id).classList.add('wn-loader-xs');
            }
        },
        closeModal: function closeModal(modal) {
            $(modal).modal("hide");
            if (modal == 'paywith') {
                this.reset();
            }
            this.login_script = '';
            this.disable_btn_wallet = false;
            this.disable_btn = false;
            this.disable_topup_wallet_btn = false;
            this.wallet_payment_message = '';
            this.save_service_data_prompt = false;

            this.paga_airtime_request = {};
            this.paga_bundle_request = {};
            this.customer = {};

            if (this.transaction_processed_reload) {
                location.reload();
            }
        },
        scrollToTop: function scrollToTop() {
            var top = document.getElementById("topwrap").offsetTop;
            window.scrollTo(0, top);
        },
        setLogin: function setLogin() {
            $('#login').modal();
        },
        reset: function reset() {
            this.show_code_details = false;
            this.show_paga_service_details = false;
            this.show_airtime_form_details = false;
            this.total_fee = 0;
            this.payment_message = '';
            this.data_error_message = "";
            this.paga_merchant = {};
            this.disable_btn = false;
        },
        reset_flow: function reset_flow() {
            this.payment_message = 'processing';
            this.total_fee = 0;
            this.data_error_message = "";
            this.paga_merchant = {};
            this.disable_btn = false;
        },
        reset_payment_flow: function reset_payment_flow() {
            this.disable_btn = false;
        },
        resetServiceToPay: function resetServiceToPay() {
            this.paga_merchant.serviceToPay = false;
            this.serviceToPayComponentKey++;
        },
        resetServiceToPayAmount: function resetServiceToPayAmount() {
            this.paga_merchant.serviceToPay.servicePrice = 0;
        },
        reset_data_bundle: function reset_data_bundle() {
            this.show_data_bundle_phone_number_field = false;
            this.paga_merchant.serviceToPay = {};
        },
        processCode: function processCode() {
            var _this = this;

            this.reset();
            if (this.rrr.rrr_code == '' || this.rrr.rrr_code == undefined) {
                this.rrr_err_message = "Please Enter RRR Code";
            } else {
                this.disable_btn = true;
                this.rloading = true;
                var self = this;

                var sanitized_rrr_code = this.rrr.rrr_code.replace(/\D/g, '');

                var timestamp = new Date().getTime();

                var encodedString = btoa(unescape(encodeURIComponent(timestamp)));


                var credentials = {
                    rrr_code: sanitized_rrr_code,
                    rrr_request_id: encodedString
                };
                var payload = {
                    "jsonp": "jp",
                    "ProcessingInfo": [{
                        "name": "AGENTCODE",
                        "value": "CIEJPM" }]
                };

                service.remitaRRRLookup(this, credentials, payload).then(function (response) {
                    var n_json = response.bodyText;

                    var f = new Function('jsonp', n_json);

                    f(function (json) {
                        if (json.responseCode && json.responseCode != "SUCCESS") {
                            self.rrr_err_message = json.responseMessage;
                            self.rloading = false;
                        } else {
                            self.rrr_details = json;
                            self.rrr_txn_details = json.txn;
                            self.show_code_details = true;

                            var cnpay_charge = 0;
                            var total_remita_amt = self.rrr_txn_details.RRRAMOUNT + self.rrr_txn_details.CHARGES;

                            if (total_remita_amt <= self.range_1_max) {
                                cnpay_charge = self.range_1_pay;
                            } else if (total_remita_amt <= self.range_2_max) {
                                cnpay_charge = self.range_2_pay;
                            } else if (total_remita_amt >= self.range_2_max) {
                                cnpay_charge = self.range_3_pay;
                            }
                            self.cnpay_proc_fee = cnpay_charge + total_remita_amt * self.ravecomm;

                            self.total_fee = total_remita_amt + total_remita_amt * self.ravecomm + cnpay_charge;
                            self.rloading = false;

                            self.total_fee = Number(self.total_fee.toPrecision(5));
                            self.cnpay_proc_fee = Number(self.cnpay_proc_fee.toPrecision(5));
                        }
                    });
                }).catch(function (err) {
                    _this.rloading = false;
                    _this.rrr_err_message = "Code Validation, Failed";
                });
            }
        },
        notifyRemitaPayment: function notifyRemitaPayment() {
            this.onboarding = true;
            this.disable_btn = true;
            var self = this;

            var timestamp = new Date().getTime();

            var encodedString = btoa(unescape(encodeURIComponent(timestamp)));


            var credentials = {
                rrr_code: this.rrr_details.RRR,
                rrr_request_id: encodedString
            };
            var payload = {
                "ProcessingInfo": [{
                    "name": "AGENTCODE",
                    "value": "CIEJPM" }]
            };

            service.remitaPaymentNotification(this, credentials, payload).then(function (response) {

                var n_json = response.bodyText;
                var f = new Function('jsonp', n_json);
                f(function (json) {
                    var payload = {
                        "rrr_notify_responseCode": json.responseCode,
                        "rrr_notify_responseId": json.responseId,
                        "rrr_notify_responseMessage": json.responseMessage
                    };

                    if (json.responseCode != "00") {
                        self.payment_message = "Sorry your Payment-Update-Process could not be completed, Please contact cnpay@cityneeds.ng";
                    }
                    service.updateCNpayPaymentNotification(self, self.cnpay_post_txn_id, payload).then(function (response22) {
                        self.afterProcessing(0, service.service_payment_circle_fully_successful);
                    }).catch(function (err) {
                        self.afterProcessing(1, service.service_payment_circle_not_fully_successful);
                    });
                });
            }).catch(function (err) {});
        },
        setProcessPayment: function setProcessPayment() {
            this.login_script = false;
            $('#paywith').modal();
        },
        prepProcessPayment: function prepProcessPayment(pay_with_option) {
            this.disable_btn = true;
            if (pay_with_option == "gateway") {
                this.processPayment();
            } else {
                this.processPaymentWithWallet();
            }
        },
        processPayment: function processPayment() {
            var self = this;
            var x = getpaidSetup({
                PBFPubKey: service.ravepay_public_live_remita,
                customer_email: self.rrr_txn_details.PAYEREMAIL,
                amount: self.total_fee,
                customer_phone: self.rrr_txn_details.PAYERNUMBER,
                currency: "NGN",
                payment_method: "both",
                txref: "CNpay-" + self.rrr_txn_details.transactionId,
                meta: [{
                    metaname: "CNpay",
                    metavalue: self.rrr_txn_details.PAYERNAME
                }],
                onclose: function onclose() {},
                callback: function callback(response) {
                    var txref = response.tx.txRef;
                    var tx_amount = response.tx.amount;
                    if (response.tx.chargeResponseCode == "00" || response.tx.chargeResponseCode == "0") {
                        self.processing = true;

                        var payload = {
                            "SECKEY": service.ravepay_secret_live_remita,
                            "txref": txref
                        };
                        service.verifyRavePayment(self, payload).then(function (response) {
                            if (response.body.data.status === "successful" && response.body.data.chargecode == "00") {
                                self.payment_message = "Payment processed successfully. Check your email for your receipts.";

                                if (response.body.data.amount === tx_amount) {
                                    var txn_payload = {
                                        "txn_ref": txref,
                                        "rrr": self.rrr_details.RRR,
                                        "payername": self.rrr_txn_details.PAYERNAME,
                                        "payeremail": self.rrr_txn_details.PAYEREMAIL,
                                        "payernumber": self.rrr_txn_details.PAYERNUMBER,
                                        "rrr_amount": self.rrr_txn_details.RRRAMOUNT,
                                        "rrr_charges": self.rrr_txn_details.CHARGES,
                                        "cnpay_charges": self.cnpay_proc_fee,
                                        "total_paid_amt": tx_amount,
                                        "payer_logged": self.loggedIn,
                                        "payer_user_id": self.user.user_id || 0

                                    };

                                    service.postCNpayPaymentDetails(self, txn_payload).then(function (response) {
                                        self.cnpay_post_txn_id = response.body.txn;

                                        self.notifyRemitaPayment();
                                        var txn_payload00 = {
                                            "transaction_payment_ref": txref,
                                            "transaction_module": 19,
                                            "transaction_module_id": self.cnpay_post_txn_id,
                                            "transaction_type": 7,
                                            "transaction_mode": 2,
                                            "transaction_mode_transaction_ref": txref,
                                            "transaction_amount_paid": tx_amount,
                                            "payer_name": self.rrr_txn_details.PAYERNAME || "",
                                            "payer_email": self.rrr_txn_details.PAYEREMAIL || "",
                                            "payer_phone": self.rrr_txn_details.PAYERNUMBER || 0,
                                            "payer_user": self.user.user_id || 0
                                        };

                                        self.postCNpaymentDetails(txn_payload00);
                                    }).catch(function (err) {});
                                }
                            }
                        }).catch(function (err) {});
                    } else {
                        self.payment_message = "Payment unsuccessfull. please try again or contact us";
                    }

                    x.close();
                }
            });
        },
        processPaymentWithWallet: function processPaymentWithWallet() {
            var _this2 = this;

            this.disable_btn_wallet = true;
            var tx_amount = this.total_fee;
            var tx_ref = "CNpay-" + this.rrr_txn_details.transactionId;

            var self = this;

            var payload = {
                pay: this.user.user_id,
                txn_amount: tx_amount,
                service: 4,
                service_ref: tx_ref
            };
            service.postWalletPayout(this, payload).then(function (response) {
                if (response.body.status == 201) {
                    self.payment_message = "Payment processed successfully, check your email for your receipts.";

                    var txn_payload = {
                        "txn_ref": tx_ref,
                        "rrr": self.rrr_details.RRR,
                        "payername": self.rrr_txn_details.PAYERNAME,
                        "payeremail": self.rrr_txn_details.PAYEREMAIL,
                        "payernumber": self.rrr_txn_details.PAYERNUMBER,
                        "rrr_amount": self.rrr_txn_details.RRRAMOUNT,
                        "rrr_charges": self.rrr_txn_details.CHARGES,
                        "cnpay_charges": self.cnpay_proc_fee,
                        "total_paid_amt": tx_amount,
                        "payer_logged": _this2.loggedIn,
                        "payer_user_id": _this2.user.user_id || 0

                    };

                    service.postCNpayPaymentDetails(self, txn_payload).then(function (response) {
                        self.cnpay_post_txn_id = response.body.txn;

                        self.notifyRemitaPayment();

                        var txref = response.body.data_txn_ref;
                        var txn_payload00 = {
                            "transaction_payment_ref": tx_ref,
                            "transaction_module": 19,
                            "transaction_module_id": self.cnpay_post_txn_id,
                            "transaction_type": 7,
                            "transaction_mode": 2,
                            "transaction_mode_transaction_ref": txref,
                            "transaction_amount_paid": tx_amount,
                            "payer_name": self.rrr_txn_details.PAYERNAME || "",
                            "payer_email": self.rrr_txn_details.PAYEREMAIL || "",
                            "payer_phone": self.rrr_txn_details.PAYERNUMBER || 0,
                            "payer_user": self.user.user_id || 0
                        };

                        self.postCNpaymentDetails(txn_payload00);

                        _this2.disable_btn_wallet = false;
                    }).catch(function (err) {});
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        postCNpaymentDetails: function postCNpaymentDetails(txn_payload) {
            var self = this;
            service.postCNpaymentDetails(self, txn_payload).then(function (response) {
                var message = response.body.message;
                self.payment_process_option = 0;
                if (response.body.status == 200) {
                    self.payment_status = 200;
                    self.data_processing_message = service.service_payment_circle_fully_successful;

                    localStorage.setItem("payment_modal_message", self.data_processing_message);
                } else if (response.body.status == 400) {
                    self.payment_status = 400;
                    self.data_processing_message = service.service_payment_circle_not_fully_successful + '\nIssue: ' + message;

                    localStorage.setItem("payment_modal_message", self.data_processing_message);
                    localStorage.setItem("reslove_issues", message);
                }
            }).catch(function (err) {});
        },
        check_max_amount_purchase: function check_max_amount_purchase(set_max, amount) {
            var check = false;
            if (set_max == 0) {
                check = true;
            } else {
                if (amount > set_max) {
                    check = false;
                } else {
                    check = true;
                }
            }
            return check;
        },
        prepPagaAirtimeServices: function prepPagaAirtimeServices(merchant, show_loading) {
            this.reset();
            this.show_data_bundle = false;
            this.show_data_bundle_phone_number_field = false;
            this.paga_merchant = merchant;

            this.paga_merchant.loading = true;
            this.show_airtime_form_details = true;
            this.is_paga_mobileops_purchase = true;
            this.getServiceSavedData(merchant.paga_service_group_merchant_id);
            this.scrollToTop();

            this.is_paga_merchant_purchase = false;
        },
        setPagaAirtimeOrDataBundle: function setPagaAirtimeOrDataBundle() {
            if (this.show_data_bundle) {
                this.show_data_bundle = false;
            } else {
                this.show_data_bundle = true;
            }
        },
        prepSetPagaProcessPayment: function prepSetPagaProcessPayment(paga_service, service_for) {
            this.data_error_message = '';
            this.customer.customerCodeAtBiller = '';

            this.paga_merchant.serviceToPay = paga_service;
            if (this.paga_merchant.serviceToPay.servicePrice == 0) {
                this.paga_merchant.serviceToPay.servicePrice = '';
            }

            this.paga_merchant.serviceToPay.servicePrice_store = this.paga_merchant.serviceToPay.servicePrice;
            this.paga_merchant.serviceToPay.serviceNameStored = this.paga_merchant.serviceToPay.serviceName;
            this.serviceToPayFor = service_for;
            this.serviceToPayComponentKey++;
            this.setPayWithOption = false;

            this.is_paga_mobileops_purchase = false;

            $('#paywith').modal();
        },
        prepDataBundleSetPagaProcessPayment: function prepDataBundleSetPagaProcessPayment(service, service_for) {
            this.paga_bundle_request = service;
            this.paga_merchant.serviceToPay = service;
            this.show_data_bundle_phone_number_field = true;
            this.serviceToPayFor = service_for;
            this.dataBundleComponentKey++;
        },
        setPagaProcessPayment: function setPagaProcessPayment(paga_service, service_for) {
            var _this3 = this;

            var can_process = false;

            var check_max_purchase_effect = false;
            if (service_for == 'MOBILEOPS') {
                check_max_purchase_effect = this.check_max_amount_purchase(this.paga_merchant.paga_service_group_merchant_max_purchase_amount, this.paga_airtime_request.amount);
            } else if (service_for == 'MOBILEDATA') {
                check_max_purchase_effect = this.check_max_amount_purchase(this.paga_merchant.paga_service_group_merchant_max_purchase_amount, this.paga_merchant.serviceToPay.servicePrice);
            } else {
                check_max_purchase_effect = this.check_max_amount_purchase(this.paga_merchant.paga_service_group_merchant_max_purchase_amount, this.paga_merchant.serviceToPay.servicePrice);

                if (this.customer.customerName != '' && this.customer.customerName != undefined) {
                    if (this.customer.customerCodeAtBiller != '' && this.customer.customerCodeAtBiller != undefined) {
                        can_process = true;
                    } else {
                        can_process = false;
                        this.data_error_message = "Enter your number";
                    }
                } else {
                    can_process = false;
                    this.data_error_message = "Enter your details";
                }
            }

            if (check_max_purchase_effect) {
                can_process = true;
            } else {
                can_process = false;
                this.data_error_message = service.service_amt_out_of_range_msg;
            }


            if (can_process) {
                this.scrollToTop;
                this.disable_btn = true;
                this.setPayWithOption = false;
                var service_amt = 0;
                var paga_proc_fee = 0;
                var data_test = false;
                this.paga_merchant.serviceToPay = paga_service;

                if (service_for == 'MERCHANT') {
                    var name_split = this.customer.customerName.split(" ");
                    this.customer.customerFirstName = name_split[0];
                    this.customer.customerLastName = name_split[1];
                    if (this.customer.customerLastName == undefined) {
                        this.customer.customerLastName = this.customer.customerFirstName;
                    }
                }

                this.setCustomerDetails();

                if (service_for == 'MERCHANT') {
                    service_amt = parseFloat(paga_service.servicePrice);
                    data_test = true;

                    this.customer.customerCodeAtBiller = this.customer.customerCodeAtBiller.toString().trim();

                    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    var email_test = re.test(String(this.customer.customerEmail).toLowerCase());
                    var re_phone = /^\d{4}\d{3}\d{4}$/;

                    var phone_test_0 = re_phone.test(String(this.customer.customerPhoneNumber).toLowerCase());
                    var phone_test = true;
                    if (phone_test_0 == false) {
                        this.data_error_message = "Your Phone Number is not correct. Please fill correctly";
                    }
                    if (email_test == false || this.customer.customerFirstName == " " || phone_test == false) {
                        data_test = false;
                        if (email_test == false) {
                            this.data_error_message = "Your Email is not correct. Please fill correctly";
                        } else if (phone_test_0 == false) {
                            this.data_error_message = "Your Phone Number is not correct. Please fill correctly";
                        } else {
                            this.data_error_message = "Some errors were found in your form. Please, fill correctly";
                        }

                        this.disable_btn = false;
                    } else {
                        data_test = true;
                        this.data_error_message = "";
                        this.disable_btn = true;
                    }

                    if (data_test) {
                        var seek_url = service.paga_apiBaseUrl + "validateMerchantPayment";
                        var payload = {
                            "referenceNumber": this.today.getTime(),
                            "amount": this.paga_merchant.serviceToPay.servicePrice,
                            "merchantAccount": this.paga_merchant.paga_service_group_merchant_billerPublicId,
                            "merchantReferenceNumber": this.customer.customerCodeAtBiller,
                            "merchantServiceProductCode": this.paga_merchant.serviceToPay.code
                        };

                        var hash = service.SHA512(payload.referenceNumber + payload.amount + payload.merchantAccount + payload.merchantReferenceNumber + service.paga_apiKey);
                        var self = this;
                        service.getPagaRequest(self, payload, seek_url, hash).then(function (data) {
                            if (data.body.responseCode == 0) {
                                var _seek_url = service.paga_apiBaseUrl + "getMerchantAccountDetails";
                                var payload = {
                                    "referenceNumber": _this3.today.getTime(),
                                    "merchantAccount": _this3.paga_merchant.paga_service_group_merchant_billerPublicId,
                                    "merchantReferenceNumber": _this3.customer.customerCodeAtBiller,
                                    "merchantServiceProductCode": _this3.paga_merchant.serviceToPay.code
                                };
                                var _hash = service.SHA512(payload.referenceNumber + payload.merchantAccount + payload.merchantReferenceNumber + payload.merchantServiceProductCode + service.paga_apiKey);
                                var _self = _this3;
                                service.getPagaRequest(_self, payload, _seek_url, _hash).then(function (data) {
                                    if (data.body.responseCode == 0) {
                                        _this3.customer_received_details = data.body.details;data.body.accountDetails;

                                        if (_this3.paga_merchant.paga_service_group_merchant_commission_type == 'P') {
                                            paga_proc_fee = parseFloat(_this3.paga_merchant.paga_service_group_merchant_commission / 100 * service_amt);
                                        }
                                        if (_this3.paga_merchant.paga_service_group_merchant_commission_type == 'C') {
                                            paga_proc_fee = parseFloat(_this3.paga_merchant.paga_service_group_merchant_commission);
                                        }
                                        _this3.total_fee = parseFloat(service_amt + paga_proc_fee);
                                        _this3.service_charge = paga_proc_fee;

                                        _this3.paga_merchant.serviceToPay.serviceName = _this3.paga_merchant.paga_service_group_merchant_displayName + "-" + _this3.paga_merchant.serviceToPay.serviceName + "--" + _this3.customer.customerCodeAtBiller;


                                        _this3.disable_btn = false;
                                        _this3.login_script = false;
                                        _this3.setPayWithOption = true;
                                    } else {
                                        _this3.disable_btn = false;
                                        _this3.data_error_message = "Your details were not validated. Please, check your details: Your " + _this3.paga_merchant.paga_service_group_merchant_displayName + " Number, Amount Paid, Phone Number etc...";

                                        if (_this3.paga_merchant.serviceToPay.servicePrice_store == 0) {
                                            _this3.resetServiceToPayAmount();
                                        }
                                    }
                                }).catch(function (err) {});
                            } else if (data.body.responseCode == -1 || data.body.responseCode == 38033 || data.body.responseCode == 38051 || data.body.responseCode == 37005 || data.body.responseCode == 38015) {
                                _this3.disable_btn = false;
                                if (data.body.responseCode == 38051) {
                                    _this3.data_error_message = "Please review your details, the Amount to Purchase does not match";
                                } else if (data.body.responseCode == 37005) {
                                    _this3.data_error_message = data.body.message;
                                } else if (data.body.responseCode == 38015) {
                                    _this3.data_error_message = "Please review your details, account seems inactive";
                                } else {
                                    _this3.data_error_message = "Your details were not validated. Please, review your details: Your " + _this3.paga_merchant.paga_service_group_merchant_displayName + " Number, Phone Number etc... Amount to Purchase may be too low.";
                                }

                                if (_this3.paga_merchant.serviceToPay.servicePrice_store == 0) {
                                    _this3.resetServiceToPayAmount();
                                }
                            } else {
                                if (data.body.responseCode == 37006) {
                                    var msg = {
                                        "message_from": "System Services",
                                        "message_body": "Your Paga Balance could not process a Service Amount of: " + _this3.paga_merchant.serviceToPay.servicePrice + ". Increase your Paga Balance to process amount such as this. " + " PAGA Response Code: " + data.body.responseCode + "."
                                    };
                                    service.postMessages(_this3, msg).then(function (data) {});
                                }
                                if (data.body.responseCode == 38006) {
                                    var msg = {
                                        "message_from": "System Services",
                                        "message_body": _this3.paga_merchant.paga_service_group_merchant_displayName + " Merchant Paga Payment Failed- " + data.body.message + ". PAGA Response Code: " + data.body.responseCode + "."
                                    };
                                    service.postMessages(_this3, msg).then(function (data) {});
                                }

                                _this3.data_error_message = _this3.paga_merchant.paga_service_group_merchant_displayName + "  Payment could not be proccessed. ...reloading CNpay";

                                _this3.paga_merchant.serviceToPay.servicePrice = _this3.paga_merchant.serviceToPay.servicePrice_store;
                                _this3.disable_btn = false;

                                var _self2 = _this3;
                                setTimeout(function () {
                                    $('#paywith').modal("hide");
                                    _self2.reset();
                                }, 30000);
                            }
                        }).catch(function (err) {});
                    } else {
                        this.disable_btn = false;
                    }
                }

                if (service_for == 'MOBILEOPS') {
                    var re_phone = /^\d{4}\d{3}\d{4}$/;
                    var _phone_test = re_phone.test(String(this.paga_airtime_request.phone_no).toLowerCase());
                    if (this.paga_airtime_request.amount == " " || _phone_test == false) {
                        if (_phone_test == false) {
                            this.data_error_message = "Phone Number seems incorrect.";
                        } else {
                            this.data_error_message = "Some errors were found in your form. Please, fill correctly.";
                        }
                        data_test = false;
                        this.disable_btn = false;
                    } else {
                        data_test = true;
                        this.data_error_message = "";
                    }
                    if (this.paga_airtime_request.amount == '' || this.paga_airtime_request.amount == undefined) {
                        data_test = false;
                        this.disable_btn = false;
                        this.data_error_message = "Enter Amount";
                    } else {
                        if (this.paga_airtime_request.amount < 50) {
                            data_test = false;
                            this.disable_btn = false;
                            this.data_error_message = "Enter Minimum Amount of 50.";
                        }
                    }

                    if (data_test) {
                        var _self3 = this;

                        service_amt = parseFloat(this.paga_airtime_request.amount);

                        this.paga_merchant.serviceToPay.serviceName = this.paga_merchant.paga_service_group_mobile_operatorName + "--" + this.paga_airtime_request.phone_no;
                        this.paga_merchant.serviceToPay.servicePrice = this.paga_airtime_request.amount;

                        if (this.paga_merchant.paga_service_group_merchant_commission_type == 'P') {
                            paga_proc_fee = parseFloat(this.paga_merchant.paga_service_group_merchant_commission / 100 * service_amt);
                        }
                        if (this.paga_merchant.paga_service_group_merchant_commission_type == 'C') {
                            paga_proc_fee = parseFloat(this.paga_merchant.paga_service_group_merchant_commission);
                        }

                        this.total_fee = parseFloat(service_amt + paga_proc_fee);
                        this.service_charge = paga_proc_fee;
                        this.disable_btn = false;
                        this.login_script = false;
                        this.setPayWithOption = true;

                        $('#paywith').modal();
                    } else {
                        this.disable_btn = false;
                    }
                }

                if (service_for == 'MOBILEDATA') {
                    var re_phone = /^\d{4}\d{3}\d{4}$/;
                    var _phone_test2 = re_phone.test(String(this.paga_bundle_request.phone_no).toLowerCase());
                    if (_phone_test2 == false) {
                        this.data_error_message = "Phone Number seems incorrect.";
                        data_test = false;
                        this.disable_btn = false;
                    } else {
                        data_test = true;
                        this.data_error_message = "";
                    }

                    if (data_test) {
                        if (this.paga_merchant.serviceToPay.servicePrice > 0) {
                            service_amt = parseFloat(this.paga_merchant.serviceToPay.servicePrice);

                            this.paga_merchant.serviceToPay.serviceName = this.paga_merchant.serviceToPay.serviceName + "--" + this.paga_bundle_request.phone_no;

                            if (this.paga_merchant.paga_service_group_merchant_commission_type == 'P') {
                                paga_proc_fee = parseFloat(this.paga_merchant.paga_service_group_merchant_commission / 100 * service_amt);
                            }
                            if (this.paga_merchant.paga_service_group_merchant_commission_type == 'C') {
                                paga_proc_fee = parseFloat(this.paga_merchant.paga_service_group_merchant_commission);
                            }

                            this.total_fee = parseFloat(service_amt + paga_proc_fee);
                            this.service_charge = paga_proc_fee;
                            this.disable_btn = false;
                            this.login_script = false;
                            this.setPayWithOption = true;

                            $('#paywith').modal();
                        }
                    } else {
                        this.disable_btn = false;
                    }
                }
            } else {
                this.disable_btn = false;

                if (this.paga_merchant.serviceToPay.servicePrice_store == 0) {
                    this.resetServiceToPayAmount();
                }
            }
        },
        prepPagaProcessPayment: function prepPagaProcessPayment(pay_with_option) {
            this.disable_btn = true;
            this.disable_btn_wallet = true;
            var data_test = false;

            if (this.loggedIn) {
                this.setCustomerDetails();

                data_test = true;
            } else {
                data_test = true;
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                var email_test = re.test(String(this.customer.customerEmail).toLowerCase());

                if (this.customer.customerName != '' && this.customer.customerName != undefined) {
                    var name_split = this.customer.customerName.split(" ");
                    this.customer.customerFirstName = name_split[0];
                    this.customer.customerLastName = name_split[1];
                    if (this.customer.customerLastName == undefined) {
                        this.customer.customerLastName = this.customer.customerFirstName;
                    }
                } else {
                    this.customer.customerFirstName = "Nil";
                    this.customer.customerLastName = "Nil";
                }

                if (email_test == false) {
                    data_test = false;
                    this.data_error_message = "Your Email is not correct. Please, fill correctly";
                } else {
                    data_test = true;
                    this.data_error_message = "";
                }
            }
            if (data_test) {
                if (pay_with_option == "gateway") {
                    this.processPagaPayment();
                } else {
                    this.processPagaPaymentWithWallet();
                }
            }
        },
        processPagaPayment: function processPagaPayment() {
            var self = this;
            var test_mode = false;
            if (test_mode) {
                console.log("test_mode: chilling here");
                if (self.is_paga_merchant_purchase) {
                    self.payPagaMerchantServices();
                }
                if (self.is_paga_mobileops_purchase) {
                    self.payPagaPurchaseAirtime();
                }
            } else {
                var _self4 = this;

                var x = getpaidSetup({
                    PBFPubKey: service.ravepay_public_live_paga,
                    customer_email: _self4.customer.customerEmail,
                    amount: _self4.total_fee,
                    customer_phone: _self4.customer.customerPhoneNumber,
                    currency: "NGN",
                    payment_method: "both",
                    txref: "CNpayPG-" + this.today.getTime(),
                    meta: [{
                        metaname: "CNpayPG",
                        metavalue: _self4.customer.customerFirstName + " " + _self4.customer.customerLastName
                    }],
                    onclose: function onclose() {
                        _self4.reset_payment_flow();
                        setTimeout(function () {}, 20000);
                    },
                    callback: function callback(response) {
                        var txref = response.tx.txRef;
                        var tx_amount = response.tx.amount;
                        if (response.tx.chargeResponseCode == "00" || response.tx.chargeResponseCode == "0") {
                            _self4.processing = true;

                            var payload = {
                                "SECKEY": service.ravepay_secret_live_paga,
                                "txref": txref
                            };
                            service.verifyRavePayment(_self4, payload).then(function (response) {
                                if (response.body.data.status === "successful" && response.body.data.chargecode == "00") {
                                    _self4.payment_message = "Payment processed successfully.";

                                    if (response.body.data.amount === tx_amount) {
                                        var _txref = "CNpayPG-" + _self4.today.getTime();
                                        var _tx_amount = _self4.total_fee;

                                        var txn_payload = {
                                            "txn_ref": _txref,
                                            "paga_merchant": _self4.paga_merchant.paga_service_group_merchant_id,
                                            "paga_merchant_name": _self4.paga_service_group_merchant_displayName || _self4.paga_service_group_mobile_operatorName,
                                            "paga_merchant_service_group": _self4.paga_merchant.paga_service_group_merchant_service_group,
                                            "paga_merchant_service_name": _self4.paga_merchant.serviceToPay.serviceName,
                                            "paga_merchant_service_price": _self4.paga_merchant.serviceToPay.servicePrice,
                                            "paga_merchant_service_commission": _self4.paga_merchant.paga_service_group_merchant_commission,
                                            "payercodeAtBiller": _self4.customer.customerCodeAtBiller || "Nil",
                                            "payerfirstname": _self4.customer.customerFirstName || "Nil",
                                            "payerlastname": _self4.customer.customerLastName || "Nil",
                                            "payeremail": _self4.customer.customerEmail,
                                            "payerphonenumber": _self4.customer.customerPhoneNumber || _self4.paga_airtime_request.phone_no || _self4.paga_bundle_request.phone_no,
                                            "total_paid_amt": _tx_amount,
                                            "payer_logged": _self4.loggedIn,
                                            "payer_user_id": _self4.user.user_id || 0
                                        };

                                        service.postCNpayPagaPaymentDetails(_self4, txn_payload).then(function (response) {
                                            _self4.cnpay_post_txn_id = response.body.txn;
                                            _self4.cnpay_post_txn_ref = response.body.txn_ref;
                                            if (_self4.is_paga_merchant_purchase) {
                                                _self4.payPagaMerchantServices();
                                            }
                                            if (_self4.is_paga_mobileops_purchase) {
                                                _self4.payPagaPurchaseAirtime();
                                            }
                                            var txn_payload00 = {
                                                "transaction_payment_ref": _txref,
                                                "transaction_module": 20,
                                                "transaction_module_id": _self4.cnpay_post_txn_id,
                                                "transaction_type": 8,
                                                "transaction_mode": 1,
                                                "transaction_mode_transaction_ref": _txref,
                                                "transaction_amount_paid": _tx_amount,
                                                "payer_name": _self4.customer.customerFirstName + _self4.customer.customerLastName || "",
                                                "payer_email": _self4.customer.customerEmail || "",
                                                "payer_phone": _self4.customer.customerPhoneNumber || 0,
                                                "payer_user": _self4.user.user_id || 0
                                            };

                                            _self4.postCNpaymentDetails(txn_payload00);
                                        }).catch(function (err) {});
                                    }
                                }
                            }).catch(function (err) {});
                        } else {
                            _self4.payment_message = service.service_payment_failed;
                        }
                    }
                });
            }
        },
        processPagaPaymentWithWallet: function processPagaPaymentWithWallet() {
            var _this4 = this;

            this.disable_btn_wallet = true;
            var tx_amount = this.total_fee;
            var tx_ref = "CNpayPG-" + this.today.getTime();

            var self = this;

            var payload = {
                pay: this.user.user_id,
                txn_amount: tx_amount,
                service: 6,
                service_paga: this.paga_merchant.paga_service_group_merchant_id,
                service_transaction_name: this.paga_merchant.serviceToPay.serviceName,
                service_ref: tx_ref
            };
            var test_mode = false;
            if (test_mode) {
                console.log("test_mode: chilling here");
                if (self.is_paga_merchant_purchase) {
                    self.payPagaMerchantServices();
                }
                if (self.is_paga_mobileops_purchase) {
                    self.payPagaPurchaseAirtime();
                }
            } else {
                service.postWalletPayout(this, payload).then(function (response) {
                    if (response.body.status == 201) {
                        var txn_payload = {
                            "txn_ref": tx_ref,
                            "paga_merchant": self.paga_merchant.paga_service_group_merchant_id,
                            "paga_merchant_name": self.paga_service_group_merchant_displayName || self.paga_service_group_mobile_operatorName,
                            "paga_merchant_service_group": self.paga_merchant.paga_service_group_merchant_service_group,
                            "paga_merchant_service_name": self.paga_merchant.serviceToPay.serviceName,
                            "paga_merchant_service_price": self.paga_merchant.serviceToPay.servicePrice,
                            "paga_merchant_service_commission": self.paga_merchant.paga_service_group_merchant_commission,
                            "payercodeAtBiller": self.customer.customerCodeAtBiller || "Nil",
                            "payerfirstname": self.customer.customerFirstName || "Nil",
                            "payerlastname": self.customer.customerLastName || "Nil",
                            "payeremail": self.customer.customerEmail || "Nil",
                            "payerphonenumber": self.customer.customerPhoneNumber || "Nil",
                            "total_paid_amt": tx_amount,
                            "payer_logged": _this4.loggedIn,
                            "payer_user_id": _this4.user.user_id || 0
                        };

                        service.postCNpayPagaPaymentDetails(self, txn_payload).then(function (response) {
                            self.cnpay_post_txn_id = response.body.txn;
                            self.cnpay_post_txn_ref = response.body.txn_ref;
                            if (self.is_paga_merchant_purchase) {
                                self.payPagaMerchantServices();
                            }
                            if (self.is_paga_mobileops_purchase) {
                                self.payPagaPurchaseAirtime();
                            }

                            var txref = response.body.data_txn_ref;
                            var txn_payload00 = {
                                "transaction_payment_ref": tx_ref,
                                "transaction_module": 20,
                                "transaction_module_id": self.cnpay_post_txn_id,
                                "transaction_type": 8,
                                "transaction_mode": 2,
                                "transaction_mode_transaction_ref": txref,
                                "transaction_amount_paid": tx_amount,
                                "payer_name": self.customer.customerFirstName + self.customer.customerLastName || "",
                                "payer_email": self.customer.customerEmail || "",
                                "payer_phone": self.customer.customerPhoneNumber || 0,
                                "payer_user": self.user.user_id || 0
                            };

                            self.postCNpaymentDetails(txn_payload00);
                        }).catch(function (err) {});
                    } else {
                        _this4.payment_message = service.service_payment_failed;
                    }
                }).catch(function (err) {
                    if (err) {}
                });
            }
        },
        getPagaServiceGroups: function getPagaServiceGroups() {
            var _this5 = this;

            this.loading = true;
            service.getPagaServiceGroups(this).then(function (data) {
                _this5.paga_service_groups = data.body.data;
                _this5.loading = false;

                _this5.getPagaDataBundles();
            }).catch(function (err) {
                if (err) {}
            });
        },
        getPagaMerchants: function getPagaMerchants() {
            var seek_url = service.paga_apiBaseUrl + 'getMerchants';
            var hash = service.SHA512("" + service.paga_apiKey);
            var payload = {
                "referenceNumber": this.getDefaultRandomNumbers()
            };
            service.getPagaRequest(this, payload, seek_url, hash).then(function (data) {
                if (data.body.responseCode == 0) {
                    console.log(3466);
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        getPagaMerchantServices: function getPagaMerchantServices(merchant, show_loading) {
            var _this6 = this;

            this.reset();
            this.paga_merchant = merchant;
            this.paga_merchant.loading = true;

            var seek_url = service.paga_apiBaseUrl + 'getMerchantServices';
            var hash = "";
            var payload = {
                "referenceNumber": this.getDefaultRandomNumbers(),
                "merchantPublicId": merchant.paga_service_group_merchant_billerPublicId
            };
            hash = service.SHA512(payload.referenceNumber + payload.merchantPublicId + service.paga_apiKey);
            service.getPagaRequest(this, payload, seek_url, hash).then(function (data) {
                if (data.body.responseCode == 0) {
                    _this6.paga_merchant.services = [];
                    var dataload = data.body.services;
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(dataload), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var load = _step.value;

                            load.serviceName = load.name;
                            load.servicePrice = load.price;

                            _this6.paga_merchant.services.push(load);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }

                    _this6.getServiceSavedData(merchant.paga_service_group_merchant_id);
                    _this6.show_paga_service_details = true;
                    _this6.is_paga_merchant_purchase = true;
                    _this6.scrollToTop();
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        getPagaDataBundles: function getPagaDataBundles() {
            var _this7 = this;

            var seek_url = service.paga_apiBaseUrl + "getDataBundleByOperator";
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.paga_service_groups), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var group = _step2.value;

                    if (group.paga_service_group_for == 'MOBILEOPS') {
                        var _loop = function _loop(paga_merchant) {
                            payload = {
                                "referenceNumber": _this7.getDefaultRandomNumbers(),
                                "operatorPublicId": paga_merchant.paga_service_group_mobile_operatorPublicId
                            };

                            var hash = "";
                            hash = service.SHA512(payload.referenceNumber + payload.operatorPublicId + service.paga_apiKey);
                            service.getPagaRequest(_this7, payload, seek_url, hash).then(function (data) {
                                if (data.body.responseCode == 0) {
                                    paga_merchant.dataBundles = data.body.mobileOperatorServices;
                                } else {
                                    paga_merchant.dataBundles = [];
                                }
                            }).catch(function (err) {});
                        };

                        var _iteratorNormalCompletion3 = true;
                        var _didIteratorError3 = false;
                        var _iteratorError3 = undefined;

                        try {
                            for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(group.paga_service_group_merchants), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                                var paga_merchant = _step3.value;
                                var payload;

                                _loop(paga_merchant);
                            }
                        } catch (err) {
                            _didIteratorError3 = true;
                            _iteratorError3 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                    _iterator3.return();
                                }
                            } finally {
                                if (_didIteratorError3) {
                                    throw _iteratorError3;
                                }
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
        },
        payPagaMerchantServices: function payPagaMerchantServices() {
            var _this8 = this;

            var seek_url = service.paga_apiBaseUrl + 'merchantPayment';

            var payload = {
                "merchantReferenceNumber": this.customer.customerCodeAtBiller,
                "amount": this.paga_merchant.serviceToPay.servicePrice,
                "merchantAccount": this.paga_merchant.paga_service_group_merchant_billerPublicId,
                "referenceNumber": this.cnpay_post_txn_ref,
                "currency": "NGN",
                "merchantService": [this.paga_merchant.serviceToPay.code],
                "locale": "NG"
            };

            var hash = service.SHA512(payload.referenceNumber + payload.amount + payload.merchantAccount + payload.merchantReferenceNumber + service.paga_apiKey);

            var self = this;

            var test_mode = false;
            if (test_mode) {
                console.log("test_mode: chilling here");

                var recharge_token = "1111111111111111111111111111111";
                var formatted_voucher = recharge_token.match(/.{1,4}/g).join('-');

                self.payment_service_message = "Token: " + formatted_voucher;
                self.afterProcessing(0, service.service_payment_circle_fully_successful);

                if (self.save_service_data_prompt) {
                    var set_payload = {
                        "merchant": self.paga_merchant.paga_service_group_merchant_id,
                        "merchant_service_id": self.paga_merchant.serviceToPay.serviceId || 0,
                        "merchant_number": self.customer.customerCodeAtBiller,
                        "merchant_number_name": self.customer_received_details.customerName,
                        "merchant_user": self.user.user_id || 0
                    };

                    self.prepSaveServiceData(set_payload);
                }

                var set_details = {
                    "payment_merchant_name": self.paga_merchant.paga_service_group_merchant_displayName,
                    "payment_merchant_logo": self.paga_merchant.paga_service_group_merchant_attached_image,
                    "payment_merchant_service": self.paga_merchant.serviceToPay.serviceName,
                    "payment_merchant_code_number": self.customer.customerCodeAtBiller,
                    "payment_payer_merchant_name": self.customer_received_details.customerName || '',
                    "payment_payer_merchant_address": self.customer_received_details.serviceAddress || '',
                    "payment_amount": self.paga_merchant.serviceToPay.servicePrice,
                    "payment_date": new Date().toJSON().slice(0, 10).replace(/-/g, '/'),
                    "payment_formatted_token_voucher": formatted_voucher || 0,
                    "payment_merchant_service_purchased_units": '',
                    "payment_merchant_service_purchased_unitType": '',
                    "payment_merchant_service_purchased_units_type": '1Units' };
                self.payment_receipt_details = set_details;
            } else {
                service.getPagaRequest(self, payload, seek_url, hash).then(function (data) {
                    if (data.body.responseCode != 0) {
                        if (data.body.responseCode == -1) {
                            _this8.data_error_message = "Please review your details, Amount to purchase may be too low";
                            _this8.disable_btn_wallet = false;
                            _this8.disable_btn = false;
                            _this8.paga_merchant.serviceToPay.servicePrice = 0;
                        } else if (data.body.responseCode == 38051) {
                            _this8.data_error_message = "Please review your details, the Amount to Purchase does not match";
                        } else {
                            _this8.data_error_message = "Payment could not be processed. Please review your details";
                            _this8.disable_btn_wallet = false;
                            _this8.disable_btn = false;
                            _this8.afterProcessingSendMessage(data.body.responseCode);
                        }

                        _this8.setPayWithOption = false;
                    } else {
                        var paga_merchant_service_purchased_units = '';
                        var paga_merchant_service_purchased_unitType = '';
                        var paga_merchant_service_purchased_units_type = '';

                        if (data.body.transactionId && (data.body.transactionId != '' || data.body.transactionId != null)) {
                            var _recharge_token = "";
                            var _formatted_voucher = "";

                            if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(data.body.additionalProperties).length > 0) {
                                var prp_data = data.body.additionalProperties;
                                _recharge_token = prp_data.token;
                                _formatted_voucher = _recharge_token.match(/.{1,4}/g).join('-');

                                if (prp_data.units && prp_data.units != '') {
                                    paga_merchant_service_purchased_units = prp_data.units;
                                }
                                if (prp_data.unitType && prp_data.unitType != '') {
                                    paga_merchant_service_purchased_unitType = prp_data.unitType;
                                }
                                paga_merchant_service_purchased_units_type = paga_merchant_service_purchased_units + " " + paga_merchant_service_purchased_unitType;
                            }

                            self.payment_service_message = "Recharge Token: " + _formatted_voucher;

                            if (self.save_service_data_prompt) {
                                var set_payload = {
                                    "merchant": self.paga_merchant.paga_service_group_merchant_id,
                                    "merchant_service_id": self.paga_merchant.serviceToPay.serviceId || 0,
                                    "merchant_number": self.customer.customerCodeAtBiller,
                                    "merchant_number_name": self.customer_received_details.customerName,
                                    "merchant_user": self.user.user_id || 0
                                };

                                self.prepSaveServiceData(set_payload);
                            }

                            var set_details = {
                                "payment_merchant_name": self.paga_merchant.paga_service_group_merchant_displayName,
                                "payment_merchant_logo": self.paga_merchant.paga_service_group_merchant_attached_image,
                                "payment_merchant_service": self.paga_merchant.serviceToPay.serviceName,
                                "payment_merchant_code_number": self.customer.customerCodeAtBiller,
                                "payment_payer_merchant_name": self.customer_received_details.customerName || '',
                                "payment_payer_merchant_address": self.customer_received_details.serviceAddress || '',
                                "payment_amount": self.paga_merchant.serviceToPay.servicePrice,
                                "payment_date": new Date().toJSON().slice(0, 10).replace(/-/g, '/'),
                                "payment_formatted_token_voucher": _formatted_voucher || 0,
                                "payment_merchant_service_purchased_units": paga_merchant_service_purchased_units || '',
                                "payment_merchant_service_purchased_unitType": paga_merchant_service_purchased_unitType || '',
                                "payment_merchant_service_purchased_units_type": paga_merchant_service_purchased_units_type || ''
                            };
                            self.payment_receipt_details = set_details;
                        } else {}

                        var payload = {
                            "paga_transaction_message": data.body.message || "Nil",
                            "paga_transaction_confirmationCode": data.body.additionalProperties.token || "Nil",
                            "paga_transaction_transactionId": data.body.transactionId || "Nil",
                            "paga_transaction_availableBalance": data.body.availableBalance || 0,
                            "paga_transaction_agentCommission": data.body.commissionEarned || 0,

                            "paga_transaction_referenceNumber": data.body.referenceNumber || "Nil",
                            "paga_transaction_amount": data.body.additionalProperties.totalPayment || 0,
                            "paga_transaction_airtime_receiverPhoneNumber": data.body.receiverPhoneNumber || "Nil",

                            "paga_merchant": self.paga_merchant.paga_service_group_merchant_id,
                            "paga_merchant_service_name": self.paga_merchant.serviceToPay.serviceName,
                            "paga_merchant_service_price": self.paga_merchant.serviceToPay.servicePrice,
                            "paga_payer_merchant_name": self.customer_received_details.customerName || '',
                            "paga_payer_merchant_address": self.customer_received_details.serviceAddress || '',
                            "paga_merchant_service_purchased_units": paga_merchant_service_purchased_units || '',
                            "paga_merchant_service_purchased_unitType": paga_merchant_service_purchased_unitType || '',
                            "payer_logged": self.loggedIn,
                            "payer_user_id": self.user.user_id || 0,
                            "txn_ref": self.cnpay_post_txn_ref

                        };

                        service.updateCNpayPagaPaymentNotification(self, self.cnpay_post_txn_id, payload).then(function (response22) {
                            self.afterProcessing(0, service.service_payment_circle_fully_successful);
                        }).catch(function (err) {
                            self.afterProcessing(1, service.service_payment_circle_not_fully_successful);
                        });
                    }
                }).catch(function (err) {
                    if (err) {}
                });
            }
        },
        payPagaPurchaseAirtime: function payPagaPurchaseAirtime() {
            this.payment_service_message = "";

            var seek_url = service.paga_apiBaseUrl + 'airtimePurchase';

            if (this.show_data_bundle) {
                var payload = {
                    "referenceNumber": this.cnpay_post_txn_ref,
                    "mobileOperatorPublicId": this.paga_merchant.paga_service_group_mobile_operatorPublicId,
                    "mobileOperatorServiceId": this.paga_bundle_request.serviceId,
                    "amount": this.paga_bundle_request.servicePrice,
                    "currency": "NGN",
                    "locale": "",
                    "destinationPhoneNumber": this.paga_bundle_request.phone_no,
                    "isSuppressRecipientMessages": true,
                    "isDataBundle": true
                };
            } else {
                var payload = {
                    "referenceNumber": this.cnpay_post_txn_ref,
                    "mobileOperatorPublicId": this.paga_merchant.paga_service_group_mobile_operatorPublicId,
                    "amount": this.paga_airtime_request.amount,
                    "currency": "NGN",
                    "locale": "",
                    "destinationPhoneNumber": this.paga_airtime_request.phone_no,
                    "isSuppressRecipientMessages": true,
                    "isDataBundle": false
                };
            }

            var hash = service.SHA512(payload.referenceNumber + payload.amount + payload.destinationPhoneNumber + service.paga_apiKey);
            var set_phone_number = payload.receiverPhoneNumber;
            var self = this;

            var test_mode = false;
            if (test_mode) {
                console.log("test_mode: chilling here");
                self.payment_service_message = "Voucher: 1111111111111111111111111111111";
                self.afterProcessing(0, service.service_payment_circle_fully_successful);

                if (self.save_service_data_prompt) {
                    var set_payload = {
                        "merchant": self.paga_merchant.paga_service_group_merchant_id,
                        "merchant_service_id": 0,
                        "merchant_number": set_phone_number,
                        "merchant_number_name": "",
                        "merchant_user": self.user.user_id || 0
                    };
                    self.prepSaveServiceData(set_payload);
                }

                var set_details = {
                    payment_merchant_name: self.paga_merchant.paga_service_group_merchant_displayName,
                    payment_merchant_logo: self.paga_service_group_merchant_attached_image,
                    payment_merchant_service: self.paga_merchant.serviceToPay.serviceName,
                    payment_merchant_code_number: set_phone_number,
                    payment_payer_merchant_name: '',
                    payment_payer_merchant_address: '',
                    payment_amount: self.paga_merchant.serviceToPay.servicePrice,
                    payment_date: new Date().toJSON().slice(0, 10).replace(/-/g, '/'),
                    payment_formatted_token_voucher: 0
                };
                self.payment_receipt_details = set_details;
            } else {
                service.getPagaRequest(self, payload, seek_url, hash).then(function (data) {
                    if (data.body.responseCode == 0) {
                        if (self.save_service_data_prompt) {
                            var set_payload = {
                                "merchant": self.paga_merchant.paga_service_group_merchant_id,
                                "merchant_service_id": 0,
                                "merchant_number": set_phone_number,
                                "merchant_number_name": "",
                                "merchant_user": self.user.user_id || 0
                            };
                            self.prepSaveServiceData(set_payload);
                        }

                        var set_details = {
                            payment_merchant_name: self.paga_merchant.paga_service_group_merchant_displayName,
                            payment_merchant_logo: self.paga_service_group_merchant_attached_image,
                            payment_merchant_service: self.paga_merchant.serviceToPay.serviceName,
                            payment_merchant_code_number: set_phone_number,
                            payment_payer_merchant_name: '',
                            payment_payer_merchant_address: '',
                            payment_amount: self.paga_merchant.serviceToPay.servicePrice,
                            payment_date: new Date().toJSON().slice(0, 10).replace(/-/g, '/'),
                            payment_formatted_token_voucher: 0
                        };
                        self.payment_receipt_details = set_details;

                        var payload = {
                            "paga_transaction_referenceNumber": data.body.referenceNumber || "Nil",
                            "paga_transaction_amount": self.paga_merchant.serviceToPay.servicePrice || 0,
                            "paga_transaction_airtime_receiverPhoneNumber": data.body.receiverPhoneNumber || "Nil",
                            "paga_transaction_message": data.body.message || "Nil",
                            "paga_transaction_confirmationCode": data.body.token || "Nil",
                            "paga_transaction_transactionId": data.body.transactionId || "Nil",
                            "paga_transaction_availableBalance": data.body.availableBalance || 0,
                            "paga_transaction_agentCommission": data.body.commissionEarned || 0,

                            "paga_merchant": self.paga_merchant.paga_service_group_merchant_id,
                            "paga_merchant_service_name": self.paga_merchant.serviceToPay.serviceName,
                            "paga_merchant_service_price": self.paga_merchant.serviceToPay.servicePrice,
                            "paga_payer_merchant_name": self.customer_received_details.customerName || '',
                            "paga_payer_merchant_address": self.customer_received_details.serviceAddress || '',
                            "paga_merchant_service_purchased_units": '',
                            "paga_merchant_service_purchased_unitType": '',
                            "payer_logged": self.loggedIn,
                            "payer_user_id": self.user.user_id || 0,
                            "txn_ref": self.cnpay_post_txn_ref
                        };

                        service.updateCNpayPagaPaymentNotification(self, self.cnpay_post_txn_id, payload).then(function (response22) {
                            self.afterProcessing(0, service.service_payment_circle_fully_successful);
                        }).catch(function (err) {
                            self.afterProcessing(1, service.service_payment_circle_not_fully_successful);
                        });
                    } else {
                        self.afterProcessing(1, service.service_purchase_failed);

                        self.afterProcessingSendMessage(data.body.responseCode);
                    }
                }).catch(function (err) {
                    if (err) {}
                });
            }
        },
        getServiceSavedData: function getServiceSavedData(merchant) {
            var self = this;
            localforage.getItem("saved_services_data", function (err, value) {
                if (value != undefined) {
                    var match = [];
                    var _iteratorNormalCompletion4 = true;
                    var _didIteratorError4 = false;
                    var _iteratorError4 = undefined;

                    try {
                        for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(value), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                            var row = _step4.value;

                            if (row.merchant == merchant) {
                                match.push(row);
                            }
                        }
                    } catch (err) {
                        _didIteratorError4 = true;
                        _iteratorError4 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion4 && _iterator4.return) {
                                _iterator4.return();
                            }
                        } finally {
                            if (_didIteratorError4) {
                                throw _iteratorError4;
                            }
                        }
                    }

                    self.set_service_saved_data = match;
                }
            }).catch(function (err) {});
        },
        prepSaveServiceData: function prepSaveServiceData(payload) {
            var can_add = false;

            var self = this;

            if (payload.merchant_number != '' && payload.merchant_number != undefined) {
                localforage.getItem("saved_services_data", function (err, value) {
                    if (value != undefined) {
                        var is_added = false;
                        var _iteratorNormalCompletion5 = true;
                        var _didIteratorError5 = false;
                        var _iteratorError5 = undefined;

                        try {
                            for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(value), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                                var row = _step5.value;

                                if (row.merchant == payload.merchant && row.merchant_number == payload.merchant_number) {
                                    is_added = true;
                                }
                            }
                        } catch (err) {
                            _didIteratorError5 = true;
                            _iteratorError5 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion5 && _iterator5.return) {
                                    _iterator5.return();
                                }
                            } finally {
                                if (_didIteratorError5) {
                                    throw _iteratorError5;
                                }
                            }
                        }

                        if (!is_added) {
                            self.saveServiceData(payload);
                        }
                    } else {
                        self.saveServiceData(payload);
                    }
                });
            }
        },
        saveServiceData: function saveServiceData(payload) {
            var _this9 = this;

            if (payload.merchant_number != '' && payload.merchant_number != undefined) {
                if (payload.merchant_user > 0) {
                    service.saveServiceData(this, payload).then(function (response) {
                        console.log("saved");

                        _this9.setSavedServiceDataLocal(response.body.data, 1);
                    }).catch(function (err) {
                        console.log(err);
                    });
                } else {
                    this.setSavedServiceDataLocal(payload, 2);
                }
            }
        },
        setSavedServiceDataLocal: function setSavedServiceDataLocal(data, save_type) {
            if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(data).length > 0) {
                if (save_type == 1) {
                    localforage.setItem("saved_services_data", data).then(function (value) {}).catch(function (err) {});
                } else if (save_type == 2) {
                    localforage.getItem("saved_services_data", function (err, value) {
                        if (value != undefined) {
                            value.push(data);

                            localforage.setItem("saved_services_data", value).then(function (value) {}).catch(function (err) {});
                        } else {
                            var base_arr = [];
                            base_arr.push(data);
                            localforage.setItem("saved_services_data", base_arr).then(function (value) {}).catch(function (err) {});
                        }
                    }).catch(function (err) {
                        var base_arr = [];
                        base_arr.push(data);
                        localforage.setItem("saved_services_data", base_arr).then(function (value) {}).catch(function (err) {});
                    });
                }
            }
        },
        getSavedServiceDataLocal: function getSavedServiceDataLocal() {
            var self = this;
            localforage.getItem("saved_services_data", function (err, value) {
                if (value != undefined) {
                    self.saved_services_data = value;
                }
            });
        },
        getSavedServiceData: function getSavedServiceData() {
            var _this10 = this;

            if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.user).length > 0 && this.user.user_id > 0) {
                service.getSavedServiceData(this, this.user.user_id).then(function (response) {
                    var data = response.body.data;
                    _this10.saved_services_data = data;

                    _this10.setSavedServiceDataLocal(data, 1);
                }).catch(function (err) {});
            } else {
                this.getSavedServiceDataLocal();
            }
        },
        afterProcessing: function afterProcessing(status, msg) {
            this.transaction_processed_reload = true;

            var self = this;
            self.payment_message = msg;
            var save_msg = self.payment_service_message;
            setTimeout(function () {
                if (status == 0) {}
                if (status == 1) {}
            }, 10000);
        },
        afterProcessingSendMessage: function afterProcessingSendMessage(error_code) {
            var self = this;

            var service_merchant_name = self.paga_service_group_merchant_displayName || self.paga_service_group_mobile_operatorName || '';
            var service_merchant_service_name = self.paga_merchant.serviceToPay.serviceName;
            var service_merchant_service_price = self.paga_merchant.serviceToPay.servicePrice;
            var service_cnpay_post_pay_txn_ref = self.cnpay_post_txn_ref;
            var msg = {
                "message_from": "Service Purchase From PAGA Failed",
                "message_body": "Service Purchase Details " + service_merchant_name + " - " + service_merchant_service_name + " Amount: " + service_merchant_service_price + " Ref: " + service_cnpay_post_pay_txn_ref + " Buyer Email: " + self.customer.customerEmail + " PAGA Response Code: " + error_code + ". Please reconcile"
            };
            service.postMessages(this, msg).then(function (data) {});
        },
        getCNpayCharges: function getCNpayCharges() {
            var _this11 = this;

            service.getCNpayCharges(this).then(function (response) {
                _this11.range_1_max = response.body.r1max;
                _this11.range_2_max = response.body.r2max;
                _this11.range_1_pay = response.body.r1pay;
                _this11.range_2_pay = response.body.r2pay;
                _this11.range_3_pay = response.body.r3pay;
                _this11.ravecomm = response.body.ravecomm / 100;
            }).catch(function (err) {});
        },
        getWalletBalance: function getWalletBalance() {
            var _this12 = this;

            var user_id = localStorage.getItem("cityneeds_token_key");
            service.getWalletBalance(this, user_id).then(function (data) {
                if (data.body.status == 200) {
                    _this12.current_wallet_balance = data.body.data_current_wallet_balance;
                    localStorage.setItem("cityneeds_wb", _this12.current_wallet_balance);
                    _this12.headerKey++;
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        formatCurrency: function formatCurrency(currency) {
            currency = Intl.NumberFormat('en-US', { style: 'currency', currency: 'NGN' }).format(currency);
            currency = currency.replace("₦", "");
            currency = currency.replace("NGN", "");
            return currency;
        },
        formatCurrency_2: function formatCurrency_2(currency) {
            currency = Intl.NumberFormat('en-US', { style: 'currency', currency: 'NGN' }).format(currency);
            currency = currency.replace("₦", "");
            currency = currency.replace("NGN", "");
            currency = currency.replace(".00", "");
            return currency;
        },
        login: function login() {
            var _this13 = this;

            this.disable_btn_login = true;
            var credentials = {
                user_email: this.user.email,
                user_password: this.user.password
            };
            var navi = this.$router;
            if (credentials.user_email == null || credentials.user_email == undefined || credentials.user_email == '') {
                toastr.warning("Kindly enter email", 'Warning!');
            } else if (credentials.user_password == null || credentials.user_password == undefined || credentials.user_password == '') {
                toastr.warning("Kindly enter password", 'Warning!');
            } else {
                service.loginUser(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            localStorage.setItem("cityneeds_user", element.user_fullname);
                            localStorage.setItem("cityneeds_token", element.user_session_key);
                            localStorage.setItem("cityneeds_token_key", element.user_token_key);
                        }, _this13);

                        _this13.getWalletBalance();
                        _this13.loggedIn = true;

                        $('#login').modal("hide");

                        _this13.preset();
                    } else {
                        toastr.warning("invalid login credentials", 'Warning!');
                        _this13.disable_btn_login = false;
                    }
                }).catch(function (err) {
                    if (err.status == 404) {
                        toastr.warning("invalid login credentials", 'Warning!');
                        _this13.disable_btn_login = false;
                        _this13.disable_btn = false;
                    } else {
                        toastr.error("Please Re-try Once More", 'Warning!');

                        _this13.disable_btn_login = false;
                        _this13.disable_btn = false;
                    }
                });
            }
        },
        preset: function preset() {
            var _this15 = this;

            this.headerKey++;
            var credentials = {
                session_key: localStorage.getItem("cityneeds_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            var _this14 = this;

                            this.user.user_id = element.user_id;
                            this.loggedIn = true;
                            this.getWalletBalance();

                            this.getSavedServiceData();

                            service.getUser(this, element.user_id).then(function (data) {
                                if (data.body.status == 200) {
                                    _this14.user_details = data.body.data;
                                    _this14.setCustomerDetails();
                                }
                            }).catch(function (err) {
                                if (err) {}
                            });
                        }, _this15);
                    } else {
                        localStorage.removeItem("cityneeds_wb");
                    }
                }).catch(function (err) {
                    if (err) {}
                });
            } else {}
        },
        setCustomerDetails: function setCustomerDetails() {
            if (this.loggedIn) {
                this.customer.customerName = this.user_details.user_fullname;
                this.customer.customerFirstName = this.user_details.user_fullname.split(" ")[0];
                this.customer.customerLastName = this.user_details.user_fullname.split(" ")[1] || "";
                this.customer.customerEmail = this.user_details.user_email;
                this.customer.customerPhoneNumber = this.user_details.user_phone;
            }
            if (!this.customer.customerCodeAtBiller) {
                this.customer.customerCodeAtBiller = '';
            }
        },
        promptTopUpWallet: function promptTopUpWallet() {
            $("#topup").modal();
        },
        getWalletProcessingCharges: function getWalletProcessingCharges() {
            var _this16 = this;

            service.getWalletProcessingChargesRF(this).then(function (data) {
                _this16.wallet_charges = data.body.data;
                _this16.min_wallet_topup_amount = data.body.data_min_wallet_topup_amount;
                _this16.max_wallet_topup_amount = data.body.data_max_wallet_topup_amount;
            }).catch(function (err) {
                if (err) {}
            });
        },
        getWalletTransactions: function getWalletTransactions() {
            var _this17 = this;

            var user_id = localStorage.getItem("cityneeds_token_key");
            service.getWalletTransactions(this, user_id).then(function (data) {
                if (data.body.status == 200) {
                    _this17.current_wallet_balance = data.body.data_current_wallet_balance;
                    localStorage.setItem("cityneeds_wb", _this17.current_wallet_balance);
                }
                _this17.wallet_transactions = data.body.data;
                _this17.loading = false;
            }).catch(function (err) {
                if (err) {}
            });
        },
        prepareWalletPayment: function prepareWalletPayment() {
            if (this.wallet_transaction.topay_amt == null) {
                toastr.error('Amount is empty', 'Warning!');
            } else {
                this.wallet_transaction.topay_amt = parseFloat(this.wallet_transaction.topay_amt);

                if (this.wallet_transaction.topay_amt > this.max_wallet_topup_amount) {
                    this.wallet_payment_error_message = 'Maximum Topup amount exceeded';
                    toastr.error('Maximum Topup amount exceeded', 'Warning!');
                } else if (this.wallet_transaction.topay_amt < this.min_wallet_topup_amount) {
                    this.wallet_payment_error_message = 'Minimum Topup amount is 100NGN';
                    toastr.error('Minimum Topup amount is 100', 'Warning!');
                } else {
                    this.wallet_charges.forEach(function (element) {
                        if (this.wallet_transaction.topay_amt >= element.wallet_charge_min && this.wallet_transaction.topay_amt <= element.wallet_charge_max) {
                            this.wallet_transaction.processing_fee = element.wallet_charge_charge;
                        }
                    }, this);
                    this.wallet_payment_calculated = true;
                }
            }
        },
        makePayment: function makePayment() {
            var _this18 = this;

            this.disable_topup_wallet_btn = true;
            var user_id = localStorage.getItem("cityneeds_token_key");
            var payload = {
                "user": user_id,
                "service": 2 };
            service.setUserPaymentDetails(this, payload).then(function (data) {
                _this18.payment_details = data.body.data;

                _this18.processWalletPayment();
            }).catch(function (err) {
                if (err) {}
            });
        },
        processWalletPayment: function processWalletPayment() {
            var self = this;
            var x = getpaidSetup({
                PBFPubKey: "FLWPUBK-8b636e40e721ae65285c678950808ef5-X",
                customer_email: self.payment_details.payer_email,
                amount: self.wallet_transaction.topay_amt + self.wallet_transaction.processing_fee,
                customer_phone: self.payment_details.payer_phone,
                currency: "NGN",
                payment_method: "both",
                txref: "CNwallet-" + self.payment_details.payer_txn_ref,
                meta: [{
                    metaname: "CNwallet",
                    metavalue: self.payment_details.payer_name
                }],
                onclose: function onclose() {},
                callback: function callback(response) {
                    var txref = response.tx.txRef;
                    var tx_amount = response.tx.amount;
                    if (response.tx.chargeResponseCode == "00" || response.tx.chargeResponseCode == "0") {
                        self.processing = true;

                        var txn_payload = {
                            "txn_ref": txref,
                            "pay": self.user.user_id,
                            "txn_amount": self.wallet_transaction.topay_amt,
                            "processing_fee": self.wallet_transaction.processing_fee,
                            "topup_by_admin": 0,
                            "total_amount": tx_amount
                        };

                        service.postWalletTopup(self, txn_payload).then(function (response) {
                            self.wallet_payment_message = "You have successfully topped up your CNwallet with ₦" + self.wallet_transaction.topay_amt;
                            self.loading = true;
                            self.disable_topup_wallet_btn = false;
                            setTimeout(function () {

                                self.closeModal('#topup');
                            }, 4000);

                            self.getWalletTransactions();
                        }).catch(function (err) {});
                    } else {
                        self.wallet_payment_message = "Payment unsuccessfull. please try again or contact us";
                    }

                    x.close();
                }
            });
        },
        getPagaAccountBalance: function getPagaAccountBalance() {
            var seek_url = service.paga_apiBaseUrl + "accountBalance";
            var payload = {
                "referenceNumber": new Date().getTime(),
                "locale": " "
            };

            var hash = service.SHA512(payload.referenceNumber + service.paga_apiKey);

            var self = this;
            service.getPagaRequest(self, payload, seek_url, hash).then(function (data) {
                if (data.body.responseCode == 0) {}
            }).catch(function (err) {});
        },
        getDefaultRandomNumbers: function getDefaultRandomNumbers() {
            return Math.floor(100000000 + Math.random() * 900000000);
        },
        deleteSaved: function deleteSaved(index) {},
        printDiv: function printDiv(divId, title) {

            var mywindow = window.open('', 'PRINT', 'height=650,width=900,top=100,left=150');

            mywindow.document.write('<html><head><title>' + title + '</title>');
            mywindow.document.write('</head><body >');
            mywindow.document.write(document.getElementById(divId).innerHTML);
            mywindow.document.write('</body></html>');

            mywindow.document.close();
            mywindow.focus();

            mywindow.print();
            mywindow.close();

            return true;
        },
        saveDiv: function saveDiv(divId, title) {
            this.downloading = true;
            var d_divId = document.getElementById(divId);
            var d_position = d_divId.getBoundingClientRect();
            var HTML_Width = d_position.width;
            var HTML_Height = d_position.height;

            var element = document.getElementById(divId);
            var opt = {
                margin: 1,
                filename: title + '.pdf',
                image: { type: 'jpeg', quality: 0.98 },
                html2canvas: { allowTaint: true, useCORS: true, scale: 2 },

                jsPDF: { unit: 'mm', format: [312, 592], orientation: 'portrait' }
            };

            var self = this;
            html2pdf().set(opt).from(element).save().then(function () {
                console.log('saving');
                setTimeout(function () {
                    self.downloading = false;
                }, 2500);
            });
        }
    },

    created: function created() {
        this.reset();
        this.getPagaMerchants();

        if (this.$route.query.login == 'login') {
            setTimeout(function () {
                $('#login').modal();

                window.history.pushState(null, null, '/');
            }, 500);
        } else {
            if (localStorage.getItem("cityneeds_token_key") != undefined) {
                this.preset();
            } else {
                this.login_script = true;
                setTimeout(function () {
                    $('#login').modal();
                }, 4000);
            }
        }

        this.getCNpayCharges();
        this.getPagaServiceGroups();

        this.getWalletProcessingCharges();

        this.getPagaAccountBalance();
    }

});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Main_Footer_index_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Main_Footer_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Main_Footer_index_vue__);



var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Login',
    data: function data() {
        return {
            user: {},
            disable_btn: false,
            forgot_processed: false,
            activation_error_message: false
        };
    },

    components: {
        'second-header': __WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue___default.a,
        'main-footer': __WEBPACK_IMPORTED_MODULE_2__Main_Footer_index_vue___default.a
    },
    methods: {
        reset: function reset() {
            var _this = this;

            localStorage.removeItem("cityneeds_user");
            localStorage.removeItem("cityneeds_token");
            localStorage.removeItem("cityneeds_token_key");

            this.$router.push('/');
            if (this.$route.query.activation) {
                var credentials = { "user_auth": this.$route.query.activation };
                service.activateEmail(this, credentials).then(function (response) {
                    if (response.status == 200) {
                        toastr.success("Email Activation Successfull", 'Kudos!');
                    }
                }).catch(function (err) {
                    _this.activation_error_message = true;
                    toastr.warning("Email Activation Failed", 'Warning!');
                });
            }
        },
        activateSignal: function activateSignal() {},
        login: function login() {
            var _this2 = this;

            this.disable_btn = true;
            var credentials = {
                user_email: this.user.email,
                user_password: this.user.password
            };
            var navi = this.$router;
            if (credentials.user_email == null || credentials.user_email == undefined || credentials.user_email == '') {
                toastr.warning("Kindly enter email", 'Warning!');
            } else if (credentials.user_password == null || credentials.user_password == undefined || credentials.user_password == '') {
                toastr.warning("Kindly enter password", 'Warning!');
            } else {
                service.loginUser(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            localStorage.setItem("cityneeds_user", element.user_fullname);
                            localStorage.setItem("cityneeds_token", element.user_session_key);
                            localStorage.setItem("cityneeds_token_key", element.user_token_key);
                        }, _this2);

                        navi.push('/');
                    } else {
                        toastr.warning("invalid login credentials", 'Warning!');
                        _this2.disable_btn = false;
                    }
                }).catch(function (err) {
                    if (err.status == 404) {
                        toastr.warning("invalid login credentials", 'Warning!');
                        _this2.disable_btn = false;
                    } else {
                        toastr.warning("Please Re-try Once More", 'Warning!');

                        _this2.disable_btn = false;
                    }
                });
            }
        },
        forgotPassword: function forgotPassword() {
            var _this3 = this;

            var credentials = {
                email: this.user.email
            };

            if (credentials.email == null || credentials.email == undefined || credentials.email == '') {
                toastr.warning("Kindly enter email", 'Warning!');
            } else {
                service.forgotPassword(this, credentials).then(function (response) {
                    if (response.status == 200) {
                        _this3.forgot_processed = true;
                    }
                }).catch(function (err) {
                    if (err.status == 404) {
                        toastr.warning("Email not valid", 'Warning!');
                    }
                });
            }
        },
        resetForgot: function resetForgot() {
            this.forgot_processed = false;
        },
        verifyEmail: function verifyEmail() {
            var _this4 = this;

            var credentials = {
                email: this.user.email,
                auth: this.user.auth
            };

            if (credentials.email == null || credentials.email == undefined || credentials.email == '') {
                toastr.warning("Validation Failed", 'Warning!');
            } else if (credentials.auth == null || credentials.auth == undefined || credentials.auth == '') {
                toastr.warning("Validation Failed", 'Warning!');
            } else {
                service.verifyEmail(this, credentials).then(function (response) {
                    if (response.status == 200) {
                        var data = response.body.data;

                        _this4.$router.push('login');
                    }
                }).catch(function (err) {
                    if (err.status == 404) {
                        toastr.warning("invalid credentials", 'Warning!');
                        _this4.$router.push('login');
                    }
                });
            }
        }
    },
    created: function created() {
        this.reset();
    }
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);

var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: "MainFooter",
    data: function data() {
        return {
            user: {},
            user_slug: {},
            mainSiteUrl: service.mainSiteUrl,
            this_year: service.thisYear
        };
    }
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);

var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: "SecondHeader",
    data: function data() {
        return {
            user: {},
            user_slug: {},
            current_wallet_balance: 0
        };
    },

    methods: {
        formatCurrency: function formatCurrency(currency) {
            currency = Intl.NumberFormat('en-US', { style: 'currency', currency: 'NGN' }).format(currency);
            currency = currency.replace("₦", "");
            currency = currency.replace("NGN", "");
            return currency;
        },
        getUser: function getUser() {
            var u = localStorage.getItem("cityneeds_user");
            if (u != null) {
                this.user = u;
                this.user_slug = u.replace(" ", "_");
                this.current_wallet_balance = localStorage.getItem("cityneeds_wb");
            } else {
                this.user = null;

                localStorage.removeItem("cityneeds_wb");
            }
        }
    },
    created: function created() {
        this.getUser();
    }
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);

var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: "Sidebar",
    data: function data() {
        return {
            forums: {},
            forum: {},
            search: {},
            survey: {},
            surveys: [],
            pageNotSurvey: true,
            siteUrl: service.siteUrl + "?title=",
            cnproParentCategories: {},
            sub_categories: {}
        };
    },


    methods: {
        copyLink: function copyLink(survey) {
            this.$clipboard(this.siteUrl + survey.cnsurvey_title_url);
            var btn = $('.linky').tooltip({
                trigger: 'click',
                placement: 'bottom'
            });
            this.setTooltip(btn, 'Copied to Clipboard');
            this.hideTooltip(btn);
        },
        setTooltip: function setTooltip(btn, message) {
            btn.tooltip('hide').attr('data-original-title', message).tooltip('show');
        },
        hideTooltip: function hideTooltip(btn) {
            setTimeout(function () {
                btn.tooltip('hide');
            }, 1000);
        },
        setForum: function setForum(forum) {
            localStorage.setItem("cn_f", forum);
            this.$router.push("/forum");
        },
        getSurveys: function getSurveys() {
            var _this = this;

            service.getAllSurveys(this, 0, 1).then(function (res) {
                _this.surveys = res.body.data;
            });
        },
        getAllForums: function getAllForums() {
            var _this2 = this;

            service.getAllForums(this).then(function (data) {
                if (data.body.status == 200) {
                    _this2.forums = data.body.data;
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        checkCurrentPage: function checkCurrentPage() {
            if (this.$route.path != '/cnsurveys') {
                this.pageNotSurvey = true;
            } else {
                this.pageNotSurvey = false;
            }
        },
        getCnproParentCategories: function getCnproParentCategories() {
            var _this3 = this;

            service.getCnproParentCategories(this).then(function (data) {
                if (data.body.status == 200) {
                    _this3.cnproParentCategories = data.body.data;
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        getCnproSubCategories: function getCnproSubCategories(parent) {
            var _this4 = this;

            service.getCnproCategories(this, parent).then(function (data) {
                if (data.body.status == 200) {
                    _this4.sub_categories = data.body.data;
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        getBusinessCategories: function getBusinessCategories() {
            var _this5 = this;

            service.getBusinessCategories(this).then(function (data) {
                if (data.body.status == 200) {
                    _this5.sub_categories = data.body.data;
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        prep_sub_categories: function prep_sub_categories(parent) {
            if (parent == "business-search") {
                this.search.type = 'business-search';
                this.getBusinessCategories();
            } else {
                this.search.type = 'cnpro-search';
                this.getCnproSubCategories(parent);
            }
        },
        prep_search: function prep_search(keywords) {
            this.search.keywords = keywords;
            this.search.city = 'Abuja';
        },
        doSearch: function doSearch() {
            var credentials = {
                search_type: this.search.type,
                search_keywords: this.search.keywords,
                search_city: this.search.city
            };

            var navi = this.$router;

            if (credentials.search_type != null || credentials.search_keywords != null) {
                navi.push(this.search.type + '?context=' + this.search.keywords + '&city=' + this.search.city);
            } else {
                toastr.error('Kindly fill all fields', 'Warning!');
            }
        }
    },
    created: function created() {
        this.getAllForums();
        this.getSurveys();
        this.checkCurrentPage();
        this.getCnproParentCategories();
    }
});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Main_Footer_index_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Main_Footer_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Main_Footer_index_vue__);




var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'CNwallet',
    data: function data() {
        return {
            user: {},
            payment_details: {},
            wallet_charges: {},
            wallet_transaction: {},
            wallet_transactions: {},
            current_wallet_balance: 0,
            bank: {},
            to_pay_out: 0,
            amount_paid: '',
            wallet_payment_message: '',
            wallet_payment_error_message: '',
            min_wallet_topup_amount: 100,
            max_wallet_topup_amount: 10000,
            wallet_payment_calculated: false,
            loading: true,
            disable_btn: false
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__Second_Header_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_2__Main_Footer_index_vue___default.a
    },
    methods: {
        setPanel: function setPanel() {
            this.panelFlag = true;
        },
        isActive: function isActive(index) {
            if (index == 1) {
                return "active";
            }
        },
        formatCurrency: function formatCurrency(currency) {
            currency = Intl.NumberFormat('en-US', { style: 'currency', currency: 'NGN' }).format(currency);
            currency = currency.replace("₦", "");
            currency = currency.replace("NGN", "");
            return currency;
        },
        closeModal: function closeModal(modal) {
            $(modal).modal("hide");

            this.wallet_transaction = {};
            this.wallet_payment_calculated = false;
            this.wallet_payment_message = '';
            this.wallet_payment_error_message = '';
        },
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("cityneeds_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                        }, _this);
                    } else {
                        _this.$router.push('login');
                    }
                }).catch(function (err) {
                    if (err) {
                        _this.$router.push('login');
                    }
                });
            } else {
                this.$router.push('login');
            }
        },
        setWalletTransaction: function setWalletTransaction(txn) {
            this.wallet_transaction = txn;
        },
        getWalletProcessingCharges: function getWalletProcessingCharges() {
            var _this2 = this;

            service.getWalletProcessingChargesRF(this).then(function (data) {
                _this2.wallet_charges = data.body.data;
                _this2.min_wallet_topup_amount = data.body.data_min_wallet_topup_amount;
                _this2.max_wallet_topup_amount = data.body.data_max_wallet_topup_amount;
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        getWalletTransactions: function getWalletTransactions() {
            var _this3 = this;

            var user_id = localStorage.getItem("cityneeds_token_key");
            service.getWalletTransactions(this, user_id).then(function (data) {
                if (data.body.status == 200) {
                    _this3.current_wallet_balance = data.body.data_current_wallet_balance;
                    localStorage.setItem("cityneeds_wb", _this3.current_wallet_balance);
                }
                _this3.wallet_transactions = data.body.data;
                _this3.loading = false;
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        prepareWalletPayment: function prepareWalletPayment() {
            if (this.wallet_transaction.topay_amt == null) {
                toastr.error('Amount is empty', 'Warning!');
            } else {
                this.wallet_transaction.topay_amt = parseFloat(this.wallet_transaction.topay_amt);

                if (this.wallet_transaction.topay_amt > this.max_wallet_topup_amount) {
                    this.wallet_payment_error_message = 'Maximum Topup amount exceeded';
                    toastr.error('Maximum Topup amount exceeded', 'Warning!');
                } else if (this.wallet_transaction.topay_amt < this.min_wallet_topup_amount) {
                    this.wallet_payment_error_message = 'Minimum Topup amount is 100NGN';
                    toastr.error('Minimum Topup amount is 100', 'Warning!');
                } else {
                    this.wallet_charges.forEach(function (element) {
                        if (this.wallet_transaction.topay_amt >= element.wallet_charge_min && this.wallet_transaction.topay_amt <= element.wallet_charge_max) {
                            this.wallet_transaction.processing_fee = element.wallet_charge_charge;
                        }
                    }, this);
                    this.wallet_payment_calculated = true;
                }
            }
        },
        makePayment: function makePayment() {
            var _this4 = this;

            this.disable_btn = true;
            var user_id = localStorage.getItem("cityneeds_token_key");
            var payload = {
                "user": user_id,
                "service": 2 };
            service.setUserPaymentDetails(this, payload).then(function (data) {
                _this4.payment_details = data.body.data;

                _this4.processPayment();
            }).catch(function (err) {
                if (err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            });
        },
        processPaymentXX: function processPaymentXX() {
            var self = this;
            var txref = self.payment_details.payer_txn_ref;
            var tx_amount = self.wallet_transaction.topay_amt + self.wallet_transaction.processing_fee;
            var txn_payload = {
                "txn_ref": txref,
                "pay": self.user.user_id,
                "txn_amount": self.wallet_transaction.topay_amt,
                "processing_fee": self.wallet_transaction.processing_fee,
                "topup_by_admin": 0,
                "total_amount": tx_amount
            };

            service.postWalletTopup(self, txn_payload).then(function (response) {
                self.disable_btn = false;
                self.wallet_payment_message = "You have successfully topped up your CNwallet with ₦" + self.wallet_transaction.topay_amt;
                self.loading = true;
                setTimeout(function () {

                    self.closeModal('#topup');
                }, 4000);

                self.getWalletTransactions();
            }).catch(function (err) {});
        },
        processPayment: function processPayment() {
            var self = this;
            var x = getpaidSetup({
                PBFPubKey: "FLWPUBK-8b636e40e721ae65285c678950808ef5-X",
                customer_email: self.payment_details.payer_email,
                amount: self.wallet_transaction.topay_amt + self.wallet_transaction.processing_fee,
                customer_phone: self.payment_details.payer_phone,
                currency: "NGN",
                payment_method: "both",
                txref: "CNwallet-" + self.payment_details.payer_txn_ref,
                meta: [{
                    metaname: "CNwallet",
                    metavalue: self.payment_details.payer_name
                }],
                onclose: function onclose() {},
                callback: function callback(response) {
                    var txref = response.tx.txRef;
                    var tx_amount = response.tx.amount;
                    if (response.tx.chargeResponseCode == "00" || response.tx.chargeResponseCode == "0") {
                        self.processing = true;

                        var txn_payload = {
                            "txn_ref": txref,
                            "pay": self.user.user_id,
                            "txn_amount": self.wallet_transaction.topay_amt,
                            "processing_fee": self.wallet_transaction.processing_fee,
                            "topup_by_admin": 0,
                            "total_amount": tx_amount
                        };

                        service.postWalletTopup(self, txn_payload).then(function (response) {
                            self.wallet_payment_message = "You have successfully topped up your CNwallet with ₦" + self.wallet_transaction.topay_amt;
                            self.loading = true;
                            self.disable_btn = false;
                            setTimeout(function () {

                                self.closeModal('#topup');
                            }, 4000);

                            self.getWalletTransactions();
                        }).catch(function (err) {});
                    } else {
                        self.wallet_payment_message = "Payment unsuccessfull. please try again or contact us";
                    }

                    x.close();
                }
            });
        }
    },
    created: function created() {
        this.preset();
        this.getWalletProcessingCharges();
        this.getWalletTransactions();
    }
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__dirname) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_resource__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vee_validate__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vee_validate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vee_validate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_progressbar__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_progressbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_progressbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_meta__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_meta___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_meta__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_v_clipboard__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_v_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_v_clipboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_CNpay_index_vue__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_CNpay_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_CNpay_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Login_index_vue__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Login_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Login_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Wallet_index_vue__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Wallet_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_Wallet_index_vue__);













__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_v_clipboard___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_meta___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vee_validate___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_progressbar___default.a, {
  color: 'rgb(143, 255, 199)',
  failedColor: 'red',
  height: '5px'
});


var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  base: __dirname,
  routes: [{ path: '/', name: 'CNpay', component: __WEBPACK_IMPORTED_MODULE_7__components_CNpay_index_vue___default.a }, { path: '/login', name: 'Login', component: __WEBPACK_IMPORTED_MODULE_8__components_Login_index_vue___default.a }, { path: '/rewards', name: 'Wallet', component: __WEBPACK_IMPORTED_MODULE_9__components_Wallet_index_vue___default.a }, { path: '*', redirect: '/' }]
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  router: router,
  template: '\n    <div id="app">\n      <vue-progress-bar></vue-progress-bar>\n      <router-view></router-view>\n    </div>\n    '
}).$mount('#app');
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "/"))

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var _class = function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, _class);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(_class, [{
        key: "validateEmail",
        value: function validateEmail(email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        }
    }, {
        key: "validateName",
        value: function validateName(name) {
            var re = /^[\w\-\s]+$/;
            return re.test(name);
        }
    }, {
        key: "validatePhoneNumber",
        value: function validatePhoneNumber(phone) {
            var re = /^\d{4}\d{3}\d{4}$/;
            return re.test(phone);
        }
    }, {
        key: "validateWebsite",
        value: function validateWebsite(url) {
            var re = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/;
            return re.test(url);
        }
    }]);

    return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 89 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 90 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 91 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 92 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 93 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 94 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(92)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(43),
  /* template */
  __webpack_require__(104),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(44),
  /* template */
  __webpack_require__(100),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(45),
  /* template */
  __webpack_require__(107),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(93)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(50),
  /* template */
  __webpack_require__(105),
  /* scopeId */
  "data-v-770f6bd1",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "header-wrapper"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "header-inner"
  }, [_c('div', {
    staticClass: "header-logo"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "7em"
    },
    attrs: {
      "src": "static/assets/img/cnpay-logo.png",
      "alt": "Logo"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "header-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "header-bottom"
  }, [_c('div', {
    staticClass: "pull-left hidden-lg hidden-md",
    staticStyle: {
      "padding-top": "1em",
      "font-size": "18px"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/rewards",
      "title": "My Rewards"
    }
  }, [_vm._v(" \r\n                                        ₦" + _vm._s(_vm.formatCurrency(_vm.current_wallet_balance)) + " "), _c('i', {
    staticClass: "fa fa-credit-card"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#22baae"
    }
  }, [_vm._v("Rewards ")]), _c('span', {
    staticStyle: {
      "color": "#daa520"
    }
  }, [_vm._v("Balance")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "pull-right hidden-sm hidden-xs",
    staticStyle: {
      "padding-top": "1em",
      "font-size": "18px"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/rewards",
      "title": "My Rewards"
    }
  }, [_vm._v(" \r\n                                        ₦" + _vm._s(_vm.formatCurrency(_vm.current_wallet_balance)) + " "), _c('i', {
    staticClass: "fa fa-credit-card"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#22baae"
    }
  }, [_vm._v("Rewards ")]), _c('span', {
    staticStyle: {
      "color": "#daa520"
    }
  }, [_vm._v("Balance")])])])], 1), _vm._v(" "), _c('ul', {
    staticClass: "header-nav-primary nav nav-pills collapse navbar-collapse"
  }, [(_vm.user != null || _vm.user != undefined) ? [_c('li', [(_vm.user != '') ? _c('router-link', {
    attrs: {
      "to": "'"
    }
  }, [_vm._v("Hello, " + _vm._s(_vm.user) + " "), _c('i', {
    staticClass: "fa fa-chevron-down"
  })]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu"
  }, [_vm._m(1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "login"
    }
  }, [_vm._v("Logout")])], 1)])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/rewards"
    }
  }, [_vm._v("My Rewards")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Pay Bills, Buy Airtime ")])], 1)] : [_vm._m(2), _vm._v(" "), _vm._m(3)]], 2), _vm._v(" "), _vm._m(4)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-top"
  }, [_c('ul', {
    staticClass: "header-nav-social social-links nav nav-pills"
  }, [_c('li', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://twitter.com/cityneedsng"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://web.facebook.com/cityneeds/"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": " https://www.instagram.com/cityneeds/"
    }
  }, [_c('i', {
    staticClass: "fa fa-instagram"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://linkedin.com/in/cityneeds-technologies-00b090138"
    }
  }, [_c('i', {
    staticClass: "fa fa-linkedin"
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "https://cityneeds.ng/dashboard",
      "target": "_blank"
    }
  }, [_vm._v("View Account")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "/?login=login"
    }
  }, [_vm._v("Log In")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "https://cityneeds.ng/register",
      "target": "_blank"
    }
  }, [_vm._v("Sign Up    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "navbar-toggle collapsed",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": ".header-nav-primary"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })])
}]}

/***/ }),
/* 100 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 col-lg-12",
    staticStyle: {
      "margin-top": "5em"
    }
  }, [_c('div', {
    staticClass: "sidebar"
  }, [_c('div', {
    staticClass: "col-md-4 widget"
  }, [_c('h2', {
    staticClass: "widgettitle"
  }, [_vm._v("Trending Forums")]), _vm._v(" "), _c('div', _vm._l((_vm.forums), function(forum, index) {
    return _c('ul', {
      key: forum,
      staticClass: "list-group"
    }, [_c('a', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: ((index) < 6),
        expression: "(index) < 6"
      }],
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.setForum(forum.forum_id)
        }
      }
    }, [_c('li', {
      staticClass: "list-group-item"
    }, [_c('span', {
      staticClass: "badge",
      staticStyle: {
        "background-color": "#22baae"
      }
    }, [_vm._v(_vm._s(forum.forum_comments.length))]), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#333"
      }
    }, [_vm._v(_vm._s(forum.forum_topic))])])])])
  }))]), _vm._v(" "), (_vm.pageNotSurvey) ? _c('div', {
    staticClass: "col-md-4 widget"
  }, [_c('h2', {
    staticClass: "widgettitle"
  }, [_vm._v("Trending Live Poll")]), _vm._v(" "), _vm._l((_vm.surveys), function(survey, index) {
    return _c('div', {
      key: index
    }, [_c('router-link', {
      attrs: {
        "to": "/cnsurveys"
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: ((index) < 1),
        expression: "(index) < 1"
      }],
      staticClass: "panel panel-poll"
    }, [_c('div', {
      staticClass: "panel-heading"
    }, [_c('b', [_vm._v(_vm._s(survey.cnsurvey_title))])]), _vm._v(" "), _c('div', {
      staticClass: "panel-body"
    }, _vm._l((survey.cnsurveys_questions), function(svq, index2) {
      return _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (index2 === survey.cnsurvey_question_index),
          expression: "index2 === survey.cnsurvey_question_index"
        }],
        key: index2
      }, [_c('p', [_c('b', [_vm._v(_vm._s(svq.cnsurvey_question))])]), _vm._v(" "), _vm._l((svq.cnsurveys_option), function(opt) {
        return _c('div', {
          key: opt,
          staticClass: "options"
        }, [_c('div', [_c('div', {
          staticClass: "radio"
        }, [_c('input', {
          attrs: {
            "id": "op",
            "type": "radio"
          },
          domProps: {
            "value": opt.cnsurvey_option_id
          }
        }), _c('label', [_vm._v(_vm._s(opt.cnsurvey_option_option))])])])])
      }), _vm._v(" "), _c('button', {
        staticClass: "btn btn-xs btn-default pull-right",
        on: {
          "click": function($event) {
            _vm.next(index, index2)
          }
        }
      }, [_vm._v("Next")]), _vm._v(" "), _c('div', {
        staticStyle: {
          "margin-top": "1em"
        }
      }, [_c('br'), _c('br'), (survey.cnsurvey_business != 0) ? _c('p', {
        staticStyle: {
          "font-size": "11px"
        }
      }, [_vm._v("Survey by: " + _vm._s(survey.cnsurvey_business_name))]) : _vm._e()])], 2)
    }))])])], 1)
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 widget hidden-xs"
  }, [_c('h2', {
    staticClass: "widgettitle"
  }, [_vm._v("Search Listings")]), _vm._v(" "), _c('div', {
    staticClass: "detail-enquire-form background-white p20"
  }, [_c('form', [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.parent),
      expression: "search.parent"
    }],
    staticClass: "search-select form-control",
    attrs: {
      "title": "Location"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.search.parent = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.prep_sub_categories(_vm.search.parent)
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("What do you want to find today?")]), _vm._v(" "), _vm._l((_vm.cnproParentCategories), function(cc) {
    return _c('option', {
      key: cc.cnpro_parent_category_id,
      domProps: {
        "value": cc.cnpro_parent_category_id
      }
    }, [_vm._v(_vm._s(cc.cnpro_parent_category_name))])
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "business-search"
    }
  }, [_vm._v("Businesses")])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.search.type != 'business-search') ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.area),
      expression: "search.area"
    }],
    staticClass: "search-select form-control",
    attrs: {
      "title": "Location"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.search.area = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.prep_search(_vm.search.area)
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Which of these services in particular")]), _vm._v(" "), _vm._l((_vm.sub_categories), function(cc) {
    return _c('option', {
      key: cc.cnpro_category_name,
      domProps: {
        "value": cc.cnpro_category_name
      }
    }, [_vm._v(_vm._s(cc.cnpro_category_name))])
  })], 2) : _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.area),
      expression: "search.area"
    }],
    staticClass: "search-select form-control",
    attrs: {
      "title": "Location"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.search.area = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.prep_search(_vm.search.area)
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Which of these services in particular")]), _vm._v(" "), _vm._l((_vm.sub_categories), function(cc) {
    return _c('option', {
      key: cc.business_category_name,
      domProps: {
        "value": cc.business_category_name
      }
    }, [_vm._v(_vm._s(cc.business_category_name))])
  })], 2)]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.doSearch
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search\n                                         ")])])])])])])
},staticRenderFns: []}

/***/ }),
/* 101 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrapper",
    attrs: {
      "id": "topwrap"
    }
  }, [_c('div', {
    attrs: {
      "id": "destination"
    }
  }), _vm._v(" "), _c('second-header', {
    key: _vm.headerKey
  }), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "main-inner"
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "margin-top": "-4em"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.onboarding) ? _c('div', {
    staticClass: "content"
  }, [_c('h3', {
    staticStyle: {
      "color": "#ff0000"
    },
    attrs: {
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.payment_message))]), _vm._v(" "), _vm._m(0), _c('br'), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e(), _vm._v(" "), (!_vm.onboarding) ? _c('div', {
    staticClass: "content"
  }, [_vm._m(3), _vm._v(" "), (_vm.show_code_details) ? _c('div', {
    staticClass: "col-sm-8 col-md-offset-2"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "static/assets/img/cnpay_banner.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-big-white"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.reset()
      }
    }
  }, [_vm._v("Back")])]), _vm._v(" "), _c('h4', [_vm._v("Your Payment Details")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("PAYER NAME: ")]), _vm._v(_vm._s(_vm.rrr_txn_details.PAYERNAME))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("RRR AMOUNT: ")]), _vm._v("₦" + _vm._s(_vm.rrr_txn_details.RRRAMOUNT))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("CHARGES: ")]), _vm._v("₦" + _vm._s(_vm.rrr_txn_details.CHARGES))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("NAME: ")]), _vm._v(_vm._s(_vm.rrr_txn_details.NAME))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("DESCRIPTION: ")]), _vm._v(_vm._s(_vm.rrr_txn_details.DESCRIPTION))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("RRR: ")]), _vm._v(_vm._s(_vm.rrr_details.RRR))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("CNpay Convenience Fee: ")]), _vm._v("₦" + _vm._s(_vm.cnpay_proc_fee))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.setProcessPayment
    }
  }, [_c('i', {
    staticClass: "fa fa-good"
  }), _vm._v(" "), (!_vm.processing) ? _c('span', [_vm._v("All OK, Continue")]) : _c('span', [_vm._v("Processing..please wait")])])])]) : _vm._e(), _vm._v(" "), (_vm.show_airtime_form_details) ? _c('div', {
    staticClass: "col-sm-8 col-md-offset-2 card-wide-bg"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "static/assets/img/cnpay_banner1.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-big-white"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.reset()
      }
    }
  }, [_vm._v("< Back")])]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [(_vm.show_data_bundle) ? _c('button', {
    staticClass: "btn btn-default pull-left",
    staticStyle: {
      "cursor": "pointer",
      "color": "inherit"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setPagaAirtimeOrDataBundle()
      }
    }
  }, [_vm._v("Buy Airtime\r\n                                        ")]) : _c('button', {
    staticClass: "btn btn-default pull-left",
    staticStyle: {
      "cursor": "pointer",
      "color": "inherit"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setPagaAirtimeOrDataBundle()
      }
    }
  }, [_vm._v("Buy Data Bundle\r\n                                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.paga_merchant.paga_service_group_merchant_max_purchase_amount && (_vm.paga_merchant.paga_service_group_merchant_max_purchase_amount > 0)) ? _c('h4', {
    staticStyle: {
      "color": "#850606",
      "font-size": "14px"
    }
  }, [_vm._v("Maximum Purchase Amount: ₦" + _vm._s(_vm.formatCurrency_2(_vm.paga_merchant.paga_service_group_merchant_max_purchase_amount)))]) : _vm._e(), _vm._v(" "), (!_vm.show_data_bundle) ? _c('div', [_c('h4', [_vm._v("Buy " + _vm._s(_vm.paga_merchant.paga_service_group_mobile_operatorName) + " Airtime")]), _vm._v(" "), _c('form', [(_vm.data_error_message != '') ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: " col-md-9",
    staticStyle: {
      "padding": "0"
    }
  }, [_vm._v("\r\n                                                    Phone Number\r\n                                                    "), _c('span', [_c('a', {
    staticStyle: {
      "color": "inherit",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.show_set_service_saved_data = true;
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-clipboard",
    staticStyle: {
      "margin-left": "10px",
      "color": "#22baae",
      "font-size": "14px"
    }
  })]), _vm._v(" "), (_vm.show_set_service_saved_data) ? _c('a', {
    staticStyle: {
      "color": "inherit",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.show_set_service_saved_data = false;
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    staticStyle: {
      "margin-left": "10px",
      "color": "#ff0000",
      "font-size": "14px"
    }
  })]) : _vm._e()])]), _vm._v(" "), (_vm.show_set_service_saved_data) ? _c('div', {
    staticStyle: {
      "margin-top": "-10px",
      "margin-left": "1em"
    }
  }, [_c('div', {
    staticStyle: {
      "clear": "both",
      "float": "left"
    }
  }, [(Object.keys(_vm.set_service_saved_data).length == 0) ? _c('p', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "12px"
    }
  }, [_vm._v("No saved data")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.set_service_saved_data), function(no, nodex) {
    return _c('div', {
      staticClass: "btn-wrapper"
    }, [(no.merchant_number != '') ? _c('button', {
      staticClass: "btn btn-22",
      on: {
        "click": function($event) {
          _vm.paga_airtime_request.phone_no = no.merchant_number;
          _vm.show_set_service_saved_data = false;
        }
      }
    }, [_vm._v(_vm._s(no.merchant_number) + "\r\n                                                            ")]) : _vm._e(), _vm._v(" "), _c('a', {
      staticStyle: {
        "color": "inherit",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.deleteSaved(nodex)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-close",
      staticStyle: {
        "margin-left": "10px",
        "color": "inherit",
        "font-size": "14px"
      }
    }), _vm._v("  ")])])
  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "clear": "both"
    }
  }, [_c('label', {
    staticClass: "en-00"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paga_airtime_request.phone_no),
      expression: "paga_airtime_request.phone_no"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "Enter phone number eg. 09088776655"
    },
    domProps: {
      "value": (_vm.paga_airtime_request.phone_no)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.paga_airtime_request.phone_no = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('label', {
    staticClass: "pull-left",
    staticStyle: {
      "background": "#22baae",
      "padding": "0em 0.3em 0.2em 0.3em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.save_service_data_prompt),
      expression: "save_service_data_prompt"
    }],
    staticStyle: {
      "display": "block !important"
    },
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.save_service_data_prompt) ? _vm._i(_vm.save_service_data_prompt, null) > -1 : (_vm.save_service_data_prompt)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.save_service_data_prompt,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.save_service_data_prompt = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.save_service_data_prompt = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.save_service_data_prompt = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: " save-no",
    staticStyle: {
      "margin-top": "-1.5em"
    }
  }, [_vm._v("  Remember this number?")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "clear": "both"
    }
  }, [_c('label', {
    staticClass: "en-00"
  }, [_vm._v("Amount\r\n                                                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paga_airtime_request.amount),
      expression: "paga_airtime_request.amount"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "Amount"
    },
    domProps: {
      "value": (_vm.paga_airtime_request.amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.paga_airtime_request.amount = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.disable_btn) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("...processing, please wait")]) : _c('button', {
    staticClass: "btn btn-primary pull-left",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setPagaProcessPayment(_vm.paga_merchant, _vm.paga_merchant.paga_service_group_merchant_service_group_type)
      }
    }
  }, [_vm._v("Enter")])])])]) : _vm._e(), _vm._v(" "), (_vm.show_data_bundle) ? _c('div', [(_vm.paga_merchant.dataBundles && (_vm.paga_merchant.dataBundles.length != 0)) ? _c('div', [_c('h4', [_vm._v("Select " + _vm._s(_vm.paga_merchant.paga_service_group_merchant_displayName) + " Data Bundle")]), _vm._v(" "), _vm._l((_vm.paga_merchant.dataBundles), function(service, index) {
    return _c('div', {
      staticClass: "col-md-4 col-sm-12"
    }, [_c('div', {
      staticClass: "card-links-wrap-box"
    }, [_c('li', {
      staticClass: "card-links-wrap"
    }, [_c('a', {
      staticClass: "card-links",
      on: {
        "click": function($event) {
          _vm.prepDataBundleSetPagaProcessPayment(service, 'MOBILEDATA')
        }
      }
    }, [_vm._v("\r\n                                                            " + _vm._s(service.serviceName)), (service.servicePrice != 0) ? _c('span', [_vm._v(" - ₦" + _vm._s(service.servicePrice))]) : _vm._e()]), _vm._v(" "), (_vm.show_data_bundle_phone_number_field && (_vm.paga_merchant.serviceToPay.serviceId == service.serviceId)) ? _c('div', {
      key: _vm.dataBundleComponentKey,
      staticClass: " card-links-wrap-box-2",
      staticStyle: {
        "height": "200px"
      }
    }, [(_vm.data_error_message != '') ? _c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v(_vm._s(_vm.data_error_message))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: " col-md-9",
      staticStyle: {
        "padding": "0"
      }
    }, [_vm._v("\r\n                                                                    Phone Number\r\n                                                                    "), _c('span', [_c('a', {
      staticStyle: {
        "color": "inherit",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.show_set_service_saved_data = true;
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-clipboard",
      staticStyle: {
        "margin-left": "10px",
        "color": "#22baae",
        "font-size": "14px"
      }
    })]), _vm._v(" "), (_vm.show_set_service_saved_data) ? _c('a', {
      staticStyle: {
        "color": "inherit",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.show_set_service_saved_data = false;
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-close",
      staticStyle: {
        "margin-left": "6px",
        "color": "#ff0000",
        "font-size": "14px"
      }
    })]) : _vm._e()])]), _vm._v(" "), (_vm.show_set_service_saved_data) ? _c('div', {
      staticStyle: {
        "clear": "both",
        "margin-top": "-10px",
        "margin-left": "1em"
      }
    }, [_c('div', {
      staticStyle: {
        "clear": "both",
        "float": "left"
      }
    }, [(Object.keys(_vm.set_service_saved_data).length == 0) ? _c('p', {
      staticStyle: {
        "color": "#ff0000",
        "font-size": "12px"
      }
    }, [_vm._v("No saved data")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.set_service_saved_data), function(no, nodex) {
      return _c('div', {
        staticClass: "btn-wrapper"
      }, [_vm._l((_vm.set_service_saved_data), function(no) {
        return (no.merchant_number != '') ? _c('button', {
          staticClass: "btn btn-22",
          on: {
            "click": function($event) {
              _vm.paga_bundle_request.phone_no = no.merchant_number;
              _vm.show_set_service_saved_data = false;
            }
          }
        }, [_vm._v(_vm._s(no.merchant_number))]) : _vm._e()
      }), _vm._v(" "), _c('a', {
        staticStyle: {
          "color": "inherit",
          "cursor": "pointer"
        },
        on: {
          "click": function($event) {
            _vm.deleteSaved(nodex)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-close",
        staticStyle: {
          "margin-left": "10px",
          "color": "inherit",
          "font-size": "14px"
        }
      }), _vm._v("  ")])], 2)
    })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both",
        "float": "left"
      }
    }, [_c('label', {
      staticClass: "en-00"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.paga_bundle_request.phone_no),
        expression: "paga_bundle_request.phone_no"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "placeholder": "Enter phone number eg. 09088776655"
      },
      domProps: {
        "value": (_vm.paga_bundle_request.phone_no)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.paga_bundle_request.phone_no = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-top": "5px"
      }
    }, [_c('label', {
      staticClass: "pull-left",
      staticStyle: {
        "background": "#22baae",
        "padding": "0em 0.3em 0.2em 0.3em"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.save_service_data_prompt),
        expression: "save_service_data_prompt"
      }],
      staticStyle: {
        "display": "block !important"
      },
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(_vm.save_service_data_prompt) ? _vm._i(_vm.save_service_data_prompt, null) > -1 : (_vm.save_service_data_prompt)
      },
      on: {
        "__c": function($event) {
          var $$a = _vm.save_service_data_prompt,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.save_service_data_prompt = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.save_service_data_prompt = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.save_service_data_prompt = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: " save-no",
      staticStyle: {
        "margin-top": "-1.5em"
      }
    }, [_vm._v("  Remember this number?")])])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "form-group",
      staticStyle: {
        "margin-top": "1em"
      }
    }, [(_vm.disable_btn) ? _c('button', {
      staticClass: "btn btn-primary btn-xs",
      attrs: {
        "type": "button"
      }
    }, [_vm._v("...processing, please wait")]) : _c('button', {
      staticClass: "btn btn-primary btn-xs pull-left",
      attrs: {
        "disabled": _vm.disable_btn,
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setPagaProcessPayment(service, 'MOBILEDATA')
        }
      }
    }, [_vm._v("Send")]), _vm._v("\r\n                                                                   "), (!_vm.disable_btn) ? _c('button', {
      staticClass: "btn btn-xs btn-default",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.reset_data_bundle()
        }
      }
    }, [_vm._v("Cancel")]) : _vm._e()])]) : _vm._e()])])])
  })], 2) : _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("No " + _vm._s(_vm.paga_merchant.paga_service_group_merchant_displayName) + " Services here yet.")])])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.show_paga_service_details) ? _c('div', {
    staticClass: "col-sm-8 col-md-offset-2 card-wide-bg"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "static/assets/img/cnpay_banner1.png"
    }
  }), _vm._v(" "), _c('div', {
    key: _vm.serviceToPayComponentKey,
    staticClass: "card-big-white"
  }, [_c('div', [_c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.reset()
      }
    }
  }, [_vm._v("< Back")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.paga_merchant.services && (_vm.paga_merchant.services.length != 0)) ? _c('div', [_c('h4', [_vm._v("Select from " + _vm._s(_vm.paga_merchant.paga_service_group_merchant_displayName) + " Services")]), _vm._v(" "), _vm._l((_vm.paga_merchant.services), function(service, index) {
    return (!((_vm.paga_merchant.paga_service_group_merchant_services_do_not_display_names).includes(service.serviceName))) ? _c('div', {
      staticClass: "col-md-4 col-sm-12 card-links-wrap-box"
    }, [_c('li', {
      staticClass: "card-links-wrap"
    }, [_c('a', {
      staticClass: "card-links",
      on: {
        "click": function($event) {
          _vm.prepSetPagaProcessPayment(service, _vm.paga_merchant.paga_service_group_merchant_service_group_type)
        }
      }
    }, [_vm._v("\r\n                                                        " + _vm._s(service.serviceName)), (service.servicePrice != 0) ? _c('span', [_vm._v(" - ₦" + _vm._s(service.servicePrice))]) : _vm._e()])])]) : _vm._e()
  })], 2) : _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("No " + _vm._s(_vm.paga_merchant.paga_service_group_merchant_displayName) + " Services here yet.")])])])])]) : _vm._e(), _vm._v(" "), ((!_vm.show_paga_service_details && !_vm.show_code_details && !_vm.show_airtime_form_details)) ? _c('div', {
    staticClass: "card_wide"
  }, [(_vm.loading) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/assets/img/loader.gif"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('div', {
    staticClass: "line-card-2"
  }, [_c('p', {
    staticClass: "p-intro"
  }, [_vm._v("Make Remita Payments")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('form', {
    staticClass: "col-xs-12",
    staticStyle: {
      "padding": "0"
    }
  }, [(_vm.rrr_err_message != '') ? _c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.rrr_err_message))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rrr.rrr_code),
      expression: "rrr.rrr_code"
    }],
    staticClass: "form-control ",
    attrs: {
      "type": "text",
      "placeholder": "Enter RRR Code"
    },
    domProps: {
      "value": (_vm.rrr.rrr_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rrr.rrr_code = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-xs-12",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.processCode()
      }
    }
  }, [(!_vm.rloading) ? _c('span', {
    staticStyle: {
      "padding-right": "4px"
    }
  }, [_c('i', {
    staticClass: "fa fa-money"
  }), _vm._v("PAY NOW")]) : _c('span', [_vm._v(" Loading ... ")])])])])])]), _vm._v(" "), _vm._l((_vm.paga_service_groups), function(group) {
    return _c('div', {}, [(group.paga_service_group_for == 'MOBILEOPS') ? _c('div', {
      staticClass: "col-md-4",
      staticStyle: {
        "padding": "0"
      }
    }, [_c('div', {
      staticClass: "line-card-2"
    }, [_c('p', {
      staticClass: "p-intro"
    }, [_vm._v(_vm._s(group.paga_service_group_title))]), _vm._v(" "), _vm._l((group.paga_service_group_merchants), function(merchant, index) {
      return _c('div', {
        staticClass: "col-xs-4",
        staticStyle: {
          "padding": "2px"
        }
      }, [_c('div', {}, [_c('a', {
        staticStyle: {
          "cursor": "pointer",
          "color": "inherit"
        },
        attrs: {
          "title": merchant.paga_service_group_mobile_operatorName
        },
        on: {
          "click": function($event) {
            _vm.prepPagaAirtimeServices(merchant, ('load-xs' + index))
          }
        }
      }, [(merchant.paga_service_group_merchant_attached_image != '') ? _c('div', [_c('img', {
        staticClass: "service-pay-logo-2",
        attrs: {
          "src": _vm.img_url + merchant.paga_service_group_merchant_attached_image
        }
      })]) : _c('div', [_c('p', {
        staticClass: "service-pay-title-logo"
      }, [_vm._v(_vm._s(merchant.paga_service_group_mobile_operatorName))])]), _vm._v(" "), ((_vm.paga_merchant.paga_service_group_merchant_id == merchant.paga_service_group_merchant_id) && (_vm.paga_merchant.loading)) ? _c('div', {
        staticClass: "wn-loader-xs"
      }) : _vm._e()])])])
    }), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })], 2)]) : _vm._e()])
  }), _vm._v(" "), _vm._l((_vm.paga_service_groups), function(group) {
    return _c('div', [(group.paga_service_group_for == 'MERCHANT') ? _c('div', {
      staticClass: "col-md-4 col-xs-12",
      staticStyle: {
        "padding": "0"
      }
    }, [_c('div', {
      staticClass: "line-card-2"
    }, [_c('p', {
      staticClass: "p-intro"
    }, [_vm._v(_vm._s(group.paga_service_group_title))]), _vm._v(" "), _vm._l((group.paga_service_group_merchants), function(merchant, index) {
      return _c('div', {
        staticClass: "col-xs-4",
        staticStyle: {
          "padding": "2px"
        }
      }, [_c('div', {}, [_c('a', {
        staticStyle: {
          "cursor": "pointer",
          "color": "inherit"
        },
        attrs: {
          "title": merchant.paga_service_group_merchant_displayName
        },
        on: {
          "click": function($event) {
            _vm.getPagaMerchantServices(merchant, ('load-xs' + index))
          }
        }
      }, [(merchant.paga_service_group_merchant_attached_image != '') ? _c('span', [_c('img', {
        staticClass: "service-pay-logo-2",
        attrs: {
          "src": _vm.img_url + merchant.paga_service_group_merchant_attached_image
        }
      })]) : _c('span', [_c('p', {
        staticClass: "service-pay-title-logo"
      }, [_vm._v(_vm._s(merchant.paga_service_group_merchant_displayName))])]), _vm._v(" "), ((_vm.paga_merchant.paga_service_group_merchant_id == merchant.paga_service_group_merchant_id) && (_vm.paga_merchant.loading)) ? _c('div', {
        staticClass: "wn-loader-xs"
      }) : _vm._e()])])])
    })], 2)]) : _vm._e()])
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e()])])])])]), _vm._v(" "), _c('main-footer'), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    staticStyle: {
      "margin-top": "5em"
    },
    attrs: {
      "id": "paywith",
      "tabindex": "-10",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "border-radius": "3px"
    }
  }, [(!_vm.show_payment_receipt) ? _c('div', [_vm._m(5), _vm._v(" "), _c('button', {
    staticClass: "pull-right btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.closeModal('paywith')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('br'), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "clear": "both"
    }
  }, [(_vm.show_payment_receipt) ? _c('div', [_c('div', {
    staticStyle: {
      "width": "342px !important"
    },
    attrs: {
      "id": "paymod"
    }
  }, [_c('div', {
    staticClass: "table",
    staticStyle: {
      "margin-top": "1em",
      "color": "#000000",
      "font-weight": "bolder",
      "margin-bottom": "0.1em !important"
    }
  }, [_c('table', [_c('tr', {}, [_vm._m(6), _vm._v(" "), _c('td', [_c('div', {
    staticStyle: {
      "margin-bottom": "0.1em",
      "margin-left": "6px"
    }
  }, [(_vm.payment_receipt_details.payment_merchant_logo != '') ? _c('span', [_c('img', {
    staticStyle: {
      "height": "45px"
    },
    attrs: {
      "src": _vm.img_url + _vm.payment_receipt_details.payment_merchant_logo
    }
  })]) : _c('span', [_c('p', {
    staticClass: "service-pay-title-logo"
  }, [_vm._v(_vm._s(_vm.payment_receipt_details.payment_merchant_name))])])])])])])]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "table rctable",
    staticStyle: {
      "color": "#000000",
      "font-weight": "bolder"
    }
  }, [_c('table', [_c('tr', [_c('td', [_vm._v("Payment:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.payment_receipt_details.payment_merchant_service))])]), _vm._v(" "), (_vm.payment_receipt_details.payment_payer_merchant_name != '') ? _c('tr', [_c('td', [_vm._v("From:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.payment_receipt_details.payment_payer_merchant_name))])]) : _vm._e(), _vm._v(" "), ((_vm.payment_receipt_details.payment_merchant_code_number && (_vm.payment_receipt_details.payment_merchant_code_number != ''))) ? _c('tr', [_c('td', [_vm._v("Number:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.payment_receipt_details.payment_merchant_code_number))])]) : _vm._e(), _vm._v(" "), (_vm.payment_receipt_details.payment_payer_merchant_address != '') ? _c('tr', [_c('td', [_vm._v("Address:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.payment_receipt_details.payment_payer_merchant_address))])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Date:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.payment_receipt_details.payment_date))])]), _vm._v(" "), (_vm.payment_receipt_details.payment_formatted_token_voucher != 0) ? _c('tr', [_c('td', [_vm._v("Token:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.payment_receipt_details.payment_formatted_token_voucher))])]) : _vm._e(), _vm._v(" "), (((_vm.payment_receipt_details.payment_merchant_service_purchased_units_type) && ((_vm.payment_receipt_details.payment_merchant_service_purchased_units_type != '') || (_vm.payment_receipt_details.payment_merchant_service_purchased_units_type != undefined)))) ? _c('tr', [_c('td', [_vm._v("Units:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.payment_receipt_details.payment_merchant_service_purchased_units_type))])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Amount:")]), _vm._v(" "), _c('td', [_vm._v("₦" + _vm._s(_vm.formatCurrency(_vm.payment_receipt_details.payment_amount)))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("CNpay Charges:")]), _vm._v(" "), _c('td', [_vm._v("₦" + _vm._s(_vm.formatCurrency(_vm.service_charge)))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Total:")]), _vm._v(" "), _c('td', [_vm._v("₦" + _vm._s(_vm.formatCurrency(_vm.total_fee)))])]), _vm._v(" "), _vm._m(8)]), _vm._v(" "), _vm._m(9)])]), _vm._v(" "), _c('div', {
    staticClass: "left"
  }, [_c('button', {
    staticClass: "btn btn btn-primary btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.printDiv('paymod', 'Utility Bill Receipt')
      }
    }
  }, [_vm._v("Print")]), _vm._v("   \r\n                        "), _c('button', {
    staticClass: "btn btn btn-primary btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.saveDiv('paymod', 'Utility Bill Receipt')
      }
    }
  }, [_vm._v("Save\r\n                            "), (_vm.downloading) ? _c('span', [_c('img', {
    attrs: {
      "src": "/static/assets/img/loader.gif",
      "height": "20"
    }
  })]) : _vm._e()]), _vm._v("   \r\n                        "), _c('button', {
    staticClass: "btn btn btn-primary btn-xs",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.closeModal('paywith')
      }
    }
  }, [_vm._v("Close")])]), _vm._v(" "), _c('br'), _c('br'), _c('br')]) : _c('div', [(_vm.payment_message != '') ? _c('div', [_c('h5', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v(_vm._s(_vm.payment_message))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "14px"
    },
    attrs: {
      "align": "left"
    }
  }, [_vm._v(_vm._s(_vm.payment_service_message))]), _vm._v(" "), _c('p', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Thank you for choosing CNpay.")]), _vm._v(" "), (Object.keys(_vm.payment_receipt_details).length > 0) ? _c('div', [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.show_payment_receipt = true
      }
    }
  }, [_vm._v("View Details")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.show_code_details && _vm.payment_message == '') ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('p', [_c('b', [_vm._v("Amount to pay: ₦" + _vm._s(_vm.formatCurrency(_vm.total_fee)))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('h5', [_vm._v("Process Payment with your CNpay Rewards")]), _vm._v(" "), (_vm.loggedIn) ? _c('div', [_c('p', [_vm._v("Available Balance: ₦" + _vm._s(_vm.formatCurrency(_vm.current_wallet_balance)))]), _vm._v(" "), (_vm.current_wallet_balance >= _vm.total_fee) ? _c('div', [(_vm.disable_btn_wallet) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("...processing, please wait")]) : _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.disable_btn_wallet,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.prepProcessPayment('wallet')
      }
    }
  }, [_vm._v("Pay with CNpay Rewards")])]) : _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Insufficient balance.")])]) : _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Please "), _c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setLogin()
      }
    }
  }, [_vm._v("Login")]), _vm._v(" to use your CNpay Rewards")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('h4', [_vm._v("Or")]), _vm._v(" "), _c('h5', [_vm._v("Process payment from your Bank Account")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.prepProcessPayment('gateway')
      }
    }
  }, [_vm._v("Pay with Debit Card/Bank")])])]) : _vm._e(), _vm._v(" "), (_vm.payment_message == '') ? _c('div', [(_vm.show_paga_service_details || _vm.show_airtime_form_details) ? _c('div', {
    staticStyle: {
      "padding": "2px 1em"
    }
  }, [(_vm.show_paga_service_details) ? _c('div', {
    staticClass: "row"
  }, [(_vm.setPayWithOption) ? _c('h5', [_c('b', [_vm._v("Purchase: ")]), _vm._v(_vm._s(_vm.paga_merchant.serviceToPay.serviceName))]) : _vm._e(), _vm._v(" "), (_vm.setPayWithOption) ? _c('h5', [_c('b', [_vm._v("Amount to pay: ₦" + _vm._s(_vm.formatCurrency(_vm.total_fee)))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.show_airtime_form_details) ? _c('div', {
    staticClass: "row"
  }, [(_vm.show_data_bundle) ? _c('h5', [_vm._v("Buy Data Bundle"), _c('br'), _c('b', [_vm._v(" ₦" + _vm._s(_vm.paga_bundle_request.servicePrice) + " - " + _vm._s(_vm.paga_merchant.paga_service_group_mobile_operatorName) + " - " + _vm._s(_vm.paga_bundle_request.serviceName))]), _c('br'), _vm._v("Phone Number: " + _vm._s(_vm.paga_bundle_request.phone_no)), _c('br'), _vm._v(" "), _c('b', [_vm._v("Total Amount to Pay: ₦" + _vm._s(_vm.formatCurrency(_vm.total_fee)))])]) : _c('h5', [_vm._v("Buy "), _c('b', [_vm._v(" ₦" + _vm._s(_vm.paga_airtime_request.amount) + " - " + _vm._s(_vm.paga_merchant.paga_service_group_mobile_operatorName))]), _vm._v(" Airtime"), _c('br'), _vm._v("Phone Number: " + _vm._s(_vm.paga_airtime_request.phone_no)), _c('br'), _vm._v(" "), _c('b', [_vm._v("Total Amount to Pay: ₦" + _vm._s(_vm.formatCurrency(_vm.total_fee)))])]), _vm._v(" "), _c('p'), _vm._v(" "), _c('form', {
    staticStyle: {
      "width": "100%"
    }
  }, [(!_vm.loggedIn) ? _c('div', {
    staticClass: "form-group"
  }, [(_vm.data_error_message != '') ? _c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("Please, fill in your details to process payment")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Full Name: "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customer.customerName),
      expression: "customer.customerName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Your Full Name"
    },
    domProps: {
      "value": (_vm.customer.customerName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.customer.customerName = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Email\r\n                                                "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customer.customerEmail),
      expression: "customer.customerEmail"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": "Enter Your Email Address"
    },
    domProps: {
      "value": (_vm.customer.customerEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.customer.customerEmail = $event.target.value
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.loggedIn) ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_c('b', [_vm._v("Name: " + _vm._s(_vm.customer.customerName))])]), _vm._v(" "), _c('label', [_c('b', [_vm._v("Email: " + _vm._s(_vm.customer.customerEmail))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "100%"
    }
  }, [(_vm.paga_merchant.paga_service_group_merchant_max_purchase_amount && (_vm.paga_merchant.paga_service_group_merchant_max_purchase_amount > 0)) ? _c('h4', {
    staticStyle: {
      "color": "#850606",
      "font-size": "14px"
    }
  }, [_vm._v("Maximum Purchase Amount: ₦" + _vm._s(_vm.formatCurrency_2(_vm.paga_merchant.paga_service_group_merchant_max_purchase_amount)))]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("\"The maximum purchase amount you can make per transaction is ₦" + _vm._s(_vm.formatCurrency_2(_vm.paga_merchant.paga_service_group_merchant_max_purchase_amount)) + ", at a go. To purchase more, reduce the subsequent purchase amount(s). For example, to buy ₦100,000 or more, start with ₦50,000, then ₦49,999, ₦49,998, and so on\".")]), _vm._v(" "), (_vm.show_paga_service_details) ? _c('form', {
    staticStyle: {
      "width": "100%"
    }
  }, [(!_vm.setPayWithOption) ? _c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("Please, fill in your details")]) : _vm._e(), _vm._v(" "), (!_vm.loggedIn && !_vm.setPayWithOption) ? _c('div', {
    staticClass: "form-group"
  }, [(_vm.data_error_message != '') ? _c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Full Name: "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customer.customerName),
      expression: "customer.customerName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Your Full Name"
    },
    domProps: {
      "value": (_vm.customer.customerName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.customer.customerName = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Email: "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customer.customerEmail),
      expression: "customer.customerEmail"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": "Your Email"
    },
    domProps: {
      "value": (_vm.customer.customerEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.customer.customerEmail = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.data_phone_error_message) ? _c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.data_phone_error_message))]) : _vm._e(), _vm._v(" "), _c('label', [_vm._v("Phone Number: "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customer.customerPhoneNumber),
      expression: "customer.customerPhoneNumber"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Your Phone Number"
    },
    domProps: {
      "value": (_vm.customer.customerPhoneNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.customer.customerPhoneNumber = $event.target.value
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.loggedIn) ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_c('b', [_vm._v("Name: " + _vm._s(_vm.customer.customerName))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.data_phone_error_message) ? _c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.data_phone_error_message))]) : _vm._e(), _vm._v(" "), _c('label', [_vm._v("Phone Number: "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customer.customerPhoneNumber),
      expression: "customer.customerPhoneNumber"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.customer.customerPhoneNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.customer.customerPhoneNumber = $event.target.value
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), (!_vm.setPayWithOption) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: " col-md-9",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('p', [_vm._v("Enter your "), _c('b', [_vm._v(_vm._s(_vm.paga_merchant.paga_service_group_merchant_displayName))]), _vm._v(" Number: \r\n                                            "), _c('span', [_c('a', {
    staticStyle: {
      "color": "inherit",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.show_set_service_saved_data = true;
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-clipboard",
    staticStyle: {
      "margin-left": "10px",
      "color": "#22baae",
      "font-size": "14px"
    }
  })]), _vm._v(" "), (_vm.show_set_service_saved_data) ? _c('a', {
    staticStyle: {
      "color": "inherit",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.show_set_service_saved_data = false;
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    staticStyle: {
      "margin-left": "10px",
      "color": "#ff0000",
      "font-size": "14px"
    }
  })]) : _vm._e()])])]), _vm._v(" "), (_vm.show_set_service_saved_data) ? _c('div', {
    staticStyle: {
      "margin-top": "-10px",
      "margin-left": "1em"
    }
  }, [_c('div', {
    staticStyle: {
      "clear": "both",
      "float": "left"
    }
  }, [(Object.keys(_vm.set_service_saved_data).length == 0) ? _c('p', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "12px"
    }
  }, [_vm._v("No saved data")]) : _vm._e(), _c('br'), _vm._v(" "), _vm._l((_vm.set_service_saved_data), function(no, nodex) {
    return _c('div', {
      staticClass: "btn-wrapper"
    }, [(no.merchant_number != '') ? _c('button', {
      staticClass: "btn btn2",
      on: {
        "click": function($event) {
          _vm.customer.customerCodeAtBiller = no.merchant_number;
          _vm.show_set_service_saved_data = false;
        }
      }
    }, [(no.merchant_number_name != '') ? _c('span', {
      staticStyle: {
        "font-size": "12x",
        "padding-bottom": "5px"
      }
    }, [_vm._v(_vm._s(no.merchant_number_name)), _c('br'), _c('br'), _c('br')]) : _vm._e(), _vm._v(_vm._s(no.merchant_number) + "\r\n                                                    ")]) : _vm._e(), _vm._v(" "), _c('a', {
      staticStyle: {
        "color": "inherit",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.deleteSaved(nodex)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-close",
      staticStyle: {
        "margin-left": "10px",
        "color": "inherit",
        "font-size": "14px"
      }
    }), _vm._v("  ")])])
  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both",
      "float": "left"
    }
  }, [_c('label', {
    staticClass: "en-00"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customer.customerCodeAtBiller),
      expression: "customer.customerCodeAtBiller"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.customer.customerCodeAtBiller)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.customer.customerCodeAtBiller = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('label', {
    staticClass: "pull-left",
    staticStyle: {
      "background": "#22baae",
      "padding": "0em 0.3em 0.2em 0.3em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.save_service_data_prompt),
      expression: "save_service_data_prompt"
    }],
    staticStyle: {
      "display": "block !important"
    },
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.save_service_data_prompt) ? _vm._i(_vm.save_service_data_prompt, null) > -1 : (_vm.save_service_data_prompt)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.save_service_data_prompt,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.save_service_data_prompt = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.save_service_data_prompt = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.save_service_data_prompt = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: " save-no",
    staticStyle: {
      "margin-top": "-1.5em"
    }
  }, [_vm._v("  Remember this number?")])])]), _vm._v(" "), (_vm.paga_merchant.serviceToPay && (_vm.paga_merchant.serviceToPay.servicePrice != 0)) ? _c('label', {
    key: _vm.serviceToPayComponentKey,
    staticClass: "col-md-9",
    staticStyle: {
      "padding": "0"
    }
  }, [_vm._v("Amount to Purchase: "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paga_merchant.serviceToPay.servicePrice),
      expression: "paga_merchant.serviceToPay.servicePrice"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "disabled",
      "type": "number",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.paga_merchant.serviceToPay.servicePrice)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.paga_merchant.serviceToPay.servicePrice = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.paga_merchant.serviceToPay && (_vm.paga_merchant.serviceToPay.servicePrice == 0)) ? _c('label', {
    key: _vm.serviceToPayComponentKey,
    staticClass: "col-md-9",
    staticStyle: {
      "padding": "0"
    }
  }, [_vm._v("Amount to Purchase: "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paga_merchant.serviceToPay.servicePrice),
      expression: "paga_merchant.serviceToPay.servicePrice"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.paga_merchant.serviceToPay.servicePrice)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.paga_merchant.serviceToPay.servicePrice = $event.target.value
      }
    }
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.data_error_message != '') ? _c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]) : _vm._e(), _vm._v(" "), (_vm.setPayWithOption) ? _c('div', {
    staticClass: "form-group"
  }, [_c('p', [_c('b', [_vm._v("Account Details: ")]), _vm._v(_vm._s(_vm.customer_received_details.customerName))]), _vm._v(" "), _c('p', [_c('b', [_vm._v(_vm._s(_vm.paga_merchant.paga_service_group_merchant_displayName) + " Number: ")]), _vm._v(_vm._s(_vm.customer.customerCodeAtBiller))])]) : _vm._e(), _vm._v(" "), (!_vm.setPayWithOption) ? _c('div', {
    staticClass: "form-group"
  }, [(_vm.disable_btn) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("...processing, please wait")]) : _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setPagaProcessPayment(_vm.paga_merchant.serviceToPay, _vm.serviceToPayFor)
      }
    }
  }, [_vm._v("Enter")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e(), _vm._v(" "), (_vm.setPayWithOption) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._m(10), _vm._v(" "), (_vm.loggedIn) ? _c('div', [_c('p', [_vm._v("Available Balance: ₦" + _vm._s(_vm.formatCurrency(_vm.current_wallet_balance)))]), _vm._v(" "), (_vm.current_wallet_balance >= _vm.total_fee) ? _c('div', [(_vm.disable_btn_wallet) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("...processing, please wait")]) : _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.disable_btn_wallet,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.prepPagaProcessPayment('wallet')
      }
    }
  }, [_vm._v("Pay with CNpay Rewards")])]) : _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Insufficient balance.")])]) : _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Please "), _c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setLogin()
      }
    }
  }, [_vm._v("Login")]), _vm._v(" to use your CNpay Rewards")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_vm._m(11), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.prepPagaProcessPayment('gateway')
      }
    }
  }, [_vm._v("Pay with Debit Card/Bank")])])]) : _vm._e()])]) : _vm._e()]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    staticStyle: {
      "margin-top": "2em"
    },
    attrs: {
      "id": "login",
      "tabindex": "-10",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "border-radius": "3px"
    }
  }, [_c('div', {
    staticClass: "modal-header login-modal-header",
    staticStyle: {
      "z-index": "3"
    }
  }, [_c('button', {
    staticClass: "pull-right btn btn-default",
    staticStyle: {
      "z-index": "9",
      "border-radius": "50%"
    },
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.closeModal('login')
      }
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('h1', [_vm._v("Can you keep a secret?")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.login_script) ? _c('div', [_c('p', {
    staticStyle: {
      "color": "#000000",
      "line-height": "2.0",
      "font-size": "16px"
    }
  }, [_vm._v("Cityneeds rewards customers who pay bills while logged-in.\r\n                                        Log in to your account, or register if you don't have an account, then proceed with your transaction, to receive instant cashback (your reward) in your CNpay account.\r\n                                ")])]) : _c('div', {
    staticClass: "page-title"
  }, [_c('h1', [_vm._v("Login")])]), _vm._v(" "), _c('form', {
    staticClass: "col-sm-8 col-sm-offset-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "login-form-email"
    }
  }, [_vm._v("E-mail or Phone Number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "name": "email",
      "id": "login-form-email"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "login-form-password"
    }
  }, [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "name": "password",
      "id": "login-form-password"
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.password = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.disable_btn_login) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("...processing, please wait")]) : _c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "disabled": _vm.disable_btn_login,
      "type": "button"
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("Login")]), _vm._v(" "), _vm._m(12)])])])])]), _vm._v(" "), _vm._m(13)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    staticStyle: {
      "margin-top": "24em"
    },
    attrs: {
      "id": "topup",
      "tabindex": "-10",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "border-radius": "3px"
    }
  }, [_c('button', {
    staticClass: "pull-right btn btn-default",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.closeModal('#topup')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [(_vm.wallet_payment_message != '') ? _c('div', [_c('h5', [_vm._v(_vm._s(_vm.wallet_payment_message))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "static/assets/img/loader.gif"
    }
  }), _vm._v(" "), _c('p', [_vm._v("..reloading wallet")])]) : _c('div', [(_vm.wallet_payment_error_message != '') ? _c('p', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "13px"
    }
  }, [_vm._v(_vm._s(_vm.wallet_payment_error_message))]) : _vm._e(), _vm._v(" "), (_vm.wallet_payment_calculated) ? _c('div', [_c('h5', [_vm._v("Amount: ₦" + _vm._s(_vm.formatCurrency(_vm.wallet_transaction.topay_amt)))]), _vm._v(" "), _c('h5', [_vm._v("Processing Fee: ₦" + _vm._s(_vm.formatCurrency(_vm.wallet_transaction.processing_fee)))]), _vm._v(" "), _c('h6', [_vm._v("Total: ₦" + _vm._s(_vm.formatCurrency(_vm.wallet_transaction.topay_amt + _vm.wallet_transaction.processing_fee)))]), _vm._v(" "), (_vm.disable_topup_wallet_btn) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("...processing, please wait")]) : _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.disable_topup_wallet_btn
    },
    on: {
      "click": _vm.makePayment
    }
  }, [_vm._v("Proceed")])]) : _c('div', [_c('h4', [_vm._v("How much would you like to top-up with?")]), _vm._v(" "), _c('blockquote', {
    staticStyle: {
      "font-size": "13px",
      "border": "thin #22baae 1px",
      "text-align": "left",
      "border-radius": "2px",
      "background": "rgba(238, 229, 106, 0.473)",
      "line-height": "1.8"
    }
  }, [_vm._v("\r\n                            CNpay is a Closed Wallet. Top-up into CNpay CANNOT BE TRANSFERRED NOR WITHDRAWN AS CASH; funds in CNpay can only be spent within Cityneeds' platform for the purchase of Cityneeds' products and services.\r\n                        ")]), _vm._v(" "), _c('label', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "11px"
    }
  }, [_vm._v("Top-up from ₦" + _vm._s(_vm.min_wallet_topup_amount) + " to ₦" + _vm._s(_vm.max_wallet_topup_amount))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.wallet_transaction.topay_amt),
      expression: "wallet_transaction.topay_amt"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "step": "0.01",
      "min": "100",
      "placeholder": "Enter Amount"
    },
    domProps: {
      "value": (_vm.wallet_transaction.topay_amt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.wallet_transaction.topay_amt = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.prepareWalletPayment
    }
  }, [_vm._v("Enter")])])])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    attrs: {
      "align": "center"
    }
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("Make Another Payment")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-title"
  }, [_c('h1', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("@"), _c('b', [_vm._v("cityneeds")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-cta"
  }, [_c('h3', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("What would you like to do with cityneeds today")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://cityneeds.ng/cnpros"
    }
  }, [_c('div', {
    staticClass: "col-md-3 card-blocks"
  }, [_c('p', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Find CNpros"), _c('br'), _c('i', [_vm._v("service workers")])])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://cityneeds.ng/cnsurveys"
    }
  }, [_c('div', {
    staticClass: "col-md-3 card-blocks"
  }, [_c('p', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Take a Survey"), _c('br'), _c('i', [_vm._v("CNsurveys")])])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://cityneeds.ng/forums"
    }
  }, [_c('div', {
    staticClass: "col-md-3 card-blocks"
  }, [_c('p', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("City Discussions"), _c('br'), _c('i', [_vm._v("join")])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://cityneeds.ng/businesses"
    }
  }, [_c('div', {
    staticClass: "col-md-3 card-blocks"
  }, [_c('p', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Search Businesses"), _c('br'), _c('i', [_vm._v("pre-verified")])])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://cnpay.cityneeds.ng"
    }
  }, [_c('div', {
    staticClass: "col-md-3 card-blocks"
  }, [_c('p', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Make Payments\r\n                                                "), _c('br'), _c('i', [_vm._v("with CNpay")])])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('div', {
    staticClass: "col-md-3 card-blocks"
  }, [_c('p', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Talk to a CNagent"), _c('br'), _vm._v(" "), _c('i', [_vm._v("call 08032258453")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('h1', {
    staticClass: "headings",
    attrs: {
      "align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#22baae"
    }
  }, [_vm._v("CN")]), _c('span', {
    staticStyle: {
      "color": "#e7c619"
    }
  }, [_vm._v("pay")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "16px",
      "margin-top": "-1em"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('b', [_vm._v("pay bills with a click 👌")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "pull-left col-md-2 col-xs-12",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('li', {
    staticClass: "line-list"
  }, [_c('img', {
    staticClass: "service-pay-logo-1",
    attrs: {
      "src": "static/assets/img/Remita-Logo.png"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-left",
    staticStyle: {
      "margin-top": "-2em",
      "margin-left": "1em"
    }
  }, [_c('h6', {
    staticClass: "headings"
  }, [_c('span', {
    staticStyle: {
      "color": "#22baae",
      "font-size": "14px"
    }
  }, [_vm._v("CN")]), _c('span', {
    staticStyle: {
      "color": "#e7c619",
      "font-size": "14px"
    }
  }, [_vm._v("pay")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "10px",
      "margin-top": "-1em"
    }
  }, [_c('b', [_vm._v("pay bills with a click 👌")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('div', {
    staticClass: "pull-left",
    staticStyle: {
      "margin-top": "-2em",
      "margin-left": "1em"
    }
  }, [_c('h6', {
    staticClass: "headings"
  }, [_c('span', {
    staticStyle: {
      "color": "#22baae",
      "font-size": "14px"
    }
  }, [_vm._v("CN")]), _c('span', {
    staticStyle: {
      "color": "#e7c619",
      "font-size": "14px"
    }
  }, [_vm._v("pay")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "10px",
      "margin-top": "-1em"
    }
  }, [_c('b', [_vm._v("pay bills with a click 👌")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_c('h5', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_c('u', [_vm._v("CNpay Payment Receipt")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("Transaction Status:")]), _vm._v(" "), _c('td', [_vm._v("Completed")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin-top": "1em",
      "margin-left": "1em",
      "font-size": "11px",
      "text-align": "left"
    }
  }, [_vm._v("Thank you for choosing CNpay."), _c('br'), _vm._v("\r\n                                Cityneeds™ ... meet everyday needs on the go!")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("1. ")]), _vm._v("Process Payment with your CNpay Rewards")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("2. ")]), _vm._v("Process Payment from your Bank Account")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-right m-t-xs text-sm pull-left"
  }, [_c('a', {
    attrs: {
      "href": "https://cityneeds.ng/login"
    }
  }, [_vm._v("Forgot Password?")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer login-modal-footer"
  }, [_c('p', {
    staticClass: "text-left m-t-xs text-sm",
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("Don't have an account?")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default btn-block m-t-xs",
    attrs: {
      "href": "https://cityneeds.ng/register"
    }
  }, [_vm._v("Register")])])
}]}

/***/ }),
/* 102 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrapper"
  }, [_c('second-header'), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "main-inner"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4 col-sm-offset-4"
  }, [(_vm.activation_error_message) ? _c('div', {
    staticClass: "page-header",
    staticStyle: {
      "padding": "1em",
      "border": "#22baae 3px solid"
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "login-form-email"
    }
  }, [_vm._v("E-mail or Phone Number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "name": "email",
      "id": "login-form-email"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "login-form-password"
    }
  }, [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "name": "password",
      "id": "login-form-password"
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("Login")]), _vm._v(" "), _c('br'), _c('br'), _c('br'), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('p', {
    staticClass: "text-left m-t-xs text-sm"
  }, [_vm._v("Don't have an account?")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-default btn-block m-t-xs",
    attrs: {
      "to": "register"
    }
  }, [_vm._v("Register")])], 1)])])])])])]), _vm._v(" "), _c('main-footer'), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    staticStyle: {
      "margin-top": "13em"
    },
    attrs: {
      "id": "forgot",
      "tabindex": "-10",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "border-radius": "3px"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.reset
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    staticStyle: {
      "font-weight": "600",
      "color": "#22baae"
    },
    attrs: {
      "id": "myModalLabel"
    }
  }, [_vm._v("Forgot your Password?")])]), _vm._v(" "), (_vm.forgot_processed) ? _c('div', [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.resetForgot
    }
  }, [_vm._v("Close")])])]) : _c('div', [_c('div', {
    staticClass: "modal-body"
  }, [_c('form', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Please enter your email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Your Email"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.email = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.forgotPassword
    }
  }, [_vm._v("Submit")])])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\r\n                                   Sorry!, your account could not be Activated, please "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Request")]), _vm._v(" \r\n                                   for another activation link, to be able to access relevant features.\r\n                                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-title"
  }, [_c('h1', [_vm._v("Login")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-right m-t-xs text-sm"
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "data-toggle": "modal",
      "data-target": "#forgot"
    }
  }, [_vm._v("Forgot Password?")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_vm._v("Some instruction have been sent to your email to help you Reset your password. Please check your mail")])])
}]}

/***/ }),
/* 103 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrapper"
  }, [_c('component-header'), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "outer-admin"
  }, [_c('div', {
    staticClass: "wrapper-admin"
  }, [_c('div', {
    staticClass: "content-admin"
  }, [_c('div', {
    staticClass: "content-admin-wrapper"
  }, [_c('div', {
    staticClass: "content-admin-main"
  }, [_c('div', {
    staticClass: "content-admin-main-inner"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-lg-12",
    staticStyle: {
      "margin-right": "5em"
    }
  }, [_c('div', {
    staticClass: "content fld-left"
  }, [_c('div', {}, [_c('div', {
    attrs: {
      "role": "",
      "id": "one"
    }
  }, [_c('div', {
    staticClass: "fld-lft-adjust"
  }, [_vm._m(0), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(1)]) : _c('div', [_c('div', {
    staticClass: "col-sm-4 col-md-offset-4 wallet-background p20 mb30"
  }, [_c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "pull-left",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('p', [_vm._v("Available Balance")]), _vm._v(" "), _c('h2', {
    staticStyle: {
      "color": "#f2f2f2"
    }
  }, [_vm._v("₦" + _vm._s(_vm.formatCurrency(_vm.current_wallet_balance)))])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  })]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.wallet_transactions.length != 0) ? _c('div', {
    attrs: {
      "id": "wallet-transactions"
    }
  }, [_c('div', {
    staticClass: " p20 mb30 hidden-sm hidden-xs"
  }, [_c('div', {
    staticClass: "p20 col-md-8 col-md-offset-2",
    staticStyle: {
      "overflow-x": "auto",
      "background": "#ffffff"
    }
  }, [_vm._m(2), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_vm._m(3), _vm._v(" "), _vm._l((_vm.wallet_transactions), function(txn) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(txn.wallet_transaction_reg_date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(txn.wallet_transaction_ref))]), _vm._v(" "), _c('td', [_c('span', {
      staticStyle: {
        "padding": "5px",
        "color": "#ffffff"
      },
      style: ({
        backgroundColor: txn.wallet_transaction_type_color
      })
    }, [_vm._v(_vm._s(txn.wallet_transaction_type))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatCurrency(txn.wallet_transaction_amount)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatCurrency(txn.wallet_transaction_current_balance)))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-default btn-sm",
      attrs: {
        "type": "button",
        "data-toggle": "modal",
        "data-target": "#viewWalletTransaction"
      },
      on: {
        "click": function($event) {
          _vm.setWalletTransaction(txn)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-info-circle"
    }), _vm._v(" More Details")])])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "background-white p20 mb30 hidden-md hidden-lg"
  }, [_vm._m(4), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, _vm._l((_vm.wallet_transactions), function(txn) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "padding": "1em"
      }
    }, [_c('p', [_c('b', [_vm._v("Date: ")]), _vm._v(_vm._s(txn.wallet_transaction_reg_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("REF: ")]), _vm._v(_vm._s(txn.wallet_transaction_ref))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Transaction: ")]), _c('span', {
      staticStyle: {
        "padding": "5px",
        "color": "#ffffff"
      },
      style: ({
        backgroundColor: txn.wallet_transaction_type_color
      })
    }, [_vm._v(_vm._s(txn.wallet_transaction_type))])]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Amount: ")]), _vm._v("₦" + _vm._s(_vm.formatCurrency(txn.wallet_transaction_amount)))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Current Balance: ")]), _vm._v("₦" + _vm._s(_vm.formatCurrency(txn.wallet_transaction_current_balance)))]), _vm._v(" "), _c('p', [_c('button', {
      staticClass: "pull-left btn btn-default btn-sm",
      attrs: {
        "type": "button",
        "data-toggle": "modal",
        "data-target": "#viewWalletTransaction"
      },
      on: {
        "click": function($event) {
          _vm.setWalletTransaction(txn)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-info-circle"
    }), _vm._v(" More Details")])])])])
  }))])]) : _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("You don't have any Rewards Transactions yet")])])])])])])])])])])])]), _vm._v(" "), _c('component-footer')], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    staticStyle: {
      "margin-top": "12em"
    },
    attrs: {
      "id": "topup",
      "tabindex": "-10",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "border-radius": "3px"
    }
  }, [_c('button', {
    staticClass: "pull-right btn btn-default",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.closeModal('#topup')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [(_vm.wallet_payment_message != '') ? _c('div', [_c('h5', [_vm._v(_vm._s(_vm.wallet_payment_message))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "static/assets/img/loader.gif"
    }
  }), _vm._v(" "), _c('p', [_vm._v("..reloading wallet")])]) : _c('div', [(_vm.wallet_payment_error_message != '') ? _c('p', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "13px"
    }
  }, [_vm._v(_vm._s(_vm.wallet_payment_error_message))]) : _vm._e(), _vm._v(" "), (_vm.wallet_payment_calculated) ? _c('div', [_c('h5', [_vm._v("Amount: ₦" + _vm._s(_vm.formatCurrency(_vm.wallet_transaction.topay_amt)))]), _vm._v(" "), _c('h5', [_vm._v("Processing Fee: ₦" + _vm._s(_vm.formatCurrency(_vm.wallet_transaction.processing_fee)))]), _vm._v(" "), _c('h6', [_vm._v("Total: ₦" + _vm._s(_vm.formatCurrency(_vm.wallet_transaction.topay_amt + _vm.wallet_transaction.processing_fee)))]), _vm._v(" "), (_vm.disable_btn) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("...processing, please wait")]) : _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.disable_btn
    },
    on: {
      "click": _vm.makePayment
    }
  }, [_vm._v("Proceed")])]) : _c('div', [_c('h4', [_vm._v("How much would you like to top-up with?")]), _vm._v(" "), _c('blockquote', {
    staticStyle: {
      "font-size": "13px",
      "border": "thin #22baae 1px",
      "text-align": "left",
      "border-radius": "2px",
      "background": "rgba(238, 229, 106, 0.473)",
      "line-height": "1.8"
    }
  }, [_vm._v("\r\n                                CNpay is a Closed Wallet. Top-up into CNpay CANNOT BE TRANSFERRED NOR WITHDRAWN AS CASH; funds in CNpay can only be spent within Cityneeds' platform for the purchase of Cityneeds' products and services.\r\n                            ")]), _vm._v(" "), _c('label', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "11px"
    }
  }, [_vm._v("Top-up from ₦" + _vm._s(_vm.min_wallet_topup_amount) + " to ₦" + _vm._s(_vm.max_wallet_topup_amount))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.wallet_transaction.topay_amt),
      expression: "wallet_transaction.topay_amt"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "Enter Amount"
    },
    domProps: {
      "value": (_vm.wallet_transaction.topay_amt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.wallet_transaction.topay_amt = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.prepareWalletPayment
    }
  }, [_vm._v("Enter")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    staticStyle: {
      "margin-top": "7em"
    },
    attrs: {
      "id": "viewWalletTransaction",
      "tabindex": "-10",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "border-radius": "3px"
    }
  }, [_c('button', {
    staticClass: "pull-right btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.closeModal('#viewWalletTransaction')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', [_c('h5', [_vm._v("Transaction Details")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Date: ")]), _vm._v(_vm._s(_vm.wallet_transaction.wallet_transaction_reg_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("REF: ")]), _vm._v(_vm._s(_vm.wallet_transaction.wallet_transaction_ref))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Transaction: ")]), _c('span', {
    staticStyle: {
      "padding": "5px",
      "color": "#ffffff"
    },
    style: ({
      backgroundColor: _vm.wallet_transaction.wallet_transaction_type_color
    })
  }, [_vm._v(_vm._s(_vm.wallet_transaction.wallet_transaction_type))])]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Amount: ")]), _vm._v("₦" + _vm._s(_vm.formatCurrency(_vm.wallet_transaction.wallet_transaction_amount)))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Current Balance: ")]), _vm._v("₦" + _vm._s(_vm.formatCurrency(_vm.wallet_transaction.wallet_transaction_current_balance)))]), _vm._v(" "), (_vm.wallet_transaction.wallet_transaction_service_ref != '') ? _c('div', [(_vm.wallet_transaction.wallet_transaction_service != 'error') ? _c('p', [_c('b', [_vm._v(_vm._s(_vm.wallet_transaction.wallet_transaction_type) + " Service: ")]), _vm._v(_vm._s(_vm.wallet_transaction.wallet_transaction_service))]) : _vm._e(), _vm._v(" "), (_vm.wallet_transaction.wallet_transaction_service_transaction_name != 'error') ? _c('p', [_c('b', [_vm._v(_vm._s(_vm.wallet_transaction.wallet_transaction_type) + " Service Details: ")]), _vm._v(_vm._s(_vm.wallet_transaction.wallet_transaction_service_transaction_name))]) : _vm._e(), _vm._v(" "), (_vm.wallet_transaction.wallet_transaction_service_transaction_token != '') ? _c('p', [_c('b', [_vm._v(_vm._s(_vm.wallet_transaction.wallet_transaction_service_transaction_token))])]) : _vm._e(), _vm._v(" "), _c('p', [_c('b', [_vm._v("Service REF: ")]), _vm._v(_vm._s(_vm.wallet_transaction.wallet_transaction_service_ref))])]) : _vm._e(), _vm._v(" "), (_vm.wallet_transaction.wallet_transaction_action_by_admin == 1) ? _c('div', [_vm._m(5), _vm._v(" "), _c('p', [_c('b', [_vm._v("Details: ")]), _vm._v(_vm._s(_vm.wallet_transaction.wallet_transaction_action_by_admin_descr))])]) : _vm._e()])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-title",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('h1', [_vm._v("My Rewards")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 col-md-offset-5 col-sm-12",
    staticStyle: {
      "padding": "5em"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/assets/img/loader.gif"
    }
  }), _vm._v(" "), _c('p', [_vm._v("loading...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_c('u', [_vm._v("Transactions")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("~"), _c('span', {
    staticStyle: {
      "font-size": "11px"
    }
  }, [_vm._v("Date")])]), _vm._v(" "), _c('th', [_vm._v("REF")]), _vm._v(" "), _c('th', [_vm._v("Transaction")]), _vm._v(" "), _c('th', [_vm._v("Amount(₦)")]), _vm._v(" "), _c('th', [_vm._v("Current Balance(₦)")]), _vm._v(" "), _c('th', [_vm._v(" --- ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_c('u', [_vm._v("Transactions")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Topup By Admin: ")]), _vm._v("Yes")])
}]}

/***/ }),
/* 104 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "__cov-progress",
    style: (_vm.style)
  })
},staticRenderFns: []}

/***/ }),
/* 105 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-5 col-lg-4"
  }, [_c('div', {
    staticClass: "sidebar"
  }, [_c('div', {
    staticClass: "widget"
  }, [_c('h2', {
    staticClass: "widgettitle"
  }, [_vm._v("Trending Forum")]), _vm._v(" "), _c('div', _vm._l((_vm.forums), function(forum, index) {
    return _c('ul', {
      staticClass: "list-group"
    }, [_c('a', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: ((index) < 6),
        expression: "(index) < 6"
      }],
      attrs: {
        "href": 'forum?topic=' + forum.forum_topic_url
      }
    }, [_c('li', {
      staticClass: "list-group-item"
    }, [(forum.forum_comments.length) ? _c('span', {
      staticClass: "badge",
      staticStyle: {
        "background-color": "#22baae"
      }
    }, [_vm._v(_vm._s(forum.forum_comments.length))]) : _vm._e(), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#333"
      }
    }, [_vm._v(_vm._s(forum.forum_topic))])])])])
  }))]), _vm._v(" "), (_vm.pageNotSurvey) ? _c('div', {
    staticClass: "widget"
  }, [_c('h2', {
    staticClass: "widgettitle"
  }, [_vm._v("Trending Live Poll")]), _vm._v(" "), _vm._l((_vm.surveys), function(survey, index) {
    return _c('div', [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: ((index) < 1),
        expression: "(index) < 1"
      }],
      staticClass: "panel panel-poll"
    }, [_c('div', {
      staticClass: "panel-heading"
    }, [_c('b', [_c('a', {
      attrs: {
        "href": 'cnsurvey?title=' + survey.cnsurvey_title_url
      }
    }, [_vm._v(_vm._s(survey.cnsurvey_title))])])]), _vm._v(" "), _c('div', {
      staticClass: "panel-body"
    }, _vm._l((survey.cnsurveys_questions), function(svq, index2) {
      return _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (index2 === survey.cnsurvey_question_index),
          expression: "index2 === survey.cnsurvey_question_index"
        }]
      }, [_c('p', [_c('b', [_vm._v(_vm._s(svq.cnsurvey_question))])]), _vm._v(" "), _c('a', {
        attrs: {
          "href": 'cnsurvey?title=' + survey.cnsurvey_title_url
        }
      }, _vm._l((svq.cnsurveys_option), function(opt) {
        return _c('div', {
          staticClass: "options"
        }, [_c('div', [_c('div', {
          staticClass: "radio"
        }, [_c('input', {
          attrs: {
            "id": "op",
            "type": "radio"
          },
          domProps: {
            "value": opt.cnsurvey_option_id
          }
        }), _c('label', [_vm._v(_vm._s(opt.cnsurvey_option_option))])])])])
      })), _vm._v(" "), _c('span', {
        staticClass: "pull-left"
      }, [_c('ul', {
        staticClass: "social-links nav nav-pills"
      }, [_c('li', [_c('a', {
        attrs: {
          "href": 'https://twitter.com/share?url=' + _vm.siteUrl + survey.cnsurvey_title_url + '&text=' + survey.cnsurvey_title + '&hashtags=cityneeds,cnsurveys',
          "target": "_blank"
        }
      }, [_c('i', {
        staticClass: "fa fa-twitter"
      })])]), _vm._v(" "), _c('li', [_c('a', {
        attrs: {
          "href": 'http://www.facebook.com/sharer.php?u=' + _vm.siteUrl + survey.cnsurvey_title_url,
          "target": "_blank"
        }
      }, [_c('i', {
        staticClass: "fa fa-facebook"
      })])]), _vm._v(" "), _c('li', [_c('a', {
        staticClass: "linky",
        staticStyle: {
          "cursor": "pointer"
        },
        on: {
          "click": function($event) {
            _vm.copyLink(survey)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-link"
      }), _vm._v("Copy Link")])])])]), _vm._v(" "), _c('div', {
        staticStyle: {
          "margin-top": "1em"
        }
      }, [_c('br'), _c('br'), (survey.cnsurvey_business != 0) ? _c('p', {
        staticStyle: {
          "font-size": "11px"
        }
      }, [_vm._v("Survey by: " + _vm._s(survey.cnsurvey_business_name))]) : _vm._e()])])
    }))])])
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "widget hidden-xs"
  }, [_c('h2', {
    staticClass: "widgettitle"
  }, [_vm._v("Search Listings")]), _vm._v(" "), _c('div', {
    staticClass: "detail-enquire-form background-white p20"
  }, [_c('form', [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.parent),
      expression: "search.parent"
    }],
    staticClass: "search-select form-control",
    attrs: {
      "title": "Location"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.search.parent = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.prep_sub_categories(_vm.search.parent)
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("What do you want to find today?")]), _vm._v(" "), _vm._l((_vm.cnproParentCategories), function(cc) {
    return _c('option', {
      domProps: {
        "value": cc.cnpro_parent_category_id
      }
    }, [_vm._v(_vm._s(cc.cnpro_parent_category_name))])
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "business-search"
    }
  }, [_vm._v("Businesses")])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.search.type != 'business-search') ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.area),
      expression: "search.area"
    }],
    staticClass: "search-select form-control",
    attrs: {
      "title": "Location"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.search.area = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.prep_search(_vm.search.area)
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Which of these areas suites best")]), _vm._v(" "), _vm._l((_vm.sub_categories), function(cc) {
    return _c('option', {
      domProps: {
        "value": cc.cnpro_category_name
      }
    }, [_vm._v(_vm._s(cc.cnpro_category_name))])
  })], 2) : _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.area),
      expression: "search.area"
    }],
    staticClass: "search-select form-control",
    attrs: {
      "title": "Location"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.search.area = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.prep_search(_vm.search.area)
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Which of these areas suites best")]), _vm._v(" "), _vm._l((_vm.sub_categories), function(cc) {
    return _c('option', {
      domProps: {
        "value": cc.business_category_name
      }
    }, [_vm._v(_vm._s(cc.business_category_name))])
  })], 2)]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.doSearch
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search\r\n                                            ")])])])])])])
},staticRenderFns: []}

/***/ }),
/* 106 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('div', {}, [_c('div', {
    staticClass: "footer-top"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('a', {
    attrs: {
      "href": _vm.mainSiteUrl + '/cnpros'
    }
  }, [_c('h3', {
    staticStyle: {
      "font-size": "1em",
      "color": "#cceded"
    }
  }, [_vm._v("CNpro CATEGORIES")])]), _vm._v(" "), _c('p', [_c('a', {
    staticStyle: {
      "color": "inherit",
      "cursor": "pointer"
    },
    attrs: {
      "href": _vm.mainSiteUrl + '/cnpro-search?context=Plumbing'
    }
  }, [_vm._v("Plumbing")])]), _vm._v(" "), _c('p', [_c('a', {
    staticStyle: {
      "color": "inherit",
      "cursor": "pointer"
    },
    attrs: {
      "href": _vm.mainSiteUrl + '/cnpro-search?context=Roofing'
    }
  }, [_vm._v("Roofing")])]), _vm._v(" "), _c('p', [_c('a', {
    staticStyle: {
      "color": "inherit",
      "cursor": "pointer"
    },
    attrs: {
      "href": _vm.mainSiteUrl + '/cnpro-search?context=Tiling'
    }
  }, [_vm._v("Tiling")])]), _vm._v(" "), _c('p', [_c('a', {
    staticStyle: {
      "color": "inherit",
      "cursor": "pointer"
    },
    attrs: {
      "href": _vm.mainSiteUrl + '/cnpro-search?context=Airconditioner'
    }
  }, [_vm._v("Airconditioning")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('a', {
    attrs: {
      "href": _vm.mainSiteUrl + '/businesses'
    }
  }, [_c('h3', {
    staticStyle: {
      "font-size": "1em",
      "color": "#cceded"
    }
  }, [_vm._v("BUSINESS CATEGORIES")])]), _vm._v(" "), _c('p', [_c('a', {
    staticStyle: {
      "color": "inherit",
      "cursor": "pointer"
    },
    attrs: {
      "href": _vm.mainSiteUrl + '/business-search?context=Food Beverage'
    }
  }, [_vm._v("Food & Beverage")])]), _vm._v(" "), _c('p', [_c('a', {
    staticStyle: {
      "color": "inherit",
      "cursor": "pointer"
    },
    attrs: {
      "href": _vm.mainSiteUrl + '/business-search?context=Hotels'
    }
  }, [_vm._v("Hotels")])]), _vm._v(" "), _c('p', [_c('a', {
    staticStyle: {
      "color": "inherit",
      "cursor": "pointer"
    },
    attrs: {
      "href": _vm.mainSiteUrl + '/business-search?context=Home Services'
    }
  }, [_vm._v("Home Services")])]), _vm._v(" "), _c('p', [_c('a', {
    staticStyle: {
      "color": "inherit",
      "cursor": "pointer"
    },
    attrs: {
      "href": _vm.mainSiteUrl + '/business-search?context=Event Planning'
    }
  }, [_vm._v("Event Planning")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('a', {
    attrs: {
      "href": _vm.mainSiteUrl + '/about'
    }
  }, [_c('h3', {
    staticStyle: {
      "font-size": "1em",
      "color": "#cceded"
    }
  }, [_vm._v("ABOUT")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.mainSiteUrl + '/about'
    }
  }, [_vm._v("About Us")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.mainSiteUrl + '/how-it-works'
    }
  }, [_vm._v("How CNpro Works")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.mainSiteUrl + '/pricing'
    }
  }, [_vm._v("CNpro Plans & Pricing")])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.mainSiteUrl + '/terms'
    }
  }, [_vm._v("Terms & Conditions")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.mainSiteUrl + '/policy'
    }
  }, [_vm._v("Privacy & Policy")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('a', {
    attrs: {
      "href": _vm.mainSiteUrl + '/forums'
    }
  }, [_c('h3', {
    staticStyle: {
      "font-size": "1em",
      "color": "#cceded"
    }
  }, [_vm._v("COMMUNITY")])]), _vm._v(" "), _c('p', [_c('a', {
    staticStyle: {
      "color": "inherit"
    },
    attrs: {
      "href": _vm.mainSiteUrl + '/forums'
    }
  }, [_vm._v("Forum")]), _vm._v("   "), _c('a', {
    staticStyle: {
      "color": "inherit"
    },
    attrs: {
      "href": "https://www.blog.cityneeds.ng",
      "target": "_blank"
    }
  }, [_vm._v("Blog")])]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "footer-bottom"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "footer-bottom-left"
  }, [_vm._v("\r\n                    © " + _vm._s(_vm.this_year) + " All rights reserved. cityneeds.\r\n                ")]), _vm._v(" "), _vm._m(3)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://cnpay.cityneeds.ng"
    }
  }, [_vm._v("Pay Bills, Buy Airtime")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "social-links nav nav-pills"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "https://twitter.com/cityneedsng"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://web.facebook.com/cityneeds/"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": " https://www.instagram.com/cityneeds/"
    }
  }, [_c('i', {
    staticClass: "fa fa-instagram"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://linkedin.com/in/cityneeds-technologies-00b090138"
    }
  }, [_c('i', {
    staticClass: "fa fa-linkedin"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "social-links nav nav-pills"
  }, [_c('li', {
    staticStyle: {
      "margin-bottom": "1em"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-phone"
  }), _vm._v("    08032258453")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-map-marker"
  }), _vm._v("   Visit Us:"), _c('br'), _vm._v("\r\n                                    P53A, Emirate Lane, Sunnyvale Estate,\r\n                                    Abuja, Nigeria.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-bottom-right"
  }, [_c('ul', {
    staticClass: "nav nav-pills"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "https://cityneeds.ng/about"
    }
  }, [_vm._v("About Us")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://cityneeds.ng/terms"
    }
  }, [_vm._v("Terms & Conditions")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://cityneeds.ng/policy"
    }
  }, [_vm._v("Privacy & Policy")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("08032258453")])])])])
}]}

/***/ }),
/* 107 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "document-title"
  }, [_c('form', {
    staticClass: "filter"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.parent),
      expression: "search.parent"
    }],
    staticClass: "search-select form-control",
    attrs: {
      "title": "Location"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.search.parent = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.prep_sub_categories(_vm.search.parent)
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("What do you want to find today?")]), _vm._v(" "), _vm._l((_vm.cnproParentCategories), function(cc) {
    return _c('option', {
      key: cc.cnpro_parent_category_id,
      domProps: {
        "value": cc.cnpro_parent_category_id
      }
    }, [_vm._v(_vm._s(cc.cnpro_parent_category_name))])
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "business-search"
    }
  }, [_vm._v("Businesses")])], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [(_vm.search.type != 'business-search') ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.area),
      expression: "search.area"
    }],
    staticClass: "search-select form-control",
    attrs: {
      "title": "Location"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.search.area = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.prep_search(_vm.search.area)
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Which of these services in particular")]), _vm._v(" "), _vm._l((_vm.sub_categories), function(cc) {
    return _c('option', {
      key: cc.cnnpro_category_name,
      domProps: {
        "value": cc.cnpro_category_name
      }
    }, [_vm._v(_vm._s(cc.cnpro_category_name))])
  })], 2) : _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.area),
      expression: "search.area"
    }],
    staticClass: "search-select form-control",
    attrs: {
      "title": "Location"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.search.area = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.prep_search(_vm.search.area)
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Which of these services in particular")]), _vm._v(" "), _vm._l((_vm.sub_categories), function(cc) {
    return _c('option', {
      key: cc.cnnpro_category_name,
      domProps: {
        "value": cc.business_category_name
      }
    }, [_vm._v(_vm._s(cc.business_category_name))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.doSearch
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])])])
},staticRenderFns: []}

/***/ }),
/* 108 */,
/* 109 */,
/* 110 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[52]);


// WEBPACK FOOTER //
// static/js/app.62aa37f6b613703a88bb.js